const SERVICES = [
  {
    Name: "VT Weld",
    Description: "Visual Test on Welding",
    Updated_at: "07/Oct/24 12:00 AM (ago)"
  },
  {
    Name: "VT Cast",
    Description: "Visual Test on Castings",
    Updated_at: "07/Oct/24 12:00 AM (ago)"
  },
  {
    Name: "UTG",
    Description: "Ultrasonic Thickness Gauge",
    Updated_at: "07/Oct/24 12:00 AM (ago)"
  },
  {
    Name: "UT Weld",
    Description: "Ultrasonic Test on Welding",
    Updated_at: "07/Oct/24 12:00 AM (ago)"
  },
  {
    Name: "UT Plate / Forging",
    Description: "Ultrasonic Test on Plate / Forging",
    Updated_at: "07/Oct/24 12:00 AM (ago)"
  },
  {
    Name: "PT Visible",
    Description: "Penetrant Test - Visible",
    Updated_at: "07/Oct/24 12:00 AM (ago)"
  },
  {
    Name: "PT Fluorescent",
    Description: "Penetrant Test - Fluorescent",
    Updated_at: "07/Oct/24 12:00 AM (ago)"
  },
  {
    Name: "MT Yoke",
    Description: "Magnetic Particle Test - Yoke Method",
    Updated_at: "07/Oct/24 12:00 AM (ago)"
  },
  {
    Name: "MT Bench Type",
    Description: "Magnetic Particle Test - Bench Type",
    Updated_at: "07/Oct/24 12:00 AM (ago)"
  },
  {
    Name: "RT Cast",
    Description: "Radiographic Test on Castings",
    Updated_at: "18/Mar/26 12:00 AM (ago)"
  },
  {
    Name: "RT Weld",
    Description: "Radiographic Test on Welding",
    Updated_at: "18/Mar/26 12:00 AM (ago)"
  }
];

const STAGE_SURFACE_CONDITIONS = [
  {
    id: 71,
    Attribute: "Stage",
    Value: "After Bending",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 72,
    Attribute: "Stage",
    Value: "After Casting",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 73,
    Attribute: "Stage",
    Value: "After Casting and Heat Treatment",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 74,
    Attribute: "Stage",
    Value: "After Casting and Machining",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 75,
    Attribute: "Stage",
    Value: "After Final Machining",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 76,
    Attribute: "Stage",
    Value: "After Final Machining and Drilling",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 77,
    Attribute: "Stage",
    Value: "After Forging",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 78,
    Attribute: "Stage",
    Value: "After Forging and Machining",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 79,
    Attribute: "Stage",
    Value: "After Forging",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 80,
    Attribute: "Stage",
    Value: "After Forming",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 81,
    Attribute: "Stage",
    Value: "After Forming and Grinding",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 82,
    Attribute: "Stage",
    Value: "After Hard facing",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 83,
    Attribute: "Stage",
    Value: "After Heat Treatment",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 84,
    Attribute: "Stage",
    Value: "After Machining",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 85,
    Attribute: "Stage",
    Value: "After Machining and Electroplating",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 86,
    Attribute: "Stage",
    Value: "After Normalizing",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 87,
    Attribute: "Stage",
    Value: "After Proof Machining",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 88,
    Attribute: "Stage",
    Value: "After Rolling",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 89,
    Attribute: "Stage",
    Value: "After Solution Annealing",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 90,
    Attribute: "Stage",
    Value: "After Welding",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 91,
    Attribute: "Stage",
    Value: "After Welding and Before Heat Treatment",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 92,
    Attribute: "Stage",
    Value: "After Welding and Heat Treatment",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 93,
    Attribute: "Stage",
    Value: "Before Heat Treatment",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 94,
    Attribute: "Stage",
    Value: "During In-Service",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 95,
    Attribute: "Lighting Equipment",
    Value: "UV Light",
    Status: "Active",
    Description: "Used in PT-V, PT-F, MT-B and MT-Y templates"
  },
  {
    id: 96,
    Attribute: "Lighting Equipment",
    Value: "LED Torch",
    Status: "Active",
    Description: "Used in PT-V, PT-F, MT-B and MT-Y templates"
  },
  {
    id: 97,
    Attribute: "Lighting Equipment",
    Value: "White Light",
    Status: "Active",
    Description: "Used in PT-V, PT-F, MT-B and MT-Y templates"
  },
  {
    id: 98,
    Attribute: "Surface Condition",
    Value: "As Bent",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 99,
    Attribute: "Surface Condition",
    Value: "As Cast",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 100,
    Attribute: "Surface Condition",
    Value: "As Cast and Machined",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 101,
    Attribute: "Surface Condition",
    Value: "As Forged",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 102,
    Attribute: "Surface Condition",
    Value: "As Formed",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 103,
    Attribute: "Surface Condition",
    Value: "As Formed and Ground",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 104,
    Attribute: "Surface Condition",
    Value: "As Ground",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 105,
    Attribute: "Surface Condition",
    Value: "As Heat Treated",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 106,
    Attribute: "Surface Condition",
    Value: "As Machined",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 107,
    Attribute: "Surface Condition",
    Value: "As Normalized",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 108,
    Attribute: "Surface Condition",
    Value: "As Polished",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 109,
    Attribute: "Surface Condition",
    Value: "As Proof Machined",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 110,
    Attribute: "Surface Condition",
    Value: "As Rolled",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 111,
    Attribute: "Surface Condition",
    Value: "As Welded",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 112,
    Attribute: "Surface Condition",
    Value: "Smooth",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 113,
    Attribute: "Penetrant Application",
    Value: "By Brushing",
    Status: "Active",
    Description: "Used in PT-V and PT-F templates"
  },
  {
    id: 114,
    Attribute: "Penetrant Application",
    Value: "By Spraying",
    Status: "Active",
    Description: "Used in PT-V and PT-F templates"
  },
  {
    id: 115,
    Attribute: "Penetrant Application",
    Value: "By Dipping",
    Status: "Active",
    Description: "Used in PT-V and PT-F templates"
  },
  {
    id: 116,
    Attribute: "Developer Application",
    Value: "By Brushing",
    Status: "Active",
    Description: "Used in PT-V and PT-F templates"
  },
  {
    id: 117,
    Attribute: "Developer Application",
    Value: "By Spraying",
    Status: "Active",
    Description: "Used in PT-V and PT-F templates"
  },
  {
    id: 118,
    Attribute: "Bath Medium",
    Value: "By Spraying",
    Status: "Active",
    Description: "Used in MT Bench Type"
  },
  {
    id: 119,
    Attribute: "Type of current and Pole Spacing",
    Value: "AC Type 4 to 6 inches",
    Status: "Active",
    Description: "Used in MT Yoke"
  },
  {
    id: 120,
    Attribute: "Type of current and Pole Spacing",
    Value: "DC Type 2 to 4 inches",
    Status: "Active",
    Description: "Used in MT Yoke"
  },
  {
    id: 121,
    Attribute: "Type of current and Pole Spacing",
    Value: "DC Type 4 to 6 inches",
    Status: "Active",
    Description: "Used in MT Yoke"
  },
  {
    id: 122,
    Attribute: "Type of current and Pole Spacing",
    Value: "AC Type (At maximum Pole Spacing)",
    Status: "Active",
    Description: "Used in MT Yoke"
  },
  {
    id: 123,
    Attribute: "Type of current and Pole Spacing",
    Value: "DC Type (At maximum Pole Spacing)",
    Status: "Active",
    Description: "Used in MT Yoke"
  },
  {
    id: 124,
    Attribute: "Magnetisation Method",
    Value: "Longitudinal Magnetisation in 2 directions",
    Status: "Active",
    Description: "Used in MT-B and MT-Y templates"
  },
  {
    id: 125,
    Attribute: "Magnetisation Method",
    Value: "Longitudinal Magnetisation",
    Status: "Active",
    Description: "Used in MT-B and MT-Y templates"
  },
  {
    id: 126,
    Attribute: "Magnetisation Method",
    Value: "Longitudinal Magnetisation + Circular",
    Status: "Active",
    Description: "Used in MT-B and MT-Y templates"
  },
  {
    id: 127,
    Attribute: "Magnetisation Method",
    Value: "Circular Magnetisation",
    Status: "Active",
    Description: "Used in MT-B and MT-Y templates"
  },
  {
    id: 128,
    Attribute: "Magnetisation Method",
    Value: "Circular Magnetisation 2 Directions",
    Status: "Active",
    Description: "Used in MT-B and MT-Y templates"
  },
  {
    id: 129,
    Attribute: "Field Adequacy",
    Value: "Pie Gauge and shim (230)",
    Status: "Active",
    Description: "Used in MT-B and MT-Y templates"
  },
  {
    id: 130,
    Attribute: "Field Adequacy",
    Value: "Shim",
    Status: "Active",
    Description: "Used in MT-B and MT-Y templates"
  },
  {
    id: 131,
    Attribute: "Field Adequacy",
    Value: "Pie Gauge",
    Status: "Active",
    Description: "Used in MT-B and MT-Y templates"
  },
  {
    id: 132,
    Attribute: "Field Adequacy",
    Value: "Shim and known Discontinuity Sample",
    Status: "Active",
    Description: "Used in MT-B and MT-Y templates"
  },
  {
    id: 133,
    Attribute: "Field Adequacy",
    Value: "Not Applicable for Yoke",
    Status: "Active",
    Description: "Used in MT-B and MT-Y templates"
  },
  {
    id: 134,
    Attribute: "Current Type",
    Value: "HWDC",
    Status: "Active",
    Description: "Used in MT Bench Type"
  },
  {
    id: 135,
    Attribute: "Current Type",
    Value: "DC",
    Status: "Active",
    Description: "Used in MT Bench Type"
  },
  {
    id: 136,
    Attribute: "Current Type",
    Value: "AC",
    Status: "Active",
    Description: "Used in MT Bench Type"
  },
  {
    id: 140,
    Attribute: "Outcome",
    Value: "Accept",
    Status: "Active",
    Description: "Used in Observation Report"
  },
  {
    id: 141,
    Attribute: "Outcome",
    Value: "Reject",
    Status: "Active",
    Description: "Used in Observation Report"
  },
  {
    id: 142,
    Attribute: "Sample",
    Value: "Item/Part/Component",
    Status: "Active",
    Description: "Used in Observation Report"
  },
  {
    id: 218,
    Attribute: "Stage",
    Value: "After Hardfacing and Machining",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 219,
    Attribute: "Stage",
    Value: "After Forging, Heat Treatment, and Machining",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 220,
    Attribute: "Stage",
    Value: "After Rolling, Heat Treatment, and Machining",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 289,
    Attribute: "Surface Condition",
    Value: "As Welded and As Ground",
    Status: "Active",
    Description: "Used in All Templet"
  },
  {
    id: 290,
    Attribute: "Lighting Equipment",
    Value: "15 w White Led Bulb",
    Status: "Active",
    Description: "Used in PT-V, PT-F, MT-B and MT-Y templates"
  },
  {
    id: 304,
    Attribute: "Surface Condition",
    Value: "After Machining after laser Induction hardening",
    Status: "Active",
    Description: "Surface Condition After Machining after laser Induction hardening"
  },
  {
    id: 305,
    Attribute: "Surface Condition",
    Value: "As Machined & Casting surface & after Hydro & pneumatic Test",
    Status: "Active",
    Description: "As Machined & Casting surface & after Hydro & pneumatic Test"
  },
  {
    id: 311,
    Attribute: "Stage",
    Value: "After Machining after Induction Hardening",
    Status: "Active",
    Description: "Used in all templates"
  },
  {
    id: 318,
    Attribute: "Stage",
    Value: "After Hydro Test",
    Status: "Active",
    Description: ""
  },
  {
    id: 319,
    Attribute: "Stage",
    Value: "After Welding and Polishing",
    Status: "Active",
    Description: ""
  },
  {
    id: 320,
    Attribute: "Surface Condition",
    Value: "As Polished",
    Status: "Active",
    Description: ""
  },
  {
    id: 321,
    Attribute: "Stage",
    Value: "After Cladding",
    Status: "Active",
    Description: ""
  },
  {
    id: 322,
    Attribute: "Stage",
    Value: "After Platting",
    Status: "Active",
    Description: ""
  },
  {
    id: 323,
    Attribute: "Surface Condition",
    Value: "As Platted",
    Status: "Active",
    Description: ""
  },
  {
    id: 324,
    Attribute: "Stage",
    Value: "After Assembly",
    Status: "Active",
    Description: ""
  },
  {
    id: 325,
    Attribute: "Stage",
    Value: "After Welding and Stress Relieving",
    Status: "Active",
    Description: ""
  },
  {
    id: 326,
    Attribute: "Stage",
    Value: "After Welding and After Heat Treatment",
    Status: "Active",
    Description: ""
  }
];

const DEVICES_LIST = [
  {
    ID: "554",
    Identifier: "KQSPL/EL-YK/17",
    Device_Name: "ELECTROMAGNETIC YOKE",
    Device_Model: "MAGNAFLUX -Y-7",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "2024065485",
    Calibration_Due_Date: "23/6/2025",
    Active: "Yes",
    Specification: "Min. lifting Capacity 4.5 Kg.",
    Certificate_Ref: "MMA/23-24/31012024-4/2",
    Updated_At: "07/May/25 12:00 AM (ago)"
  },
  {
    ID: "553",
    Identifier: "KQSPL/EL-YK/16",
    Device_Name: "ELECTROMAGNETIC YOKE",
    Device_Model: "MAGNAFLUX -Y-7",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "2024055461",
    Calibration_Due_Date: "27/5/2025",
    Active: "Yes",
    Specification: "Min. lifting Capacity 4.5 Kg.",
    Certificate_Ref: "MMA/23-24/31012024-4/2",
    Updated_At: "07/May/25 12:00 AM (ago)"
  },
  {
    ID: "552",
    Identifier: "5450",
    Device_Name: "T/R PROBE",
    Device_Model: "MODSONIC",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5450",
    Calibration_Due_Date: "20/4/2030",
    Active: "Yes",
    Specification: "4MHz, \u00c3\u02dc 10 mm, 0\u00c2\u00b0",
    Certificate_Ref: "",
    Updated_At: "25/Apr/25 12:00 AM (ago)"
  },
  {
    ID: 551,
    Identifier: "FPEPL/E5539-9101",
    Device_Name: "DIGITAL ULTRASONIC FLAW DETECTOR",
    Device_Model: "Modsonic Einstein II DGS",
    Device_Type: "ULTRASONIC FLAW DETECTOR",
    Branch: "Pune",
    Device_Serial_Number: "E5539-9101",
    Calibration_Due_Date: "20/07/2028",
    Active: "Yes",
    Specification: "",
    Certificate_Ref: "MIMCO/UFD/E5539-9101",
    Updated_At: "20/Jul/26 12:00 AM (ago)"
  },
  {
    ID: "550",
    Identifier: "TW31/MF-01 -PYG",
    Device_Name: "STATIONARY MACHINE -4000 AMP",
    Device_Model: "Hymech 603",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "TW31/MF-01",
    Calibration_Due_Date: "2/8/2025",
    Active: "Yes",
    Specification: "0-4000 amps",
    Certificate_Ref: "HME/2000",
    Updated_At: "21/Apr/25 12:00 AM (ago)"
  },
  {
    ID: 549,
    Identifier: "KQSPL/LX-MX/01",
    Device_Name: "LUX METER",
    Device_Model: "Mextech",
    Device_Type: "LUX METER",
    Branch: "Pune",
    Device_Serial_Number: "T127782",
    Calibration_Due_Date: "31/10/2026",
    Active: "Yes",
    Specification: "0-50000 Lux",
    Certificate_Ref: "GTS/250303/04-001",
    Updated_At: "18/May/26 12:00 AM (ago)"
  },
  {
    ID: "548",
    Identifier: "226040",
    Device_Name: "TR PROBE",
    Device_Model: "MODSONIC",
    Device_Type: "TR PROBE",
    Branch: "Head Office",
    Device_Serial_Number: "226040",
    Calibration_Due_Date: "30/11/2029",
    Active: "Yes",
    Specification: "10 mm Dia. 4 MHz",
    Certificate_Ref: "",
    Updated_At: "14/Feb/25 12:00 AM (ago)"
  },
  {
    ID: "547",
    Identifier: "222019",
    Device_Name: "NORMAL PROBE",
    Device_Model: "MODSONIC",
    Device_Type: "NORMAL PROBE",
    Branch: "Head Office",
    Device_Serial_Number: "222019",
    Calibration_Due_Date: "30/11/2029",
    Active: "Yes",
    Specification: "4 MHz, \u00c3\u02dc 24 mm",
    Certificate_Ref: "",
    Updated_At: "14/Feb/25 12:00 AM (ago)"
  },
  {
    ID: "546",
    Identifier: "2413146",
    Device_Name: "NORMAL PROBE",
    Device_Model: "MODSONIC",
    Device_Type: "NORMAL PROBE",
    Branch: "Head Office",
    Device_Serial_Number: "2413146",
    Calibration_Due_Date: "30/11/2029",
    Active: "Yes",
    Specification: "2 MHz, \u00c3\u02dc 10 mm",
    Certificate_Ref: "",
    Updated_At: "14/Feb/25 12:00 AM (ago)"
  },
  {
    ID: "545",
    Identifier: "220616",
    Device_Name: "NORMAL PROBE",
    Device_Model: "MODSONIC",
    Device_Type: "NORMAL PROBE",
    Branch: "Head Office",
    Device_Serial_Number: "220616",
    Calibration_Due_Date: "30/11/2029",
    Active: "Yes",
    Specification: "2 MHz, \u00c3\u02dc 24 mm",
    Certificate_Ref: "",
    Updated_At: "14/Feb/25 12:00 AM (ago)"
  },
  {
    ID: "544",
    Identifier: "2418905",
    Device_Name: "TR PROBE",
    Device_Model: "MODSONIC MMEB4H",
    Device_Type: "TR PROBE",
    Branch: "Pune",
    Device_Serial_Number: "2418905",
    Calibration_Due_Date: "31/12/2029",
    Active: "Yes",
    Specification: "10 mm Dia. 4 MHz",
    Certificate_Ref: "",
    Updated_At: "24/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "543",
    Identifier: "2418842",
    Device_Name: "TR PROBE",
    Device_Model: "MODSONIC MMEB4H",
    Device_Type: "TR PROBE",
    Branch: "Pune",
    Device_Serial_Number: "2418842",
    Calibration_Due_Date: "31/12/2029",
    Active: "Yes",
    Specification: "10 mm Dia. 4 MHz",
    Certificate_Ref: "",
    Updated_At: "24/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "542",
    Identifier: "2418838",
    Device_Name: "TR PROBE",
    Device_Model: "MODSONIC MMEB4H",
    Device_Type: "TR PROBE",
    Branch: "Pune",
    Device_Serial_Number: "2418838",
    Calibration_Due_Date: "31/12/2029",
    Active: "Yes",
    Specification: "10 mm Dia. 4 MHz",
    Certificate_Ref: "",
    Updated_At: "24/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "541",
    Identifier: "2418833",
    Device_Name: "TR PROBE",
    Device_Model: "MODSONIC MMEB4H",
    Device_Type: "TR PROBE",
    Branch: "Pune",
    Device_Serial_Number: "2418833",
    Calibration_Due_Date: "31/12/2029",
    Active: "Yes",
    Specification: "10 mm Dia. 4 MHz",
    Certificate_Ref: "",
    Updated_At: "24/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "540",
    Identifier: "222902",
    Device_Name: "T/R PROBE",
    Device_Model: "MODSONIC -MMEB4H",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "222902",
    Calibration_Due_Date: "31/1/2026",
    Active: "Yes",
    Specification: "4 MHz, 10 mm Dia.",
    Certificate_Ref: "",
    Updated_At: "24/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "539",
    Identifier: "246172",
    Device_Name: "T/R PROBE",
    Device_Model: "MODSONIC -MMEB4H",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "246172",
    Calibration_Due_Date: "31/1/2026",
    Active: "Yes",
    Specification: "4 MHz, 10 mm Dia.",
    Certificate_Ref: "",
    Updated_At: "24/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "538",
    Identifier: "2414421",
    Device_Name: "T/R PROBE",
    Device_Model: "MODSONIC -MMEB4H",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "2414421",
    Calibration_Due_Date: "31/1/2026",
    Active: "Yes",
    Specification: "4 MHz, 10 mm Dia.",
    Certificate_Ref: "",
    Updated_At: "24/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "537",
    Identifier: "KQSPL/SW/05",
    Device_Name: "STOP WATCH",
    Device_Model: "CE",
    Device_Type: "STOP WATCH",
    Branch: "Pune",
    Device_Serial_Number: "KQSPL/SW/05",
    Calibration_Due_Date: "7/4/2025",
    Active: "Yes",
    Specification: "0 to 60 Minutes",
    Certificate_Ref: "",
    Updated_At: "12/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "536",
    Identifier: "KQSPL/SW/04",
    Device_Name: "STOP WATCH",
    Device_Model: "CE",
    Device_Type: "STOP WATCH",
    Branch: "Pune",
    Device_Serial_Number: "KQSPL/SW/04",
    Calibration_Due_Date: "7/4/2025",
    Active: "Yes",
    Specification: "0 to 60 Minutes",
    Certificate_Ref: "",
    Updated_At: "12/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "535",
    Identifier: "KQSPL/SW/03",
    Device_Name: "STOP WATCH",
    Device_Model: "CE",
    Device_Type: "STOP WATCH",
    Branch: "Pune",
    Device_Serial_Number: "KQSPL/SW/03",
    Calibration_Due_Date: "7/4/2025",
    Active: "Yes",
    Specification: "0 to 60 Minutes",
    Certificate_Ref: "",
    Updated_At: "12/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "534",
    Identifier: "KQSPL/SW/02",
    Device_Name: "STOP WATCH",
    Device_Model: "CE",
    Device_Type: "STOP WATCH",
    Branch: "Pune",
    Device_Serial_Number: "KQSPL/SW/02",
    Calibration_Due_Date: "7/4/2025",
    Active: "Yes",
    Specification: "0 to 60 Minutes",
    Certificate_Ref: "",
    Updated_At: "12/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "533",
    Identifier: "KQSPL/SW/01",
    Device_Name: "STOP WATCH",
    Device_Model: "CE",
    Device_Type: "STOP WATCH",
    Branch: "Pune",
    Device_Serial_Number: "KQSPL/SW/01",
    Calibration_Due_Date: "20/12/2025",
    Active: "Yes",
    Specification: "1 to 60 Minutes",
    Certificate_Ref: "",
    Updated_At: "12/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "532",
    Identifier: "KQSPL/VC/03",
    Device_Name: "VERNIER CALLIPER",
    Device_Model: "MITUTOYO",
    Device_Type: "VERNIER CALLIPER",
    Branch: "Pune",
    Device_Serial_Number: "22101727",
    Calibration_Due_Date: "9/4/2025",
    Active: "Yes",
    Specification: "0 to 300 mm",
    Certificate_Ref: "PL/24/4/453",
    Updated_At: "12/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "531",
    Identifier: "KQSPL/VC/02",
    Device_Name: "VERNIER CALLIPER",
    Device_Model: "MITUTOYO",
    Device_Type: "VERNIER CALLIPER",
    Branch: "Pune",
    Device_Serial_Number: "22102831",
    Calibration_Due_Date: "9/4/2025",
    Active: "Yes",
    Specification: "0 to 200 mm",
    Certificate_Ref: "",
    Updated_At: "12/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "530",
    Identifier: "VWI/RFI/3",
    Device_Name: "GAUSS METER",
    Device_Model: "HYMECH",
    Device_Type: "GAUSS METER",
    Branch: "Pune",
    Device_Serial_Number: "VWI/RFI/3",
    Calibration_Due_Date: "25/4/2025",
    Active: "Yes",
    Specification: "",
    Certificate_Ref: "",
    Updated_At: "10/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "529",
    Identifier: "KQSPL/SM-BT/02",
    Device_Name: "STATIONARY MACHINE -1500AMP",
    Device_Model: "MAYURESH",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "415",
    Calibration_Due_Date: "28/4/2026",
    Active: "Yes",
    Specification: "0-1500 amps",
    Certificate_Ref: "HME-1500",
    Updated_At: "28/Dec/24 12:00 AM (ago)"
  },
  {
    ID: 528,
    Identifier: "Q&Q-Thermometer",
    Device_Name: "DIGITAL IR THERMOMETER",
    Device_Model: "---",
    Device_Type: "THERMOMETER",
    Branch: "Pune",
    Device_Serial_Number: "24H4049-QQS-39-007",
    Calibration_Due_Date: "20/07/2028",
    Active: "Yes",
    Specification: "---",
    Certificate_Ref: "",
    Updated_At: "20/Jul/26 12:00 AM (ago)"
  },
  {
    ID: 527,
    Identifier: "Q&Q-Lux Meter",
    Device_Name: "LUX METER",
    Device_Model: "---",
    Device_Type: "LUX METER",
    Branch: "Pune",
    Device_Serial_Number: "2135415",
    Calibration_Due_Date: "31/05/2026",
    Active: "Yes",
    Specification: "---",
    Certificate_Ref: "",
    Updated_At: "18/May/26 12:00 AM (ago)"
  },
  {
    ID: "526",
    Identifier: "246505",
    Device_Name: "NORMAL PROBE",
    Device_Model: "MODSONIC",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "246505",
    Calibration_Due_Date: "30/11/2029",
    Active: "Yes",
    Specification: "2 MHz, \u00c3\u02dc 24 mm",
    Certificate_Ref: "",
    Updated_At: "07/Dec/24 12:00 AM (ago)"
  },
  {
    ID: "525",
    Identifier: "2413298",
    Device_Name: "TR PROBE",
    Device_Model: "MODSONIC",
    Device_Type: "TR PROBE",
    Branch: "Pune",
    Device_Serial_Number: "2413298",
    Calibration_Due_Date: "30/11/2029",
    Active: "Yes",
    Specification: "4 MHZ, \u00c3\u02dc20 mm",
    Certificate_Ref: "",
    Updated_At: "07/Dec/24 12:00 AM (ago)"
  },
  {
    ID: "524",
    Identifier: "DPL-510404",
    Device_Name: "DIGITAL HALLS PROBE",
    Device_Model: "---",
    Device_Type: "GAUSS METER",
    Branch: "Pune",
    Device_Serial_Number: "DPL-510404",
    Calibration_Due_Date: "18/9/2024",
    Active: "Yes",
    Specification: "\u00c2\u00b10 to \u00c2\u00b1100 Gauss",
    Certificate_Ref: "",
    Updated_At: "26/Jul/24 12:00 AM (ago)"
  },
  {
    ID: "523",
    Identifier: "210701",
    Device_Name: "LUX METER",
    Device_Model: "----",
    Device_Type: "LUX METER",
    Branch: "Pune",
    Device_Serial_Number: "210701",
    Calibration_Due_Date: "29/9/2024",
    Active: "Yes",
    Specification: "",
    Certificate_Ref: "",
    Updated_At: "26/Jul/24 12:00 AM (ago)"
  },
  {
    ID: "522",
    Identifier: "210701",
    Device_Name: "UV INTENSITY METER",
    Device_Model: "----",
    Device_Type: "UV METER",
    Branch: "Pune",
    Device_Serial_Number: "210701",
    Calibration_Due_Date: "29/9/2024",
    Active: "Yes",
    Specification: "",
    Certificate_Ref: "",
    Updated_At: "26/Jul/24 12:00 AM (ago)"
  },
  {
    ID: 521,
    Identifier: 202010389,
    Device_Name: "INFRARED THERMOMETER",
    Device_Model: "---",
    Device_Type: "THERMOMETER",
    Branch: "Pune",
    Device_Serial_Number: "202010389",
    Calibration_Due_Date: "20/07/2028",
    Active: "Yes",
    Specification: "",
    Certificate_Ref: "",
    Updated_At: "20/Jul/26 12:00 AM (ago)"
  },
  {
    ID: "520",
    Identifier: "GMFLMPI01",
    Device_Name: "STATIONARY MACHINE",
    Device_Model: "VINZE",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "GMFLMPI01",
    Calibration_Due_Date: "29/9/2024",
    Active: "No",
    Specification: "0-5000 amps",
    Certificate_Ref: "",
    Updated_At: "12/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "519",
    Identifier: "KQSPL/HB-DY/02",
    Device_Name: "DIGITAL HALLS PROBE",
    Device_Model: "DGM-1058",
    Device_Type: "GAUSS METER",
    Branch: "Pune",
    Device_Serial_Number: "DPL-510415",
    Calibration_Due_Date: "15/7/2025",
    Active: "Yes",
    Specification: "\u00c2\u00b10 to \u00c2\u00b1100 Gauss",
    Certificate_Ref: "SIMS/KUB/415/25/09",
    Updated_At: "28/Jan/25 12:00 AM (ago)"
  },
  {
    ID: 518,
    Identifier: "KQSPL/UFD/WT/12",
    Device_Name: "ULTRASONIC FLAW DETECTOR",
    Device_Model: "Krautkramer USM100",
    Device_Type: "ULTRASONIC FLAW DETECTOR",
    Branch: "Pune",
    Device_Serial_Number: "USM10024070031",
    Calibration_Due_Date: "20/07/2028",
    Active: "Yes",
    Specification: "",
    Certificate_Ref: "250312/UFD/KUB",
    Updated_At: "20/Jul/26 12:00 AM (ago)"
  },
  {
    ID: "517",
    Identifier: "741849",
    Device_Name: "ANGLE PROBE",
    Device_Model: "MODSONIC -MBW70N4",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "741849",
    Calibration_Due_Date: "20/2/2029",
    Active: "Yes",
    Specification: "8 X 9 mm, 70\u00c2\u00b0, 4 MHz",
    Certificate_Ref: "",
    Updated_At: "23/Feb/24 12:00 AM (ago)"
  },
  {
    ID: "516",
    Identifier: "243144",
    Device_Name: "ANGLE PROBE",
    Device_Model: "MODSONIC -MBW70N4",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "243144",
    Calibration_Due_Date: "20/2/2029",
    Active: "Yes",
    Specification: "8 X 9 mm, 70\u00c2\u00b0, 4 MHz",
    Certificate_Ref: "",
    Updated_At: "23/Feb/24 12:00 AM (ago)"
  },
  {
    ID: "515",
    Identifier: "243690",
    Device_Name: "T/R PROBE",
    Device_Model: "MODSONIC -MMEB4H",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "243690",
    Calibration_Due_Date: "20/2/2029",
    Active: "Yes",
    Specification: "4 MHz, 10 mm Dia.",
    Certificate_Ref: "",
    Updated_At: "24/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "514",
    Identifier: "243693",
    Device_Name: "T/R PROBE",
    Device_Model: "MODSONIC -MMEB4H",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "243693",
    Calibration_Due_Date: "20/2/2029",
    Active: "Yes",
    Specification: "4 MHz, 10 mm Dia.",
    Certificate_Ref: "",
    Updated_At: "23/Feb/24 12:00 AM (ago)"
  },
  {
    ID: "513",
    Identifier: "237515",
    Device_Name: "T/R PROBE",
    Device_Model: "MODSONIC -MBE4H",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "237515",
    Calibration_Due_Date: "20/2/2029",
    Active: "Yes",
    Specification: "4 MHz, 20 mm Dia.",
    Certificate_Ref: "",
    Updated_At: "23/Feb/24 12:00 AM (ago)"
  },
  {
    ID: "512",
    Identifier: "237591",
    Device_Name: "T/R PROBE",
    Device_Model: "MODSONIC -MBE4H",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "237591",
    Calibration_Due_Date: "20/2/2029",
    Active: "Yes",
    Specification: "4 MHz, 20 mm Dia.",
    Certificate_Ref: "",
    Updated_At: "23/Feb/24 12:00 AM (ago)"
  },
  {
    ID: "511",
    Identifier: "242363",
    Device_Name: "T/R PROBE",
    Device_Model: "MODSONIC -MBE4H",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "242363",
    Calibration_Due_Date: "20/2/2029",
    Active: "Yes",
    Specification: "4 MHz, 20 mm Dia.",
    Certificate_Ref: "",
    Updated_At: "23/Feb/24 12:00 AM (ago)"
  },
  {
    ID: "510",
    Identifier: "232343",
    Device_Name: "T/R PROBE",
    Device_Model: "MODSONIC -MBE4H",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "232343",
    Calibration_Due_Date: "20/2/2029",
    Active: "Yes",
    Specification: "4 MHz, 20 mm Dia.",
    Certificate_Ref: "",
    Updated_At: "27/Feb/24 12:00 AM (ago)"
  },
  {
    ID: "509",
    Identifier: "223366",
    Device_Name: "NORMAL PROBE",
    Device_Model: "MODSONIC",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "223366",
    Calibration_Due_Date: "30/5/2028",
    Active: "Yes",
    Specification: "4 MHz, 10 mm Dia.",
    Certificate_Ref: "",
    Updated_At: "23/Feb/24 12:00 AM (ago)"
  },
  {
    ID: "508",
    Identifier: "KQSPL/AWSG/02",
    Device_Name: "WELDING GAUGE",
    Device_Model: "----",
    Device_Type: "WELD GAUGE",
    Branch: "Pune",
    Device_Serial_Number: "---",
    Calibration_Due_Date: "7/2/2025",
    Active: "Yes",
    Specification: "0-20 mm",
    Certificate_Ref: "PL/24/02/210",
    Updated_At: "14/Feb/24 12:00 AM (ago)"
  },
  {
    ID: "507",
    Identifier: "KQSPL/AWSG/01",
    Device_Name: "WELDING GAUGE",
    Device_Model: "----",
    Device_Type: "WELD GAUGE",
    Branch: "Pune",
    Device_Serial_Number: "---",
    Calibration_Due_Date: "6/6/2024",
    Active: "Yes",
    Specification: "0-20 mm",
    Certificate_Ref: "BE06F-02/01",
    Updated_At: "14/Feb/24 12:00 AM (ago)"
  },
  {
    ID: "506",
    Identifier: "56929-93131",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "56929-93131",
    Calibration_Due_Date: "22/1/2025",
    Active: "Yes",
    Specification: "8X9 mm, 70\u00c2\u00b0 - 4 MHz",
    Certificate_Ref: "",
    Updated_At: "29/Jan/24 12:00 AM (ago)"
  },
  {
    ID: "505",
    Identifier: "56929-93125",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "56929-93125",
    Calibration_Due_Date: "22/1/2025",
    Active: "Yes",
    Specification: "8X9 mm, 70\u00c2\u00b0 - 4 MHz",
    Certificate_Ref: "",
    Updated_At: "29/Jan/24 12:00 AM (ago)"
  },
  {
    ID: "504",
    Identifier: "56929-93127",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "56929-93127",
    Calibration_Due_Date: "22/1/2025",
    Active: "Yes",
    Specification: "8X9 mm, 70\u00c2\u00b0 - 4 MHz",
    Certificate_Ref: "",
    Updated_At: "29/Jan/24 12:00 AM (ago)"
  },
  {
    ID: "503",
    Identifier: "56929-93132",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "56929-93132",
    Calibration_Due_Date: "22/1/2025",
    Active: "Yes",
    Specification: "8X9 mm, 70\u00c2\u00b0 - 4 MHz",
    Certificate_Ref: "",
    Updated_At: "29/Jan/24 12:00 AM (ago)"
  },
  {
    ID: "502",
    Identifier: "56928-83775",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "56928-83775",
    Calibration_Due_Date: "22/1/2025",
    Active: "Yes",
    Specification: "8X9 mm, 60\u00c2\u00b0 - 4 MHz",
    Certificate_Ref: "",
    Updated_At: "29/Jan/24 12:00 AM (ago)"
  },
  {
    ID: "501",
    Identifier: "56928-83831",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "56928-83831",
    Calibration_Due_Date: "22/1/2025",
    Active: "Yes",
    Specification: "8X9 mm, 60\u00c2\u00b0 - 4 MHz",
    Certificate_Ref: "",
    Updated_At: "29/Jan/24 12:00 AM (ago)"
  },
  {
    ID: "500",
    Identifier: "56928-83821",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "56928-83821",
    Calibration_Due_Date: "22/1/2025",
    Active: "Yes",
    Specification: "8X9 mm, 60\u00c2\u00b0 - 4 MHz",
    Certificate_Ref: "",
    Updated_At: "29/Jan/24 12:00 AM (ago)"
  },
  {
    ID: "499",
    Identifier: "56927-86049",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "56927-86049",
    Calibration_Due_Date: "22/1/2025",
    Active: "Yes",
    Specification: "8X9 mm, 45\u00c2\u00b0 - 4 MHz",
    Certificate_Ref: "",
    Updated_At: "29/Jan/24 12:00 AM (ago)"
  },
  {
    ID: "498",
    Identifier: "56927-86042",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "56927-86042",
    Calibration_Due_Date: "22/1/2025",
    Active: "Yes",
    Specification: "8X9 mm, 45\u00c2\u00b0 - 4 MHz",
    Certificate_Ref: "",
    Updated_At: "29/Jan/24 12:00 AM (ago)"
  },
  {
    ID: "497",
    Identifier: "56927-85145",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "56927-85145",
    Calibration_Due_Date: "22/1/2025",
    Active: "Yes",
    Specification: "8X9 mm, 45\u00c2\u00b0 - 4 MHz",
    Certificate_Ref: "",
    Updated_At: "29/Jan/24 12:00 AM (ago)"
  },
  {
    ID: "496",
    Identifier: "56927-86044",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "56927-86044",
    Calibration_Due_Date: "22/1/2025",
    Active: "Yes",
    Specification: "8X9 mm, 45\u00c2\u00b0 - 4 MHz",
    Certificate_Ref: "",
    Updated_At: "29/Jan/24 12:00 AM (ago)"
  },
  {
    ID: "495",
    Identifier: "57467-5199",
    Device_Name: "TR PROBE",
    Device_Model: "GE",
    Device_Type: "TR PROBE",
    Branch: "Pune",
    Device_Serial_Number: "57467-5199",
    Calibration_Due_Date: "22/1/2025",
    Active: "Yes",
    Specification: "20 mm Dia.- 2 MHz (7X18)",
    Certificate_Ref: "",
    Updated_At: "29/Jan/24 12:00 AM (ago)"
  },
  {
    ID: "494",
    Identifier: "57469-53345",
    Device_Name: "TR PROBE",
    Device_Model: "GE",
    Device_Type: "TR PROBE",
    Branch: "Pune",
    Device_Serial_Number: "57469-53345",
    Calibration_Due_Date: "22/1/2025",
    Active: "Yes",
    Specification: "20 mm Dia.- 4 MHz (6X20)",
    Certificate_Ref: "",
    Updated_At: "29/Jan/24 12:00 AM (ago)"
  },
  {
    ID: "493",
    Identifier: "57749-72755",
    Device_Name: "NORMAL PROBE",
    Device_Model: "GE",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "57749-72755",
    Calibration_Due_Date: "22/1/2025",
    Active: "Yes",
    Specification: "10 mm Dia.- 4 MHz",
    Certificate_Ref: "",
    Updated_At: "29/Jan/24 12:00 AM (ago)"
  },
  {
    ID: "492",
    Identifier: "57745-74842",
    Device_Name: "NORMAL PROBE",
    Device_Model: "GE",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "57745-74842",
    Calibration_Due_Date: "22/1/2025",
    Active: "Yes",
    Specification: "24 mm Dia.- 2 MHz",
    Certificate_Ref: "",
    Updated_At: "29/Jan/24 12:00 AM (ago)"
  },
  {
    ID: "491",
    Identifier: "57746-57065",
    Device_Name: "NORMAL PROBE",
    Device_Model: "GE",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "57746-57065",
    Calibration_Due_Date: "22/1/2025",
    Active: "Yes",
    Specification: "24 mm Dia.- 4 MHz",
    Certificate_Ref: "",
    Updated_At: "29/Jan/24 12:00 AM (ago)"
  },
  {
    ID: "490",
    Identifier: "57749-74715",
    Device_Name: "NORMAL PROBE",
    Device_Model: "GE",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "57749-74715",
    Calibration_Due_Date: "22/1/2025",
    Active: "Yes",
    Specification: "10 mm Dia.- 4 MHz",
    Certificate_Ref: "",
    Updated_At: "29/Jan/24 12:00 AM (ago)"
  },
  {
    ID: "489",
    Identifier: "KQSPL/UFD/MOD/11",
    Device_Name: "DIGITAL ULTRASONIC FLAW DETECTOR",
    Device_Model: "Modsonic Einstein II DGS",
    Device_Type: "ULTRASONIC FLAW DETECTOR",
    Branch: "Pune",
    Device_Serial_Number: "E6273-2250",
    Calibration_Due_Date: "22/12/2025",
    Active: "Yes",
    Specification: "",
    Certificate_Ref: "SNDT/UFD/2333/KQSPL",
    Updated_At: "28/Dec/24 12:00 AM (ago)"
  },
  {
    ID: "488",
    Identifier: "1664",
    Device_Name: "ANGLE PROBE",
    Device_Model: "MODSONIC",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1664",
    Calibration_Due_Date: "30/5/2025",
    Active: "Yes",
    Specification: "2 MHz, 45\u00c2\u00ba 8 X 9 mm",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "487",
    Identifier: "633162017",
    Device_Name: "ANGLE PROBE",
    Device_Model: "MODSONIC",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "633162017",
    Calibration_Due_Date: "30/5/2025",
    Active: "Yes",
    Specification: "2 MHz, 60\u00c2\u00ba 8 X 9 mm",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "486",
    Identifier: "VWI-THRMO-2",
    Device_Name: "INFRARED THERMOMETER",
    Device_Model: "VWI-THRMO-2",
    Device_Type: "THERMOMETER",
    Branch: "Pune",
    Device_Serial_Number: "VWI-THRMO-2",
    Calibration_Due_Date: "18/9/2025",
    Active: "Yes",
    Specification: "",
    Certificate_Ref: "",
    Updated_At: "10/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "485",
    Identifier: "VWI-UVM-01",
    Device_Name: "UV METER",
    Device_Model: "VWI-UVM-01",
    Device_Type: "UV METER",
    Branch: "Pune",
    Device_Serial_Number: "VWI-UVM-01",
    Calibration_Due_Date: "12/1/2025",
    Active: "Yes",
    Specification: "",
    Certificate_Ref: "",
    Updated_At: "10/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "484",
    Identifier: "VWI-DGM-1",
    Device_Name: "GAUSS METER",
    Device_Model: "VWI-DGM-1",
    Device_Type: "GAUSS METER",
    Branch: "Pune",
    Device_Serial_Number: "VWI-DGM-1",
    Calibration_Due_Date: "25/4/2025",
    Active: "Yes",
    Specification: "",
    Certificate_Ref: "",
    Updated_At: "10/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "483",
    Identifier: "VWI/DLM/01",
    Device_Name: "UV METER",
    Device_Model: "VWI/DLM/01",
    Device_Type: "UV METER",
    Branch: "Pune",
    Device_Serial_Number: "VWI/DLM/01",
    Calibration_Due_Date: "26/4/2024",
    Active: "Yes",
    Specification: "",
    Certificate_Ref: "",
    Updated_At: "24/Nov/23 12:00 AM (ago)"
  },
  {
    ID: "482",
    Identifier: "VWI/DLM/01",
    Device_Name: "LUX METER",
    Device_Model: "VWI/DLM/01",
    Device_Type: "LUX METER",
    Branch: "Pune",
    Device_Serial_Number: "VWI/DLM/01",
    Calibration_Due_Date: "26/4/2024",
    Active: "Yes",
    Specification: "",
    Certificate_Ref: "",
    Updated_At: "24/Nov/23 12:00 AM (ago)"
  },
  {
    ID: "481",
    Identifier: "VWI/DGM/01",
    Device_Name: "GAUSS METER",
    Device_Model: "VWI/DGM/01",
    Device_Type: "GAUSS METER",
    Branch: "Pune",
    Device_Serial_Number: "VWI/DGM/01",
    Calibration_Due_Date: "25/4/2025",
    Active: "Yes",
    Specification: "",
    Certificate_Ref: "",
    Updated_At: "10/Jan/25 12:00 AM (ago)"
  },
  {
    ID: 480,
    Identifier: "VWI/IR/02",
    Device_Name: "INFRARED THERMOMETER",
    Device_Model: "VWI/IR/02",
    Device_Type: "THERMOMETER",
    Branch: "Pune",
    Device_Serial_Number: "VWI/IR/02",
    Calibration_Due_Date: "20/07/2028",
    Active: "Yes",
    Specification: "",
    Certificate_Ref: "",
    Updated_At: "20/Jul/26 12:00 AM (ago)"
  },
  {
    ID: "479",
    Identifier: "VWI-LM-01",
    Device_Name: "LUX METER",
    Device_Model: "LUTRON",
    Device_Type: "LUX METER",
    Branch: "Pune",
    Device_Serial_Number: "VWI-LM-01",
    Calibration_Due_Date: "12/1/2025",
    Active: "Yes",
    Specification: "365nm",
    Certificate_Ref: "",
    Updated_At: "10/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "478",
    Identifier: "VWI/LM/07",
    Device_Name: "UV INTENSITY METER",
    Device_Model: "LUTRON",
    Device_Type: "UV METER",
    Branch: "Pune",
    Device_Serial_Number: "VWI/LM/07",
    Calibration_Due_Date: "4/3/2024",
    Active: "Yes",
    Specification: "365 nm",
    Certificate_Ref: "",
    Updated_At: "10/Nov/23 12:00 AM (ago)"
  },
  {
    ID: "477",
    Identifier: "9097",
    Device_Name: "ANGLE PROBE  CURVATURE",
    Device_Model: "FALLON",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "9097",
    Calibration_Due_Date: "30/5/2025",
    Active: "Yes",
    Specification: "4 MHz, 70\u00c2\u00ba 5 mm Dia.",
    Certificate_Ref: "",
    Updated_At: "28/Oct/23 12:00 AM (ago)"
  },
  {
    ID: "476",
    Identifier: "VWI/MT/01",
    Device_Name: "STATIONARY MACHINE -5000AMP",
    Device_Model: "HYMECH",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "VWI/MT/01",
    Calibration_Due_Date: "4/9/2024",
    Active: "No",
    Specification: "0-5000 amps",
    Certificate_Ref: "",
    Updated_At: "12/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "475",
    Identifier: "510385",
    Device_Name: "GAUSS METER",
    Device_Model: "Dyglo",
    Device_Type: "GAUSS METER",
    Branch: "Head Office",
    Device_Serial_Number: "510385",
    Calibration_Due_Date: "26/10/2023",
    Active: "No",
    Specification: "0-10 Guass",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "474",
    Identifier: "223977",
    Device_Name: "ANGLE PROBE",
    Device_Model: "MODSONIC",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "223977",
    Calibration_Due_Date: "30/5/2025",
    Active: "Yes",
    Specification: "4 MHz, 70\u00c2\u00ba 8X9 mm",
    Certificate_Ref: "",
    Updated_At: "15/Oct/23 12:00 AM (ago)"
  },
  {
    ID: "473",
    Identifier: "223855",
    Device_Name: "ANGLE PROBE",
    Device_Model: "MODSONIC",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "223855",
    Calibration_Due_Date: "30/5/2025",
    Active: "Yes",
    Specification: "4 MHz, 60\u00c2\u00ba 8X9 mm",
    Certificate_Ref: "",
    Updated_At: "15/Oct/23 12:00 AM (ago)"
  },
  {
    ID: "472",
    Identifier: "223762",
    Device_Name: "ANGLE PROBE",
    Device_Model: "MODSONIC",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "223762",
    Calibration_Due_Date: "30/5/2025",
    Active: "Yes",
    Specification: "4 MHz, 45\u00c2\u00ba 8X9 mm",
    Certificate_Ref: "",
    Updated_At: "15/Oct/23 12:00 AM (ago)"
  },
  {
    ID: "471",
    Identifier: "L-126",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Lensar",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "L-126",
    Calibration_Due_Date: "25/10/2026",
    Active: "Yes",
    Specification: "2MHz 14X14mm, 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "15/Oct/23 12:00 AM (ago)"
  },
  {
    ID: "468",
    Identifier: "853EAF",
    Device_Name: "T/R PROBE",
    Device_Model: "EECI, VNPGXI03, TR-4L",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "853EAF",
    Calibration_Due_Date: "3/6/2024",
    Active: "Yes",
    Specification: "24 mm Dia.- 4 MHz",
    Certificate_Ref: "",
    Updated_At: "05/Sep/23 12:00 AM (ago)"
  },
  {
    ID: "467",
    Identifier: "513EAF",
    Device_Name: "T/R PROBE",
    Device_Model: "EECI, VNPHXI02, TRM-4L",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "513EAF",
    Calibration_Due_Date: "3/6/2024",
    Active: "Yes",
    Specification: "10 mm Dia.- 4 MHz",
    Certificate_Ref: "",
    Updated_At: "05/Sep/23 12:00 AM (ago)"
  },
  {
    ID: "466",
    Identifier: "510EAF",
    Device_Name: "T/R PROBE",
    Device_Model: "EECI, VNPHXI02, TRM-4L",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "510EAF",
    Calibration_Due_Date: "3/6/2024",
    Active: "Yes",
    Specification: "10 mm Dia.- 4 MHz",
    Certificate_Ref: "",
    Updated_At: "05/Sep/23 12:00 AM (ago)"
  },
  {
    ID: "465",
    Identifier: "577EAF",
    Device_Name: "T/R PROBE",
    Device_Model: "EECI, VNPGXI03, TR-4L",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "577EAF",
    Calibration_Due_Date: "3/6/2024",
    Active: "Yes",
    Specification: "24 mm Dia.- 4 MHz",
    Certificate_Ref: "",
    Updated_At: "05/Sep/23 12:00 AM (ago)"
  },
  {
    ID: "464",
    Identifier: "051EAF",
    Device_Name: "AN",
    Device_Model: "EECI, VNPBII08, AM70-4L",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "051EAF",
    Calibration_Due_Date: "3/6/2024",
    Active: "Yes",
    Specification: "8X9 mm, 70 - 4 MHz",
    Certificate_Ref: "",
    Updated_At: "05/Sep/23 12:00 AM (ago)"
  },
  {
    ID: "463",
    Identifier: "959DAF",
    Device_Name: "ANGLE PROBE",
    Device_Model: "EECI, VNPBI013, AM70-4L",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "959DAF",
    Calibration_Due_Date: "3/6/2024",
    Active: "Yes",
    Specification: "8X9 mm, 70 - 4 MHz",
    Certificate_Ref: "",
    Updated_At: "05/Sep/23 12:00 AM (ago)"
  },
  {
    ID: "462",
    Identifier: "853EAF",
    Device_Name: "ANGLE PROBE",
    Device_Model: "EECI, VNPBGI06, AM60-4L",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "853EAF",
    Calibration_Due_Date: "3/6/2024",
    Active: "Yes",
    Specification: "8X9 mm, 60 - 4 MHz",
    Certificate_Ref: "",
    Updated_At: "05/Sep/23 12:00 AM (ago)"
  },
  {
    ID: "461",
    Identifier: "852EAF",
    Device_Name: "ANGLE PROBE",
    Device_Model: "EECI, VNPBGI06, AM60-4L",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "852EAF",
    Calibration_Due_Date: "3/6/2024",
    Active: "Yes",
    Specification: "8X9 mm, 60 - 4 MHz",
    Certificate_Ref: "",
    Updated_At: "05/Sep/23 12:00 AM (ago)"
  },
  {
    ID: "460",
    Identifier: "395CAF",
    Device_Name: "ANGLE PROBE",
    Device_Model: "EECI, VNPIFI04, AM45-4L",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "395CAF",
    Calibration_Due_Date: "3/6/2024",
    Active: "Yes",
    Specification: "8X9 mm, 45 - 4 MHz",
    Certificate_Ref: "",
    Updated_At: "05/Sep/23 12:00 AM (ago)"
  },
  {
    ID: "459",
    Identifier: "394CAF",
    Device_Name: "ANGLE PROBE",
    Device_Model: "EECI, VNPIFI04, AM45-4L",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "394CAF",
    Calibration_Due_Date: "3/6/2024",
    Active: "Yes",
    Specification: "8X9 mm, 45 - 4 MHz",
    Certificate_Ref: "",
    Updated_At: "05/Sep/23 12:00 AM (ago)"
  },
  {
    ID: "458",
    Identifier: "596DAF",
    Device_Name: "NORMAL PROBE",
    Device_Model: "EECI VNPLXI09, NM-4LS",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "596DAF",
    Calibration_Due_Date: "3/6/2024",
    Active: "Yes",
    Specification: "10 mm Dia.- 4 MHz",
    Certificate_Ref: "",
    Updated_At: "05/Sep/23 12:00 AM (ago)"
  },
  {
    ID: "457",
    Identifier: "595DAF",
    Device_Name: "NORMAL PROBE",
    Device_Model: "EECI VNPLXI09, NM-4LS",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "595DAF",
    Calibration_Due_Date: "3/6/2024",
    Active: "Yes",
    Specification: "10 mm Dia.- 4 MHz",
    Certificate_Ref: "",
    Updated_At: "05/Sep/23 12:00 AM (ago)"
  },
  {
    ID: "456",
    Identifier: "526CAF",
    Device_Name: "NORMAL PROBE",
    Device_Model: "EECI VNPLXE05, N-2LS",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "526CAF",
    Calibration_Due_Date: "3/6/2024",
    Active: "Yes",
    Specification: "24 mm Dia.- 2 MHz",
    Certificate_Ref: "",
    Updated_At: "05/Sep/23 12:00 AM (ago)"
  },
  {
    ID: "455",
    Identifier: "KQSPL/UFD/EECI/10",
    Device_Name: "ULTRASONIC FLAW DETECTOR",
    Device_Model: "DS702",
    Device_Type: "ULTRASONIC FLAW DETECTOR",
    Branch: "Pune",
    Device_Serial_Number: "S7080CWB",
    Calibration_Due_Date: "12/8/2025",
    Active: "Yes",
    Specification: "",
    Certificate_Ref: "SNDT/UFD/2448/KQSPL",
    Updated_At: "20/Aug/24 12:00 AM (ago)"
  },
  {
    ID: "430",
    Identifier: "VWI/MT/02",
    Device_Name: "STATIONARY MACHINE -3000 AMP",
    Device_Model: "Hymech",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "VWI/MT/02 (Hymech Make)",
    Calibration_Due_Date: "12/1/2025",
    Active: "Yes",
    Specification: "3000Amp",
    Certificate_Ref: "",
    Updated_At: "14/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "429",
    Identifier: "ABC-069",
    Device_Name: "V3 CALIBRATION BLOCK",
    Device_Model: "X-RAY ACCESSORIES PRODUCTS",
    Device_Type: "V3 CALIBRATION BLOCK",
    Branch: "Pune",
    Device_Serial_Number: "ABC-069",
    Calibration_Due_Date: "15/6/2024",
    Active: "Yes",
    Specification: "ABC-069",
    Certificate_Ref: "",
    Updated_At: "19/Jun/23 12:00 AM (ago)"
  },
  {
    ID: "428",
    Identifier: "527CAF",
    Device_Name: "NORMAL PROBE",
    Device_Model: "EECI VNPLXE05, N-2LS",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "527CAF",
    Calibration_Due_Date: "3/6/2024",
    Active: "Yes",
    Specification: "24 mm Dia.- 2 MHz",
    Certificate_Ref: "",
    Updated_At: "09/Jun/23 12:00 AM (ago)"
  },
  {
    ID: "427",
    Identifier: "786CAF",
    Device_Name: "NORMAL PROBE",
    Device_Model: "EECI VNPLXE05, NM-2LS",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "786CAF",
    Calibration_Due_Date: "3/6/2024",
    Active: "Yes",
    Specification: "10 mm Dia.- 2 MHz",
    Certificate_Ref: "",
    Updated_At: "09/Jun/23 12:00 AM (ago)"
  },
  {
    ID: "426",
    Identifier: "788CAF",
    Device_Name: "NORMAL PROBE",
    Device_Model: "EECI VNPLXE05, NM-2LS",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "788CAF",
    Calibration_Due_Date: "3/6/2024",
    Active: "Yes",
    Specification: "10 mm Dia.- 2 MHz",
    Certificate_Ref: "",
    Updated_At: "09/Jun/23 12:00 AM (ago)"
  },
  {
    ID: "425",
    Identifier: "535BAF",
    Device_Name: "NORMAL PROBE",
    Device_Model: "EECI VNPKXI08, N-4LS",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "535BAF",
    Calibration_Due_Date: "3/6/2024",
    Active: "Yes",
    Specification: "24 mm Dia.- 4 MHz",
    Certificate_Ref: "",
    Updated_At: "09/Jun/23 12:00 AM (ago)"
  },
  {
    ID: "424",
    Identifier: "534BAF",
    Device_Name: "NORMAL PROBE",
    Device_Model: "EECI VNPKXI08, N-4LS",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "534BAF",
    Calibration_Due_Date: "3/6/2024",
    Active: "Yes",
    Specification: "24 mm Dia.- 4 MHz",
    Certificate_Ref: "",
    Updated_At: "09/Jun/23 12:00 AM (ago)"
  },
  {
    ID: "423",
    Identifier: "231332",
    Device_Name: "PROBE",
    Device_Model: "MODSONIC",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "231332",
    Calibration_Due_Date: "30/5/2025",
    Active: "Yes",
    Specification: "10 mm Dia.- 4 MHz",
    Certificate_Ref: "",
    Updated_At: "15/Oct/23 12:00 AM (ago)"
  },
  {
    ID: "422",
    Identifier: "231331",
    Device_Name: "PROBE",
    Device_Model: "MODSONIC",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "231331",
    Calibration_Due_Date: "30/5/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "15/Oct/23 12:00 AM (ago)"
  },
  {
    ID: "421",
    Identifier: "231330",
    Device_Name: "TR PROBE",
    Device_Model: "MODSONIC MMEB 4H",
    Device_Type: "MINI DUAL CRYSTAL",
    Branch: "Pune",
    Device_Serial_Number: "231330",
    Calibration_Due_Date: "30/5/2025",
    Active: "Yes",
    Specification: "10 mm Dia.- 4 MHz",
    Certificate_Ref: "",
    Updated_At: "15/Jul/23 12:00 AM (ago)"
  },
  {
    ID: "420",
    Identifier: "232344",
    Device_Name: "T/R PROBE",
    Device_Model: "MODSONIC MEB4H",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "232344",
    Calibration_Due_Date: "30/5/2028",
    Active: "Yes",
    Specification: "4 MHz, 20 mm Dia.",
    Certificate_Ref: "",
    Updated_At: "27/Feb/24 12:00 AM (ago)"
  },
  {
    ID: "419",
    Identifier: "232343",
    Device_Name: "TR PROBE",
    Device_Model: "MODSONIC MEB4H",
    Device_Type: "TR PROBE",
    Branch: "Pune",
    Device_Serial_Number: "232343",
    Calibration_Due_Date: "30/5/2028",
    Active: "Yes",
    Specification: "4 MHz, 20 mm Dia.",
    Certificate_Ref: "",
    Updated_At: "27/Feb/24 12:00 AM (ago)"
  },
  {
    ID: "418",
    Identifier: "231926",
    Device_Name: "ANGLE PROBE",
    Device_Model: "MODSONIC MBW 70 N4",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "231926",
    Calibration_Due_Date: "30/5/2025",
    Active: "Yes",
    Specification: "8X9 mm, 70 - 4 MHz",
    Certificate_Ref: "",
    Updated_At: "05/Jun/23 12:00 AM (ago)"
  },
  {
    ID: "417",
    Identifier: "231781",
    Device_Name: "ANGLE PROBE",
    Device_Model: "MODSINIC MBW 60 N4",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "231781",
    Calibration_Due_Date: "30/5/2025",
    Active: "Yes",
    Specification: "8X9 mm, 60 - 4 MHz",
    Certificate_Ref: "",
    Updated_At: "05/Jun/23 12:00 AM (ago)"
  },
  {
    ID: "416",
    Identifier: "231729",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic MBW 45 N4",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "231729",
    Calibration_Due_Date: "30/5/2025",
    Active: "Yes",
    Specification: "8X9 mm, 45 - 4 MHz",
    Certificate_Ref: "",
    Updated_At: "05/Jun/23 12:00 AM (ago)"
  },
  {
    ID: "415",
    Identifier: "229180",
    Device_Name: "NORMAL PROBE",
    Device_Model: "MODSONIC MM4SN",
    Device_Type: "NORMAL PROBE",
    Branch: "Head Office",
    Device_Serial_Number: "229180",
    Calibration_Due_Date: "30/5/2025",
    Active: "Yes",
    Specification: "10 mm Dia.- 2 MHz",
    Certificate_Ref: "",
    Updated_At: "05/Jun/23 12:00 AM (ago)"
  },
  {
    ID: "414",
    Identifier: "229124",
    Device_Name: "NORMAL PROBE",
    Device_Model: "MODSONIC MM4SN",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "229124",
    Calibration_Due_Date: "30/5/2025",
    Active: "Yes",
    Specification: "10 mm Dia.- 4 MHz",
    Certificate_Ref: "",
    Updated_At: "05/Jun/23 12:00 AM (ago)"
  },
  {
    ID: "413",
    Identifier: "228697",
    Device_Name: "NORMAL PROBE",
    Device_Model: "MODSONIC M4SN",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "228697",
    Calibration_Due_Date: "30/5/2025",
    Active: "Yes",
    Specification: "24 mm Dia.- 4 MHz",
    Certificate_Ref: "",
    Updated_At: "05/Jun/23 12:00 AM (ago)"
  },
  {
    ID: "412",
    Identifier: "228696",
    Device_Name: "NORMAL PROBE",
    Device_Model: "MODSONIC M4SN",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "228696",
    Calibration_Due_Date: "30/5/2025",
    Active: "Yes",
    Specification: "24 mm Dia.- 4 MHz",
    Certificate_Ref: "",
    Updated_At: "05/Jun/23 12:00 AM (ago)"
  },
  {
    ID: "411",
    Identifier: "228643",
    Device_Name: "NORMAL PROBE",
    Device_Model: "MODSONIC M2SN",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "228643",
    Calibration_Due_Date: "30/5/2025",
    Active: "Yes",
    Specification: "24 mm Dia.- 2 MHz",
    Certificate_Ref: "",
    Updated_At: "05/Jun/23 12:00 AM (ago)"
  },
  {
    ID: "410",
    Identifier: "228642",
    Device_Name: "NORMAL PROBE",
    Device_Model: "MODSONIC M2SN",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "228642",
    Calibration_Due_Date: "30/5/2025",
    Active: "Yes",
    Specification: "24 mm Dia.- 2 MHz",
    Certificate_Ref: "",
    Updated_At: "05/Jun/23 12:00 AM (ago)"
  },
  {
    ID: "409",
    Identifier: "FC-83060",
    Device_Name: "UV LED TORCH",
    Device_Model: "FERROCHEM",
    Device_Type: "UV LED TORCH",
    Branch: "Pune",
    Device_Serial_Number: "FC-83060",
    Calibration_Due_Date: "19/8/2023",
    Active: "No",
    Specification: "365nm",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "408",
    Identifier: "DUVT-5K-89",
    Device_Name: "UV LED TORCH",
    Device_Model: "DNDT",
    Device_Type: "UV LED TORCH",
    Branch: "Pune",
    Device_Serial_Number: "DUVT-5K-89",
    Calibration_Due_Date: "27/1/2024",
    Active: "Yes",
    Specification: "365nm",
    Certificate_Ref: "",
    Updated_At: "16/May/23 12:00 AM (ago)"
  },
  {
    ID: "407",
    Identifier: "DUVT-5K-38",
    Device_Name: "UV LED TORCH",
    Device_Model: "DNDT",
    Device_Type: "UV LED TORCH",
    Branch: "Pune",
    Device_Serial_Number: "DUVT-5K-38",
    Calibration_Due_Date: "4/4/2024",
    Active: "Yes",
    Specification: "365nm",
    Certificate_Ref: "DNDT/CRT/ET01/26",
    Updated_At: "16/May/23 12:00 AM (ago)"
  },
  {
    ID: "406",
    Identifier: "DUVT-6K-179",
    Device_Name: "UV LED TORCH",
    Device_Model: "DNDT",
    Device_Type: "UV LED TORCH",
    Branch: "Pune",
    Device_Serial_Number: "DUVT-6K-179",
    Calibration_Due_Date: "26/1/2024",
    Active: "Yes",
    Specification: "365nm",
    Certificate_Ref: "DNDT/CRT/UV01/1015",
    Updated_At: "13/Mar/24 12:00 AM (ago)"
  },
  {
    ID: "405",
    Identifier: "DUVT-6K-178",
    Device_Name: "UV LIGHT",
    Device_Model: "DNDT",
    Device_Type: "UV LIGHT",
    Branch: "Pune",
    Device_Serial_Number: "DUVT-6K-178",
    Calibration_Due_Date: "26/1/2024",
    Active: "Yes",
    Specification: "365nm",
    Certificate_Ref: "DNDT/CRT/UV01/2014",
    Updated_At: "13/Mar/24 12:00 AM (ago)"
  },
  {
    ID: "404",
    Identifier: "9096",
    Device_Name: "ANGLE PROBE CURVATURE",
    Device_Model: "FALLON",
    Device_Type: "ANGLE PROBE CURVATURE",
    Branch: "Pune",
    Device_Serial_Number: "9096",
    Calibration_Due_Date: "31/12/2025",
    Active: "Yes",
    Specification: "4 MHz, 45\u00c2\u00ba 5 mm Dia.",
    Certificate_Ref: "",
    Updated_At: "27/Oct/23 12:00 AM (ago)"
  },
  {
    ID: "403",
    Identifier: "KQS/MT/LW/02",
    Device_Name: "LIFTING WEIGHT 5.15 KG",
    Device_Model: "-",
    Device_Type: "LIFTING WEIGHT",
    Branch: "Pune",
    Device_Serial_Number: "KQS/MT/LW/02",
    Calibration_Due_Date: "18/10/2024",
    Active: "Yes",
    Specification: "5.15 KG",
    Certificate_Ref: "PI221019-6-6",
    Updated_At: "20/Oct/23 12:00 AM (ago)"
  },
  {
    ID: "402",
    Identifier: "TW31/MF-01",
    Device_Name: "STATIONARY MACHINE \u00e2\u20ac\u201c4000 AMP",
    Device_Model: "TW31",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "TW31/MF-01",
    Calibration_Due_Date: "24/7/2023",
    Active: "No",
    Specification: "4000 AMP",
    Certificate_Ref: "HME/2500",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "401",
    Identifier: "76",
    Device_Name: "NORMAL PROBE",
    Device_Model: "Lenser,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "76",
    Calibration_Due_Date: "30/12/2025",
    Active: "Yes",
    Specification: "1MHz. Dia. 24 mm",
    Certificate_Ref: "",
    Updated_At: "16/May/23 12:00 AM (ago)"
  },
  {
    ID: "400",
    Identifier: "KQSPL/EL-YK/13",
    Device_Name: "ELECTROMAGNETIC YOKE",
    Device_Model: "MR56",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "0472 MR CHEMIE MAKE",
    Calibration_Due_Date: "18/11/2025",
    Active: "Yes",
    Specification: "Min. lifting Capacity 4.5 Kg.",
    Certificate_Ref: "---",
    Updated_At: "19/May/25 12:00 AM (ago)"
  },
  {
    ID: "399",
    Identifier: "VWIMT/02",
    Device_Name: "STATIONARY MACHINE -3000 AMP",
    Device_Model: "Hymech",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "VWIMT/02(Hymech Make)",
    Calibration_Due_Date: "14/7/2024",
    Active: "No",
    Specification: "0-3000AMP",
    Certificate_Ref: "",
    Updated_At: "14/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "398",
    Identifier: "223364",
    Device_Name: "NORMAL PROBE",
    Device_Model: "MM4SN",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "223364",
    Calibration_Due_Date: "20/5/2027",
    Active: "Yes",
    Specification: "4 MHz, 10 mm Dia.",
    Certificate_Ref: "",
    Updated_At: "25/Mar/23 12:00 AM (ago)"
  },
  {
    ID: "397",
    Identifier: "XAP17/10-16",
    Device_Name: "V1 CALIBRATION BLOCK",
    Device_Model: "X-RAY ACCESSORIES PRODUCTS",
    Device_Type: "V1 CALIBRATION BLOCK",
    Branch: "Pune",
    Device_Serial_Number: "XAP17/10-16",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "XAP17/10-16",
    Certificate_Ref: "",
    Updated_At: "12/Mar/23 12:00 AM (ago)"
  },
  {
    ID: "396",
    Identifier: "XAP17/10-02",
    Device_Name: "V1 CALIBRATION BLOCK",
    Device_Model: "X-RAY ACCESSORIES PRODUCTS",
    Device_Type: "V1 CALIBRATION BLOCK",
    Branch: "Pune",
    Device_Serial_Number: "XAP17/10-02",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "XAP17/10-02",
    Certificate_Ref: "",
    Updated_At: "12/Mar/23 12:00 AM (ago)"
  },
  {
    ID: "395",
    Identifier: "17/10-K52-CS",
    Device_Name: "V2 CALIBRATION BLOCK",
    Device_Model: "X-RAY ACCESSORIES PRODUCTS",
    Device_Type: "V2 CALIBRATION BLOCK",
    Branch: "Pune",
    Device_Serial_Number: "17/10-K52-CS",
    Calibration_Due_Date: "24/5/2025",
    Active: "Yes",
    Specification: "17/10-K52-CS",
    Certificate_Ref: "",
    Updated_At: "13/Mar/24 12:00 AM (ago)"
  },
  {
    ID: "394",
    Identifier: "LE-13-14",
    Device_Name: "V2 CALIBRATION BLOCK",
    Device_Model: "X-RAY ACCESSORIES PRODUCTS",
    Device_Type: "V2 CALIBRATION BLOCK",
    Branch: "Pune",
    Device_Serial_Number: "LE-13-14",
    Calibration_Due_Date: "24/5/2025",
    Active: "Yes",
    Specification: "LE-13-14",
    Certificate_Ref: "",
    Updated_At: "13/Mar/24 12:00 AM (ago)"
  },
  {
    ID: "393",
    Identifier: "LE-13-12",
    Device_Name: "V2 CALIBRATION BLOCK",
    Device_Model: "X-RAY ACCESSORIES PRODUCTS",
    Device_Type: "V2 CALIBRATION BLOCK",
    Branch: "Pune",
    Device_Serial_Number: "LE-13-12",
    Calibration_Due_Date: "24/5/2025",
    Active: "Yes",
    Specification: "LE-13-12",
    Certificate_Ref: "",
    Updated_At: "13/Mar/24 12:00 AM (ago)"
  },
  {
    ID: "392",
    Identifier: "2019027",
    Device_Name: "V2 CALIBRATION BLOCK",
    Device_Model: "Kirti NDT",
    Device_Type: "V2 CALIBRATION BLOCK",
    Branch: "Pune",
    Device_Serial_Number: "2019027",
    Calibration_Due_Date: "24/5/2025",
    Active: "Yes",
    Specification: "2019027",
    Certificate_Ref: "",
    Updated_At: "13/Mar/24 12:00 AM (ago)"
  },
  {
    ID: "391",
    Identifier: "2019022",
    Device_Name: "V2 CALIBRATION BLOCK",
    Device_Model: "X-RAY ACCESSORIES PRODUCTS",
    Device_Type: "V2 CALIBRATION BLOCK",
    Branch: "Pune",
    Device_Serial_Number: "2019022",
    Calibration_Due_Date: "6/3/2025",
    Active: "Yes",
    Specification: "2019022",
    Certificate_Ref: "",
    Updated_At: "13/Mar/24 12:00 AM (ago)"
  },
  {
    ID: "390",
    Identifier: "2019021",
    Device_Name: "V2 CALIBRATION BLOCK",
    Device_Model: "Kirti NDT",
    Device_Type: "V2 CALIBRATION BLOCK",
    Branch: "Pune",
    Device_Serial_Number: "2019021",
    Calibration_Due_Date: "6/3/2025",
    Active: "Yes",
    Specification: "2019021",
    Certificate_Ref: "",
    Updated_At: "13/Mar/24 12:00 AM (ago)"
  },
  {
    ID: "389",
    Identifier: "2019028",
    Device_Name: "V2 CALIBRATION BLOCK",
    Device_Model: "X-RAY ACCESSORIES PRODUCTS",
    Device_Type: "V2 CALIBRATION BLOCK",
    Branch: "Pune",
    Device_Serial_Number: "2019028",
    Calibration_Due_Date: "6/3/2025",
    Active: "Yes",
    Specification: "2019028",
    Certificate_Ref: "",
    Updated_At: "13/Mar/24 12:00 AM (ago)"
  },
  {
    ID: "388",
    Identifier: "747252018",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "747252018",
    Calibration_Due_Date: "24/5/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "10/May/23 12:00 AM (ago)"
  },
  {
    ID: "387",
    Identifier: "221583",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "221583",
    Calibration_Due_Date: "24/5/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "10/May/23 12:00 AM (ago)"
  },
  {
    ID: "386",
    Identifier: "222737",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "222737",
    Calibration_Due_Date: "24/5/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 60 Deg.",
    Certificate_Ref: "",
    Updated_At: "10/May/23 12:00 AM (ago)"
  },
  {
    ID: "385",
    Identifier: "747292018",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "747292018",
    Calibration_Due_Date: "24/5/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 70 Deg.",
    Certificate_Ref: "",
    Updated_At: "10/May/23 12:00 AM (ago)"
  },
  {
    ID: "384",
    Identifier: "220842",
    Device_Name: "NORMAL PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "220842",
    Calibration_Due_Date: "24/5/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "10/May/23 12:00 AM (ago)"
  },
  {
    ID: "383",
    Identifier: "1263",
    Device_Name: "TR PROBE",
    Device_Model: "Modsonic",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1263",
    Calibration_Due_Date: "24/5/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 20 mm",
    Certificate_Ref: "",
    Updated_At: "10/May/23 12:00 AM (ago)"
  },
  {
    ID: "382",
    Identifier: "1731",
    Device_Name: "NORMAL PROBE",
    Device_Model: "Lensar",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1731",
    Calibration_Due_Date: "24/5/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 24 mm",
    Certificate_Ref: "",
    Updated_At: "10/May/23 12:00 AM (ago)"
  },
  {
    ID: "381",
    Identifier: "504853014",
    Device_Name: "NORMAL PROBE",
    Device_Model: "Lensar",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "504853014",
    Calibration_Due_Date: "24/5/2025",
    Active: "Yes",
    Specification: "2MHz. Dia. 24 mm",
    Certificate_Ref: "",
    Updated_At: "10/May/23 12:00 AM (ago)"
  },
  {
    ID: "380",
    Identifier: "1924",
    Device_Name: "NORMAL PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1924",
    Calibration_Due_Date: "24/5/2025",
    Active: "Yes",
    Specification: "2MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "10/May/23 12:00 AM (ago)"
  },
  {
    ID: "379",
    Identifier: "222955",
    Device_Name: "TR PROBE",
    Device_Model: "Modsonic",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "222955",
    Calibration_Due_Date: "30/6/2027",
    Active: "Yes",
    Specification: "4MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "03/Oct/23 12:00 AM (ago)"
  },
  {
    ID: "378",
    Identifier: "KQSPL/UV-LX/03",
    Device_Name: "UV METER",
    Device_Model: "DUVM207",
    Device_Type: "UV METER",
    Branch: "Pune",
    Device_Serial_Number: "210570",
    Calibration_Due_Date: "15/5/2025",
    Active: "Yes",
    Specification: "365 nm",
    Certificate_Ref: "681/23",
    Updated_At: "12/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "377",
    Identifier: "SPC1/RFI/01",
    Device_Name: "GAUSS METER",
    Device_Model: "Dyglo",
    Device_Type: "GAUSS METER",
    Branch: "Pune",
    Device_Serial_Number: "268",
    Calibration_Due_Date: "7/5/2023",
    Active: "No",
    Specification: "0-10 Guass",
    Certificate_Ref: "DY/CAL/6827-22",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "376",
    Identifier: "KQSPL/UV-LX/03",
    Device_Name: "LUX METER",
    Device_Model: "DUVM207",
    Device_Type: "LUX METER",
    Branch: "Pune",
    Device_Serial_Number: "210570",
    Calibration_Due_Date: "15/5/2025",
    Active: "Yes",
    Specification: "365 nm",
    Certificate_Ref: "717/24",
    Updated_At: "25/Dec/24 12:00 AM (ago)"
  },
  {
    ID: "375",
    Identifier: "SPC1/MPI-3000-CF/01",
    Device_Name: "STATIONARY MACHINE -3000AMP",
    Device_Model: "DY-3000-CF",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "98368",
    Calibration_Due_Date: "4/5/2025",
    Active: "Yes",
    Specification: "0-3000AMP",
    Certificate_Ref: "DY/CAL/6845-22",
    Updated_At: "22/Nov/24 12:00 AM (ago)"
  },
  {
    ID: "351",
    Identifier: "KQSPL/LX-HT/06",
    Device_Name: "LUX METER",
    Device_Model: "HTC",
    Device_Type: "LUX METER",
    Branch: "Pune",
    Device_Serial_Number: "2136446",
    Calibration_Due_Date: "13/9/2025",
    Active: "Yes",
    Specification: "365 nm",
    Certificate_Ref: "GTS/2403/5/03-001",
    Updated_At: "30/Apr/25 12:00 AM (ago)"
  },
  {
    ID: "350",
    Identifier: "KQSPL/EL-YK/12",
    Device_Name: "ELECTROMAGNETIC YOKE",
    Device_Model: "HYMECH",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "242 HYMECH MAKE",
    Calibration_Due_Date: "18/11/2025",
    Active: "Yes",
    Specification: "Min. lifting Capacity 4.5 Kg.",
    Certificate_Ref: "KQSPL/CAL/YK/2023/14",
    Updated_At: "19/May/25 12:00 AM (ago)"
  },
  {
    ID: "333",
    Identifier: "---",
    Device_Name: "ANGLE PROBE  CURVATURE",
    Device_Model: "Fallon",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "---",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHZ, 45 Deg.  CURVATURE",
    Certificate_Ref: "",
    Updated_At: "27/Mar/22 12:00 AM (ago)"
  },
  {
    ID: "332",
    Identifier: "KQSPL/EL-YK/14",
    Device_Name: "ELECTROMAGNETIC YOKE",
    Device_Model: "SIMS-Y A/D",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "2.02302E+11",
    Calibration_Due_Date: "18/11/2025",
    Active: "Yes",
    Specification: "Min. lifting Capacity 4.5 Kg.",
    Certificate_Ref: "KQSPL/CAL/YK/2023/48",
    Updated_At: "19/May/25 12:00 AM (ago)"
  },
  {
    ID: "331",
    Identifier: "80",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "80",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 38 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "330",
    Identifier: "79",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "79",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 38 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "329",
    Identifier: "114",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "114",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 35 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "328",
    Identifier: "113",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "113",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 35 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "327",
    Identifier: "5154",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5154",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 70 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "326",
    Identifier: "2866",
    Device_Name: "NORMAL PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "2866",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz. Dia. 24 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "325",
    Identifier: "1640",
    Device_Name: "NORMAL PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1640",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 24 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "324",
    Identifier: "5422",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5422",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 70 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "323",
    Identifier: "4093",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "4093",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 60 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "322",
    Identifier: "4493",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "4493",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "321",
    Identifier: "1626",
    Device_Name: "NORMAL PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1626",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz. Dia. 24 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "320",
    Identifier: "56929-89074",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "56929-89074",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 70 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "319",
    Identifier: "57746-57174",
    Device_Name: "NORMAL PROBE",
    Device_Model: "GE",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "57746-57174",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 24 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "318",
    Identifier: "16605",
    Device_Name: "NORMAL PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "16605",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz. Dia. 24 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "317",
    Identifier: "1731",
    Device_Name: "NORMAL PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1731",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz. Dia. 24 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "316",
    Identifier: "4584",
    Device_Name: "NORMAL PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "4584",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "6MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "315",
    Identifier: "1249",
    Device_Name: "NORMAL PROBE",
    Device_Model: "Lensar",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1249",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 14 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "314",
    Identifier: "2554",
    Device_Name: "NORMAL PROBE",
    Device_Model: "Lensar",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "2554",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "1MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "313",
    Identifier: "269BAI",
    Device_Name: "NORMAL PROBE",
    Device_Model: "PI",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "269BAI",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "312",
    Identifier: "246EAH",
    Device_Name: "T/R PROBE",
    Device_Model: "PI",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "246EAH",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "311",
    Identifier: "304",
    Device_Name: "T/R PROBE",
    Device_Model: "Lensar",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "304",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "310",
    Identifier: "249",
    Device_Name: "T/R PROBE",
    Device_Model: "Lensar",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "249",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "309",
    Identifier: "071CAG",
    Device_Name: "T/R PROBE",
    Device_Model: "PI",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "071CAG",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz. Dia. 24 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "308",
    Identifier: "VS/4293",
    Device_Name: "T/R PROBE",
    Device_Model: "Lensar",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "VS/4293",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "307",
    Identifier: "103",
    Device_Name: "T/R PROBE",
    Device_Model: "GE",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "103",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz. Dia. 20 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "306",
    Identifier: "205",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Lensar",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "205",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz 14X14mm, 60 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "305",
    Identifier: "2114",
    Device_Name: "ANGLE PROBE",
    Device_Model: "KRAUTKRAMER",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "2114",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "304",
    Identifier: "2106",
    Device_Name: "ANGLE PROBE",
    Device_Model: "KRAUTKRAMER",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "2106",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "303",
    Identifier: "151",
    Device_Name: "T/R PROBE",
    Device_Model: "Lensar",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "151",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 70 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "302",
    Identifier: "2480",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Lensar",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "2480",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 70 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "301",
    Identifier: "115",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Lensar",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "115",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 80 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "300",
    Identifier: "52",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Lensar",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "52",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz, 8X9mm, 90 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "299",
    Identifier: "533",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Lensar",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "533",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 60 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "298",
    Identifier: "17",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Lensar",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "17",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz, 8X9mm, 60 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "297",
    Identifier: "10",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Lensar",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "10",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz, 8X9mm, 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "296",
    Identifier: "301",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Lensar",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "301",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz, 8X9mm, 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "295",
    Identifier: "206JAS",
    Device_Name: "ANGLE PROBE",
    Device_Model: "PI",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "206JAS",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "294",
    Identifier: "319AAF",
    Device_Name: "ANGLE PROBE",
    Device_Model: "PI",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "319AAF",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "293",
    Identifier: "429JAC",
    Device_Name: "ANGLE PROBE",
    Device_Model: "PI",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "429JAC",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "292",
    Identifier: "4074",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "4074",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 70 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "291",
    Identifier: "4072",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "4072",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 70 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "290",
    Identifier: "6066",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "6066",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 70 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "289",
    Identifier: "6543",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "6543",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 70 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "288",
    Identifier: "3653",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "3653",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 60 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "287",
    Identifier: "3335",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "3335",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 60 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "286",
    Identifier: "4094",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "4094",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 60 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "285",
    Identifier: "3616",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "3616",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 45 Deg.,",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "284",
    Identifier: "3617",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "3617",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 45 Deg.,",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "283",
    Identifier: "4466",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "4466",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 45 Deg.,",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "282",
    Identifier: "4660",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "4660",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 45 Deg.,",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "281",
    Identifier: "1302",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1302",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 60 Deg.,",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "280",
    Identifier: "5149",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5149",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 45 Deg.,",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "279",
    Identifier: "4330",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "4330",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8X9mm, 70 Deg.,",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "278",
    Identifier: "1152",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1152",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz, 8X9mm, 60 Deg.,",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "277",
    Identifier: "201",
    Device_Name: "NORMAL PROBE",
    Device_Model: "Lensar",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "201",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "276",
    Identifier: "5671",
    Device_Name: "NORMAL PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5671",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "275",
    Identifier: "8792",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "8792",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8x9mm, 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "274",
    Identifier: "1262",
    Device_Name: "T/R PROBE",
    Device_Model: "Modsonic",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1262",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 24 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "273",
    Identifier: "1107",
    Device_Name: "T/R PROBE",
    Device_Model: "Modsonic",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1107",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 20 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "272",
    Identifier: "5466",
    Device_Name: "T/R PROBE",
    Device_Model: "Modsonic",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5466",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "271",
    Identifier: "3987",
    Device_Name: "NORMAL PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "3987",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz. Dia. 24 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "270",
    Identifier: "3986",
    Device_Name: "NORMAL PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "3986",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz. Dia. 24 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "269",
    Identifier: "1870",
    Device_Name: "NORMAL PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1870",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "268",
    Identifier: "707",
    Device_Name: "T/R PROBE",
    Device_Model: "Modsonic",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "707",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "267",
    Identifier: "1180",
    Device_Name: "T/R PROBE",
    Device_Model: "Modsonic",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1180",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 20 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "266",
    Identifier: "5762",
    Device_Name: "T/R PROBE",
    Device_Model: "Modsonic",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5762",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "265",
    Identifier: "5660",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5660",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8 X 9 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "264",
    Identifier: "5324",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5324",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8x9mm, 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "263",
    Identifier: "5790",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5790",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8x9mm, 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "262",
    Identifier: "6926",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "6926",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8x9mm, 70 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "261",
    Identifier: "5346",
    Device_Name: "NORMAL PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5346",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "260",
    Identifier: "57469 - 53335",
    Device_Name: "T/R PROBE",
    Device_Model: "GE",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "57469 - 53335",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "SEB 4, 4MHz, 6 X 20 Dia.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "259",
    Identifier: "57001 - 53827",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "57001 - 53827",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2 MHz, 20 X 22, 70 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "258",
    Identifier: "57000 - 53449",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "57000 - 53449",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2 MHz, 20 X 22, 60 Deg.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "257",
    Identifier: "56999 - 55010",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "56999 - 55010",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz, 20 X 22, 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "256",
    Identifier: "58416 - 53064",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "58416 - 53064",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "SWB 70 2Z 14x14 A70 Deg.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "255",
    Identifier: "58415 - 53031",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "58415 - 53031",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "SWB 60 2Z 14x14 A60 Deg.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "254",
    Identifier: "58414 - 52906",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "58414 - 52906",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "SWB 45 2Z 14x14 A45 Deg.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "253",
    Identifier: "88278",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "88278",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8x9mm, 70 Deg.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "252",
    Identifier: "89074",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "89074",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8x9mm, 70 Deg.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "251",
    Identifier: "80907",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "80907",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8x9mm, 60 Deg.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "250",
    Identifier: "83146",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "83146",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz 8x9mm, 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "249",
    Identifier: "85239",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "85239",
    Calibration_Due_Date: "31/8/2025",
    Active: "Yes",
    Specification: "2MHz 45 14X14mm, (85239)",
    Certificate_Ref: "",
    Updated_At: "16/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "248",
    Identifier: "1495",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1495",
    Calibration_Due_Date: "31/1/2025",
    Active: "Yes",
    Specification: "2MHz 8X9mm, 70 (1495)",
    Certificate_Ref: "",
    Updated_At: "16/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "247",
    Identifier: "61353",
    Device_Name: "NORMAL PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "61353",
    Calibration_Due_Date: "31/1/2025",
    Active: "Yes",
    Specification: "4MHz, Dia. 24 mm",
    Certificate_Ref: "",
    Updated_At: "16/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "246",
    Identifier: "54",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Lensor",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "54",
    Calibration_Due_Date: "10/1/2025",
    Active: "Yes",
    Specification: "8x9mm, 35 Deg, 4MHz",
    Certificate_Ref: "",
    Updated_At: "18/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "245",
    Identifier: "444",
    Device_Name: "NORMAL PROBE",
    Device_Model: "Lensor",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "444",
    Calibration_Due_Date: "31/1/2025",
    Active: "Yes",
    Specification: "4MHz, Dia 10 mm",
    Certificate_Ref: "",
    Updated_At: "16/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "244",
    Identifier: "190103",
    Device_Name: "PROBE",
    Device_Model: "Fallon",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "190103",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "NHR10S.06.10",
    Certificate_Ref: "",
    Updated_At: "05/Jan/22 12:00 AM (ago)"
  },
  {
    ID: "243",
    Identifier: "1924",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1924",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "242",
    Identifier: "37248",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "37248",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "BW 70-N2 2MHz 20x22 mm, 70 Deg.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "241",
    Identifier: "2533",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "2533",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "BW 45-N2 2MHz 20x22mm, 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "240",
    Identifier: "36336",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "36336",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "BW 70-N2, 2MHz, 20x22mm, 70 Deg.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "239",
    Identifier: "53520",
    Device_Name: "PROBE",
    Device_Model: "GE (K)",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "53520",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "WB 60-N4 4MHz 20X22mm 60 Deg.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "238",
    Identifier: "53471",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE (K)",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "53471",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "WB 70-N2 2MHz 20X22mm 70 Deg.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "237",
    Identifier: "1179",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1179",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 20 mm",
    Certificate_Ref: "",
    Updated_At: "15/Oct/23 12:00 AM (ago)"
  },
  {
    ID: "236",
    Identifier: "1261",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1261",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 20 mm",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "235",
    Identifier: "1166",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1166",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 20 mm",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "234",
    Identifier: "1263",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1263",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 20 mm",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "233",
    Identifier: "3690",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "3690",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz. Dia. 24 mm",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "232",
    Identifier: "4633",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "4633",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "231",
    Identifier: "5304",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5304",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "13/Mar/22 12:00 AM (ago)"
  },
  {
    ID: "230",
    Identifier: "37",
    Device_Name: "NORMAL PROBE",
    Device_Model: "Lensar",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "37",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "229",
    Identifier: "5322",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5322",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8x9mm, 60 Deg.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "228",
    Identifier: "4509",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "4509",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHzn 8x9mm, 60 Deg.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "227",
    Identifier: "2720",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "2720",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz, 8x9mm, 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "226",
    Identifier: "1599",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1599",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz, 8x9mm, 60 Deg.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "225",
    Identifier: "6126",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "6126",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8x9mm, 70 Deg.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "224",
    Identifier: "5320",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5320",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8x9mm, 60 Deg.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "223",
    Identifier: "5720",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5720",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 8x9mm, 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "222",
    Identifier: "4465",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "4465",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz 8x9mm,45 (4465)",
    Certificate_Ref: "",
    Updated_At: "05/Jan/22 12:00 AM (ago)"
  },
  {
    ID: "221",
    Identifier: "973",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "973",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 24 mm",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "220",
    Identifier: "5764",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5764",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "Curvature Radius 4MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "10/Jun/24 12:00 AM (ago)"
  },
  {
    ID: "219",
    Identifier: "787",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "787",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "218",
    Identifier: "4809",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "4809",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "217",
    Identifier: "5311",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5311",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz 8X9mm, 70 (5311)",
    Certificate_Ref: "",
    Updated_At: "05/Jan/22 12:00 AM (ago)"
  },
  {
    ID: "216",
    Identifier: "6925",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "6925",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz 8X9mm, 70 Deg.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "215",
    Identifier: "5321",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5321",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz 8X9mm, 60 (5321)",
    Certificate_Ref: "",
    Updated_At: "05/Jan/22 12:00 AM (ago)"
  },
  {
    ID: "214",
    Identifier: "5791",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5791",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz 8X9mm, 45 (5791)",
    Certificate_Ref: "",
    Updated_At: "05/Jan/22 12:00 AM (ago)"
  },
  {
    ID: "213",
    Identifier: "5465",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5465",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHZ. 8X9 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "212",
    Identifier: "1922",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1922",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "211",
    Identifier: "4964",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "4964",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "210",
    Identifier: "L-128",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Lensar",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "L-128",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz 14X14mm, 60 Deg.",
    Certificate_Ref: "",
    Updated_At: "15/Oct/23 12:00 AM (ago)"
  },
  {
    ID: "209",
    Identifier: "L-127",
    Device_Name: "PROBE",
    Device_Model: "Lensar",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "L-127",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz 14X14mm, 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "208",
    Identifier: "4327",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "4327",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz 8X9mm, 70 (4327)",
    Certificate_Ref: "",
    Updated_At: "05/Jan/22 12:00 AM (ago)"
  },
  {
    ID: "207",
    Identifier: "215",
    Device_Name: "PROBE",
    Device_Model: "Lensar",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "215",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "206",
    Identifier: "5148",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5148",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "205",
    Identifier: "1738",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1738",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 24 mm",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "204",
    Identifier: "5669",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5669",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz Dia.10 mm",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "203",
    Identifier: "486",
    Device_Name: "PROBE",
    Device_Model: "Lensar",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "486",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz 8X9mm, 60 (486)",
    Certificate_Ref: "",
    Updated_At: "05/Jan/22 12:00 AM (ago)"
  },
  {
    ID: "202",
    Identifier: "747262018",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "747262018",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz 8X9mm, 45 (747262018)",
    Certificate_Ref: "",
    Updated_At: "05/Jan/22 12:00 AM (ago)"
  },
  {
    ID: "201",
    Identifier: "6065",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "6065",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz 8X9mm, 70 (6065)",
    Certificate_Ref: "",
    Updated_At: "05/Jan/22 12:00 AM (ago)"
  },
  {
    ID: "200",
    Identifier: "85245",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "85245",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz, 14 X 14mm,60 (85245)",
    Certificate_Ref: "",
    Updated_At: "05/Jan/22 12:00 AM (ago)"
  },
  {
    ID: "199",
    Identifier: "381",
    Device_Name: "PROBE",
    Device_Model: "Lensar",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "381",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "198",
    Identifier: "3571",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "3571",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "197",
    Identifier: "7640",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "7640",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 24 mm",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "196",
    Identifier: "1406",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1406",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "MBW 70 N2 8x9mm 70,2MHz, (1406)",
    Certificate_Ref: "",
    Updated_At: "05/Jan/22 12:00 AM (ago)"
  },
  {
    ID: "195",
    Identifier: "6544",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "6544",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "MBW 70 N4 8x9mm 70,4MHz,(6544)",
    Certificate_Ref: "",
    Updated_At: "05/Jan/22 12:00 AM (ago)"
  },
  {
    ID: "194",
    Identifier: "4910",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "4910",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "MBW 60 N4 8x9mm 60,4MHz,(4910)",
    Certificate_Ref: "",
    Updated_At: "05/Jan/22 12:00 AM (ago)"
  },
  {
    ID: "193",
    Identifier: "5792",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5792",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "MBW 45 N4 8x9mm 45,4MHz, (5792)",
    Certificate_Ref: "",
    Updated_At: "05/Jan/22 12:00 AM (ago)"
  },
  {
    ID: "192",
    Identifier: "1425",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1425",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "MBW 45 N2 8x9mm 45,2MHz,(1425)",
    Certificate_Ref: "",
    Updated_At: "05/Jan/22 12:00 AM (ago)"
  },
  {
    ID: "191",
    Identifier: "216",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "216",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "190",
    Identifier: "5305",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5305",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "189",
    Identifier: "5465",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5465",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "188",
    Identifier: "1838",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1838",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "187",
    Identifier: "1720",
    Device_Name: "PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1720",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz, 45 Deg 8x9 mm",
    Certificate_Ref: "",
    Updated_At: "03/Jan/22 12:00 AM (ago)"
  },
  {
    ID: "186",
    Identifier: "KQSPL/UTG/OLM/DL/04",
    Device_Name: "ULTRASONIC THICKNESS GAUGE",
    Device_Model: "38DL PLUS",
    Device_Type: "ULTRASONIC THICKNESS GAUGE",
    Branch: "Pune",
    Device_Serial_Number: "213868411",
    Calibration_Due_Date: "17/11/2024",
    Active: "Yes",
    Specification: "",
    Certificate_Ref: "PL/23/11/615",
    Updated_At: "20/Nov/23 12:00 AM (ago)"
  },
  {
    ID: "185",
    Identifier: "KQSPL/UFD/GE/09",
    Device_Name: "DIGITAL ULTRASONIC FLAW DETECTOR",
    Device_Model: "USN60",
    Device_Type: "ULTRASONIC FLAW DETECTOR",
    Branch: "Pune",
    Device_Serial_Number: "SNDT/UFD/2224/KQSPL",
    Calibration_Due_Date: "19/9/2025",
    Active: "Yes",
    Specification: "",
    Certificate_Ref: "SNDT/UFD/2334/KQSPL",
    Updated_At: "21/Sep/24 12:00 AM (ago)"
  },
  {
    ID: 184,
    Identifier: "KQSPL/HRD/CT/01",
    Device_Name: "PORTABLE HARDNESS TESTING",
    Device_Model: "EP04-013-0043 C1",
    Device_Type: "HARDNESS TESTER",
    Branch: "Pune",
    Device_Serial_Number: "HD03-104-0049B",
    Calibration_Due_Date: "01/12/2026",
    Active: "Yes",
    Specification: "",
    Certificate_Ref: "PL/23/11/617",
    Updated_At: "06/Apr/26 12:00 AM (ago)"
  },
  {
    ID: "183",
    Identifier: "KQSPL/UFD/GE/08",
    Device_Name: "ULTRASONIC FLAW DETECTOR",
    Device_Model: "USMGO",
    Device_Type: "ULTRASONIC FLAW DETECTOR",
    Branch: "Pune",
    Device_Serial_Number: "USMGO10090273",
    Calibration_Due_Date: "19/9/2025",
    Active: "Yes",
    Specification: "",
    Certificate_Ref: "SNDT/UFD/2333/KQSPL",
    Updated_At: "05/Apr/25 12:00 AM (ago)"
  },
  {
    ID: "181",
    Identifier: "KQSPL/EL-YK/11",
    Device_Name: "ELECTROMAGNETIC YOKE",
    Device_Model: "SUPERMAG",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "SMY122021580 - SUPERMAG MAKE",
    Calibration_Due_Date: "18/11/2025",
    Active: "Yes",
    Specification: "Min. lifting Capacity 4.5 Kg.",
    Certificate_Ref: "KQSPL/CAL/YK/2022/18",
    Updated_At: "19/May/25 12:00 AM (ago)"
  },
  {
    ID: "180",
    Identifier: "KQSPL/LX-LT/03",
    Device_Name: "LUX METER",
    Device_Model: "Lux Meter",
    Device_Type: "Lux Meter",
    Branch: "Pune",
    Device_Serial_Number: "T.007016",
    Calibration_Due_Date: "20/12/2025",
    Active: "Yes",
    Specification: "0-400,000 Lux",
    Certificate_Ref: "GTS/231105/02-001",
    Updated_At: "28/Dec/24 12:00 AM (ago)"
  },
  {
    ID: "179",
    Identifier: "KQSPL/RFI/05",
    Device_Name: "Residual Field Indicator",
    Device_Model: "DYEGLO",
    Device_Type: "RFI",
    Branch: "Pune",
    Device_Serial_Number: "962",
    Calibration_Due_Date: "15/7/2025",
    Active: "Yes",
    Specification: "-10-0-+10 GAUSS",
    Certificate_Ref: "SIMS/KQSPL/62/25",
    Updated_At: "28/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "178",
    Identifier: "KQSPL/RFI/06",
    Device_Name: "Residual Field Indicator",
    Device_Model: "DYEGLO",
    Device_Type: "RFI",
    Branch: "Pune",
    Device_Serial_Number: "963",
    Calibration_Due_Date: "15/7/2025",
    Active: "Yes",
    Specification: "-10-0-+10 GAUSS",
    Certificate_Ref: "SIMS/KQSPL/63/25",
    Updated_At: "28/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "177",
    Identifier: "5469",
    Device_Name: "PROBE",
    Device_Model: "MM4SN",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5469",
    Calibration_Due_Date: "11/6/2025",
    Active: "Yes",
    Specification: "10 Dia 4 MHz",
    Certificate_Ref: "15/6/2025",
    Updated_At: "15/Jun/21 12:00 AM (ago)"
  },
  {
    ID: "176",
    Identifier: "KQSPL/UFD/GE/06",
    Device_Name: "Digital Ultrasonic Flaw Detector",
    Device_Model: "USM GO PLUS",
    Device_Type: "Ultrasonic Flaw Detector",
    Branch: "Pune",
    Device_Serial_Number: "GOPLS19010101",
    Calibration_Due_Date: "20/5/2026",
    Active: "Yes",
    Specification: "USM GO PLUS",
    Certificate_Ref: "SNDT/UFD/2317/KQSPL",
    Updated_At: "04/Jun/25 12:00 AM (ago)"
  },
  {
    ID: "169",
    Identifier: "54577/2283",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "54577/2283",
    Calibration_Due_Date: "13/7/2025",
    Active: "Yes",
    Specification: "VSY 45-4MHz,, Longitudinal Angle Probe",
    Certificate_Ref: "",
    Updated_At: "23/Jan/24 12:00 AM (ago)"
  },
  {
    ID: "168",
    Identifier: "226206",
    Device_Name: "NORMAL PROBE",
    Device_Model: "MODSONIC",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "226206",
    Calibration_Due_Date: "13/7/2027",
    Active: "Yes",
    Specification: "2 MHz, Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "23/Feb/24 12:00 AM (ago)"
  },
  {
    ID: "167",
    Identifier: "54579/5096",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "54579/5096",
    Calibration_Due_Date: "13/7/2025",
    Active: "Yes",
    Specification: "VSY 70-4 MHz,, Longitudinal Angle Probe",
    Certificate_Ref: "",
    Updated_At: "23/Jan/24 12:00 AM (ago)"
  },
  {
    ID: "166",
    Identifier: "54578/2282",
    Device_Name: "ANGLE PROBE",
    Device_Model: "GE,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "54578/2282",
    Calibration_Due_Date: "13/7/2025",
    Active: "Yes",
    Specification: "VSY 60-4 MHz, Longitudinal Angle Probe",
    Certificate_Ref: "",
    Updated_At: "23/Jan/24 12:00 AM (ago)"
  },
  {
    ID: "165",
    Identifier: "57469",
    Device_Name: "TR Probe",
    Device_Model: "Modsonic",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "57469",
    Calibration_Due_Date: "30/6/2020",
    Active: "No",
    Specification: "4 MHz, Dia. 20 mm",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "164",
    Identifier: "5688",
    Device_Name: "TR Probe",
    Device_Model: "Modsonic",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5688",
    Calibration_Due_Date: "30/6/2020",
    Active: "No",
    Specification: "4 MHz, Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "163",
    Identifier: "1399",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1399",
    Calibration_Due_Date: "30/6/2020",
    Active: "No",
    Specification: "2MHz, 8X9, 60 Deg.",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "162",
    Identifier: "57745-74973",
    Device_Name: "NORMAL PROBE",
    Device_Model: "GE",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "57745-74973",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "2MHz, 24mm Dia,",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "161",
    Identifier: "25",
    Device_Name: "Probe",
    Device_Model: "Modsonic, 2MHz,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "25",
    Calibration_Due_Date: "31/12/2021",
    Active: "No",
    Specification: "14x14 mm, 45 Deg,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "160",
    Identifier: "18",
    Device_Name: "Probe",
    Device_Model: "2MHz,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "18",
    Calibration_Due_Date: "31/12/2021",
    Active: "No",
    Specification: "14x14mm, 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "159",
    Identifier: "15",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Lensar",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "15",
    Calibration_Due_Date: "31/12/2021",
    Active: "No",
    Specification: "AP 45-2 2MHz 20x22, 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "158",
    Identifier: "78344/18",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "78344/18",
    Calibration_Due_Date: "31/1/2021",
    Active: "No",
    Specification: "2MHz,14x14mm 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "157",
    Identifier: "78345/15",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "78345/15",
    Calibration_Due_Date: "31/1/2021",
    Active: "No",
    Specification: "2MHz,14x14mm, 60 Deg.",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "156",
    Identifier: "KQSPL - 4",
    Device_Name: "Stationary Machine 3000Amp",
    Device_Model: "Hymech 603",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "KQSPL - 04",
    Calibration_Due_Date: "2/12/2021",
    Active: "No",
    Specification: "Hymech 603",
    Certificate_Ref: "HME/1301",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "155",
    Identifier: "KQS/MT/LW/03B",
    Device_Name: "LIFTING WEIGHT 18.340 KG",
    Device_Model: "-",
    Device_Type: "LIFTING WEIGHT",
    Branch: "Pune",
    Device_Serial_Number: "KQS/MT/LW/03B",
    Calibration_Due_Date: "18/10/2024",
    Active: "Yes",
    Specification: "18.340 Kg",
    Certificate_Ref: "PI221019-6-2",
    Updated_At: "20/Oct/23 12:00 AM (ago)"
  },
  {
    ID: "154",
    Identifier: "KQS/MT/LW/05",
    Device_Name: "LIFTING WEIGHT 23.150 KG",
    Device_Model: "-",
    Device_Type: "LIFTING WEIGHT",
    Branch: "Pune",
    Device_Serial_Number: "KQS/MT/LW/05",
    Calibration_Due_Date: "18/10/2024",
    Active: "Yes",
    Specification: "23.150 Kg",
    Certificate_Ref: "PI221019-6-1",
    Updated_At: "20/Oct/23 12:00 AM (ago)"
  },
  {
    ID: "153",
    Identifier: "KQS/MT/LW/03A",
    Device_Name: "LIFTING WEIGHT 13.680 KG",
    Device_Model: "-",
    Device_Type: "LIFTING WEIGHT",
    Branch: "Pune",
    Device_Serial_Number: "KQS/MT/LW/03A",
    Calibration_Due_Date: "18/10/2024",
    Active: "Yes",
    Specification: "13.680 Kg",
    Certificate_Ref: "PI221019-6-3",
    Updated_At: "20/Oct/23 12:00 AM (ago)"
  },
  {
    ID: "152",
    Identifier: "KQS/MT/LW/03",
    Device_Name: "LIFTING WEIGHT 4.807KG",
    Device_Model: "-",
    Device_Type: "LIFTING WEIGHT",
    Branch: "Pune",
    Device_Serial_Number: "KQS/MT/LW/03",
    Calibration_Due_Date: "18/10/2024",
    Active: "Yes",
    Specification: "4.807Kg",
    Certificate_Ref: "PI221019-6-5",
    Updated_At: "20/Oct/23 12:00 AM (ago)"
  },
  {
    ID: "151",
    Identifier: "KQS/MT/LW/04",
    Device_Name: "LIFTING WEIGHT 4.805 KG",
    Device_Model: "-",
    Device_Type: "LIFTING WEIGHT",
    Branch: "Pune",
    Device_Serial_Number: "KQS/MT/LW/04",
    Calibration_Due_Date: "18/10/2024",
    Active: "Yes",
    Specification: "4.805 Kg",
    Certificate_Ref: "PI221019-6-4",
    Updated_At: "20/Oct/23 12:00 AM (ago)"
  },
  {
    ID: "144",
    Identifier: "140",
    Device_Name: "Probe",
    Device_Model: "Lenser,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "140",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "2 MHz,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "143",
    Identifier: "1410",
    Device_Name: "Probe",
    Device_Model: "Modsonic,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1410",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4 MHz, 24mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "142",
    Identifier: "3657",
    Device_Name: "Probe",
    Device_Model: "Modsonic,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "3657",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "2 MHz, 24mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "141",
    Identifier: "6316",
    Device_Name: "Angle Probe",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "6316",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4 MHz, 8X9mm,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "140",
    Identifier: "5150",
    Device_Name: "Angle Probe",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5150",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4 MHz, 8X9mm,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "139",
    Identifier: "3695",
    Device_Name: "T/R Probe",
    Device_Model: "Modsonic,",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "3695",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4 MHz, 10mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "138",
    Identifier: "5340",
    Device_Name: "T/R Probe",
    Device_Model: "Modsonic,",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5340",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4 MHz, 10mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "137",
    Identifier: "1106",
    Device_Name: "T/R Probe",
    Device_Model: "Modsonic,",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1106",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4 MHz, 20mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "136",
    Identifier: "5043",
    Device_Name: "Probe",
    Device_Model: "Modsonic,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5043",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4 MHz, 10mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "135",
    Identifier: "135",
    Device_Name: "Probe",
    Device_Model: "Modsonic,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "---",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "2MHz, 10mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "134",
    Identifier: "1731",
    Device_Name: "Probe",
    Device_Model: "Modsonic,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1731",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 24mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "133",
    Identifier: "9640",
    Device_Name: "Probe",
    Device_Model: "Modsonic,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "9640",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 24mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "132",
    Identifier: "3977",
    Device_Name: "Probe",
    Device_Model: "Modsonic,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "3977",
    Calibration_Due_Date: "31/12/2028",
    Active: "Yes",
    Specification: "2MHz, 24mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "27/Feb/24 12:00 AM (ago)"
  },
  {
    ID: "131",
    Identifier: "6924",
    Device_Name: "Angle Probe",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "6924",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 70\u00c2\u00b0, 8X9mm,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "130",
    Identifier: "3355",
    Device_Name: "Angle Probe",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "3355",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 60\u00c2\u00b0, 8X9mm,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "129",
    Identifier: "4659",
    Device_Name: "Angle Probe",
    Device_Model: "MBW Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "4659",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 45\u00c2\u00b0, 8X9mm,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "128",
    Identifier: "53460",
    Device_Name: "PROBE",
    Device_Model: "Krautkramer,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "53460",
    Calibration_Due_Date: "31/1/2025",
    Active: "Yes",
    Specification: "Dia.24mm, 1MHz,",
    Certificate_Ref: "",
    Updated_At: "09/Jan/24 12:00 AM (ago)"
  },
  {
    ID: "127",
    Identifier: "215",
    Device_Name: "T/R Curvature",
    Device_Model: "Lenser,",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "215",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "Dia.10mm,  4MHz,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "126",
    Identifier: "3722",
    Device_Name: "T/R Probe",
    Device_Model: "Modsonic,",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "3722",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 10mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "125",
    Identifier: "1165",
    Device_Name: "T/R Probe",
    Device_Model: "Modsonic,",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1165",
    Calibration_Due_Date: "31/12/2027",
    Active: "Yes",
    Specification: "4MHz, 20mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "25/Jul/23 12:00 AM (ago)"
  },
  {
    ID: "124",
    Identifier: "5340",
    Device_Name: "Probe",
    Device_Model: "Modsonic,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5340",
    Calibration_Due_Date: "31/12/2025",
    Active: "Yes",
    Specification: "4MHz,10mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "15/Oct/23 12:00 AM (ago)"
  },
  {
    ID: "123",
    Identifier: "57749-73159",
    Device_Name: "NORMAL PROBE",
    Device_Model: "GE,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "57749-73159",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "4MHz, 10mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "20/Feb/22 12:00 AM (ago)"
  },
  {
    ID: "122",
    Identifier: "57748-55813",
    Device_Name: "NORMAL PROBE",
    Device_Model: "GE,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "57748-55813",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "2MHz, 10mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "121",
    Identifier: "1321",
    Device_Name: "Probe",
    Device_Model: "Modsonic,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1321",
    Calibration_Due_Date: "31/12/2028",
    Active: "Yes",
    Specification: "4MHz, 24mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "27/Feb/24 12:00 AM (ago)"
  },
  {
    ID: "120",
    Identifier: "3262",
    Device_Name: "Probe",
    Device_Model: "Modsonic,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "3262",
    Calibration_Due_Date: "31/12/2027",
    Active: "Yes",
    Specification: "2MHz, 24mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "25/Jul/23 12:00 AM (ago)"
  },
  {
    ID: "119",
    Identifier: "1363",
    Device_Name: "Angle Probe",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1363",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "2MHz, 8X9mm, 70 Deg.",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "118",
    Identifier: "1351",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1351",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "2MHz, 8X9mm, 60 Deg.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "117",
    Identifier: "1664",
    Device_Name: "Angle Prone",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1664",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "2MHz, 45\u00c2\u00b0, 8X9mm,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "116",
    Identifier: "MBW70-4",
    Device_Name: "Angle Probe",
    Device_Model: "GE,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "MBW70-4",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "8X9mm, 4MHz, 70\u00c2\u00b0,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "115",
    Identifier: "MBW60-4",
    Device_Name: "Angle Probe",
    Device_Model: "GE,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "MBW60-4",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "8X9mm, 4MHz, 60\u00c2\u00b0,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "114",
    Identifier: "MBW45-4",
    Device_Name: "Angle Probe",
    Device_Model: "GE,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "MBW45-4",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "8X9mm, 4MHz, 45\u00c2\u00b0,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "113",
    Identifier: "4633",
    Device_Name: "T/R Probe",
    Device_Model: "Modsonic,",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "4633",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 10mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "112",
    Identifier: "1221",
    Device_Name: "T/R Probe",
    Device_Model: "Modsonic,",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1221",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 24mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "111",
    Identifier: "180622",
    Device_Name: "Probe",
    Device_Model: "Fallon,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "180622",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 10mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "110",
    Identifier: "37",
    Device_Name: "Probe",
    Device_Model: "Lenser,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "37",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "Dia.10mm, 2MHz,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "109",
    Identifier: "462",
    Device_Name: "Probe",
    Device_Model: "krautkramer,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "462",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "Dia. 24mm,  4MHz,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "108",
    Identifier: "3656",
    Device_Name: "Probe",
    Device_Model: "Modsonic,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "3656",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "2MHz, 24mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "107",
    Identifier: "6768",
    Device_Name: "Angle Probe",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "6768",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 70\u00c2\u00b0, 8X9mm,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "106",
    Identifier: "5423",
    Device_Name: "Angle Probe",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5423",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 70\u00c2\u00b0, 8X9mm,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "105",
    Identifier: "5154",
    Device_Name: "Angle Probe",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5154",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 70\u00c2\u00b0, 8X9mm,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "104",
    Identifier: "1014",
    Device_Name: "Angle Probe",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "----",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 60\u00c2\u00b0, 8X9,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "103",
    Identifier: "5466",
    Device_Name: "Angle Probe",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5466",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 45\u00c2\u00b0, 8 X 9,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "102",
    Identifier: "3696",
    Device_Name: "T/R Probe",
    Device_Model: "Modsonic,",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "3696",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "101",
    Identifier: "1082",
    Device_Name: "T/R Probe",
    Device_Model: "Modsonic,",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1082",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 24mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "100",
    Identifier: "5044",
    Device_Name: "Probe",
    Device_Model: "Modsonic,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5044",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 10mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "99",
    Identifier: "108",
    Device_Name: "Probe",
    Device_Model: "Lenser,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "108",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "Dia.10mm, 2MHz,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "98",
    Identifier: "98",
    Device_Name: "Probe",
    Device_Model: "Modsonic,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "---",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 24mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "97",
    Identifier: "3261",
    Device_Name: "Probe",
    Device_Model: "Modsonic,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "3261",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "2MHz, 24mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "96",
    Identifier: "4071",
    Device_Name: "Ang;le Probe",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "4071",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz,70\u00c2\u00b0, 8 X 9mm,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "95",
    Identifier: "3336",
    Device_Name: "Angle Probe",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "3336",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 60\u00c2\u00b0, 8 X 9mm,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "94",
    Identifier: "3615",
    Device_Name: "Angle Probe",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "3615",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 45\u00c2\u00b0, 8 X 9mm,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "93",
    Identifier: "1220",
    Device_Name: "T/R Probe",
    Device_Model: "Modsonic,",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1220",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 24mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "92",
    Identifier: "4274",
    Device_Name: "Probe",
    Device_Model: "Modsonic,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "4274",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 24mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "91",
    Identifier: "169",
    Device_Name: "Normal Probe",
    Device_Model: "Lenser,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "169",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "2MHz. Dia. 10 mm",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "90",
    Identifier: "257",
    Device_Name: "Normal Probe",
    Device_Model: "Lenser,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "257",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz. Dia. 24 mm",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "89",
    Identifier: "111",
    Device_Name: "Probe",
    Device_Model: "Lenser,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "111",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "2MHz. Dia. 24 mm",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "88",
    Identifier: "6317",
    Device_Name: "Angle Probe",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "6317",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 70\u00c2\u00b0, 8 X 9,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "87",
    Identifier: "480",
    Device_Name: "Angle Probe",
    Device_Model: "Lenser,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "480",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "8 X 9, 60\u00c2\u00b0, 4MHz,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "86",
    Identifier: "4122",
    Device_Name: "Angle Prone",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "4122",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 60\u00c2\u00b0, 8 X 9,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "85",
    Identifier: "4909",
    Device_Name: "Angle Probe",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "4909",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz 60\u00c2\u00b0, 8 X 9,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "84",
    Identifier: "84",
    Device_Name: "EEC",
    Device_Model: "EEC,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "---",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 45\u00c2\u00b0, 8X9mm.",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "83",
    Identifier: "5325",
    Device_Name: "Angle Probe",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5325",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz 45\u00c2\u00b0,  8 X 9,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "82",
    Identifier: "071CAG",
    Device_Name: "T/R Probe",
    Device_Model: "PI,",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "071CAG",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "2MHz, 24mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "81",
    Identifier: "1167",
    Device_Name: "T/R Probe",
    Device_Model: "Modsonic,",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1167",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 20mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "80",
    Identifier: "3406",
    Device_Name: "Normal Probe",
    Device_Model: "Modsonic,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "3406",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "2MHz, 24mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "79",
    Identifier: "1462",
    Device_Name: "Probe",
    Device_Model: "Modsonic,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1462",
    Calibration_Due_Date: "31/12/2027",
    Active: "Yes",
    Specification: "4MHz, 24mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "25/Jul/23 12:00 AM (ago)"
  },
  {
    ID: "78",
    Identifier: "78",
    Device_Name: "Probe",
    Device_Model: "Ranade,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "--",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "Dia.10, 2MHz,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "77",
    Identifier: "5763",
    Device_Name: "T/R PROBE",
    Device_Model: "Modsonic,",
    Device_Type: "T/R PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5763",
    Calibration_Due_Date: "31/12/2028",
    Active: "Yes",
    Specification: "4MHz, 10mm Dia. ,",
    Certificate_Ref: "",
    Updated_At: "27/Feb/24 12:00 AM (ago)"
  },
  {
    ID: "76",
    Identifier: "1456",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1456",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "2MHz, 8 X 9 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "75",
    Identifier: "75",
    Device_Name: "Angle Probe",
    Device_Model: "krautkramer,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "--",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "8 X 9,4MHz,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "74",
    Identifier: "6662",
    Device_Name: "Angle Probe",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "6662",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 8 X 9, 70 Deg.",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "73",
    Identifier: "5114",
    Device_Name: "Angle Probe",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5114",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 8 X 9, 60 Deg.",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "72",
    Identifier: "5557",
    Device_Name: "ANGLE PROBE",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5557",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 8 X 9, 45 Deg.",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "71",
    Identifier: "1737",
    Device_Name: "NORMAL PROBE",
    Device_Model: "Modsonic,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "1737",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 24mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "70",
    Identifier: "180711",
    Device_Name: "Normal Probe",
    Device_Model: "Fallon,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "180711",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "2MHz, 24 mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "69",
    Identifier: "150801",
    Device_Name: "Normal Probe",
    Device_Model: "Fallon,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "150801",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "2MHz, 10mm, Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "68",
    Identifier: "150517",
    Device_Name: "Normal Probe",
    Device_Model: "Fallon,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "150517",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 24 mm Dia.,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "67",
    Identifier: "150519",
    Device_Name: "Normal Probe",
    Device_Model: "Fallon,",
    Device_Type: "NORMAL PROBE",
    Branch: "Pune",
    Device_Serial_Number: "150519",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "2MHz, 24mm Dia. ,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "66",
    Identifier: "5154",
    Device_Name: "Angle Probe",
    Device_Model: "Modsonic,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "5154",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 70\u00c2\u00b0,  8 X 9,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "65",
    Identifier: "180631",
    Device_Name: "Angle Probe",
    Device_Model: "Fallon,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "180631",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 8 X 9, 60\u00c2\u00b0,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "64",
    Identifier: "180703",
    Device_Name: "Angle Probe",
    Device_Model: "Fallon,",
    Device_Type: "ANGLE PROBE",
    Branch: "Pune",
    Device_Serial_Number: "180703",
    Calibration_Due_Date: "31/12/2020",
    Active: "No",
    Specification: "4MHz, 8 X 9, 45\u00c2\u00b0,",
    Certificate_Ref: "",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "63",
    Identifier: "2019015",
    Device_Name: "V2 Calibration Block",
    Device_Model: "X-RAY ACCESSORIES PRODUCTS",
    Device_Type: "V2 CALIBRATION BLOCK",
    Branch: "Pune",
    Device_Serial_Number: "2019015",
    Calibration_Due_Date: "6/4/2020",
    Active: "No",
    Specification: "2019015",
    Certificate_Ref: "KIRTI/CAL/BLOCK/201904003",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "62",
    Identifier: "KQSPL/UTG/OLM/MG/04",
    Device_Name: "Ultrasonic Thickness Guage",
    Device_Model: "OLYMPUS",
    Device_Type: "ULTRASONIC THICKNESS GUAGE",
    Branch: "Pune",
    Device_Serial_Number: "213868411",
    Calibration_Due_Date: "16/11/2023",
    Active: "No",
    Specification: "Olympus",
    Certificate_Ref: "2135608",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "61",
    Identifier: "KQSPL/UTG/MEGA/MG/03",
    Device_Name: "Ultrasonic Thickness Guage",
    Device_Model: "Megasonic  MG 5 - P.",
    Device_Type: "ULTRASONIC THICKNESS GUAGE",
    Branch: "Pune",
    Device_Serial_Number: "M799",
    Calibration_Due_Date: "27/9/2022",
    Active: "No",
    Specification: "M799",
    Certificate_Ref: "MIPPL/21-22/215",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "60",
    Identifier: "KQSPL/UTG/OLM/MG/01",
    Device_Name: "Ultrasonic Thickness Guage",
    Device_Model: "OLYMPUS",
    Device_Type: "ULTRASONIC THICKNESS GUAGE",
    Branch: "Pune",
    Device_Serial_Number: "140428107",
    Calibration_Due_Date: "31/8/2024",
    Active: "Yes",
    Specification: "----",
    Certificate_Ref: "PL/23/09/017",
    Updated_At: "27/Sep/23 12:00 AM (ago)"
  },
  {
    ID: "59",
    Identifier: "KQSPL/UTG/MOD/ED/02",
    Device_Name: "Ultrasonic Thickness Guage",
    Device_Model: "Modsonic Inst. Mfg. co.",
    Device_Type: "ULTRASONIC THICKNESS GUAGE",
    Branch: "Pune",
    Device_Serial_Number: "2305-0906",
    Calibration_Due_Date: "31/8/2024",
    Active: "Yes",
    Specification: "----",
    Certificate_Ref: "PL/23/09/018",
    Updated_At: "27/Sep/23 12:00 AM (ago)"
  },
  {
    ID: "58",
    Identifier: "KQSPL/UFD/MOD/03",
    Device_Name: "Digital Ultrasonic Flaw Detector",
    Device_Model: "Modsonic/  DA- Vinci Alpha",
    Device_Type: "Ultrasonic Flaw Detector",
    Branch: "Pune",
    Device_Serial_Number: "D 0286 -0914",
    Calibration_Due_Date: "12/8/2025",
    Active: "Yes",
    Specification: "",
    Certificate_Ref: "SNDT/UFD/2450/KQSPL",
    Updated_At: "20/Aug/24 12:00 AM (ago)"
  },
  {
    ID: "57",
    Identifier: "KQSPL/UFD/OLY/07",
    Device_Name: "Digital Ultrasonic Flaw Detector",
    Device_Model: "OLYMPUS EPOCH 650",
    Device_Type: "ULTRASONIC FLAW DETECTOR",
    Branch: "Pune",
    Device_Serial_Number: "E 150-1330-12",
    Calibration_Due_Date: "22/1/2026",
    Active: "Yes",
    Specification: "",
    Certificate_Ref: "SNDT/UFD/24006/KQSPL",
    Updated_At: "02/Feb/25 12:00 AM (ago)"
  },
  {
    ID: "56",
    Identifier: "KQSPL/UFD/MOD/01",
    Device_Name: "Digital Ultrasonic Flaw Detector",
    Device_Model: "Modsonic/ Einstein II TFT",
    Device_Type: "Ultrasonic Flaw Detector",
    Branch: "Pune",
    Device_Serial_Number: "E 2856 -0111",
    Calibration_Due_Date: "19/9/2025",
    Active: "Yes",
    Specification: "",
    Certificate_Ref: "MIMCO/UFD/2331/KQSPL",
    Updated_At: "21/Sep/24 12:00 AM (ago)"
  },
  {
    ID: "55",
    Identifier: "KQSPL/UFD/MOD/02",
    Device_Name: "Digital Ultrasonic Flaw Detector",
    Device_Model: "Modsonic Einstein II DGS",
    Device_Type: "Ultrasonic Flaw Detector",
    Branch: "Pune",
    Device_Serial_Number: "E 3525 -1012",
    Calibration_Due_Date: "12/8/2025",
    Active: "Yes",
    Specification: "",
    Certificate_Ref: "SNDT/UFD/2449/KQSPL",
    Updated_At: "02/Sep/24 12:00 AM (ago)"
  },
  {
    ID: "53",
    Identifier: "KQSPL/UFD/GE/04",
    Device_Name: "Digital Ultrasonic Flaw Detector",
    Device_Model: "GE/ USM GO",
    Device_Type: "Ultrasonic Flaw Detector",
    Branch: "Pune",
    Device_Serial_Number: "USM GO 10090087",
    Calibration_Due_Date: "19/9/2025",
    Active: "Yes",
    Specification: "GE/ USM GO",
    Certificate_Ref: "SNDT/UFD/2332/KQSPL",
    Updated_At: "22/Sep/24 12:00 AM (ago)"
  },
  {
    ID: 52,
    Identifier: "KQSPL/UFD/GE/05",
    Device_Name: "Digita Ultrasonic Flaw Detector",
    Device_Model: "GE/ USM 35XS",
    Device_Type: "Ultrasonic Flaw Detector",
    Branch: "Pune",
    Device_Serial_Number: "19253",
    Calibration_Due_Date: "20/07/2028",
    Active: "Yes",
    Specification: "GE/ USM 35XS",
    Certificate_Ref: "SNDT/UFD/24005/KQSPL",
    Updated_At: "20/Jul/26 12:00 AM (ago)"
  },
  {
    ID: "51",
    Identifier: "46",
    Device_Name: "PIE GUAGE",
    Device_Model: "Qualitech",
    Device_Type: "PIE GUAGE",
    Branch: "Pune",
    Device_Serial_Number: "Sep-17",
    Calibration_Due_Date: "4/10/2020",
    Active: "No",
    Specification: "----",
    Certificate_Ref: "Qualitech/pg/09/17",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "50",
    Identifier: "45",
    Device_Name: "PIE GUAGE",
    Device_Model: "Qualitech",
    Device_Type: "PIE GUAGE",
    Branch: "Pune",
    Device_Serial_Number: "Aug-17",
    Calibration_Due_Date: "4/10/2020",
    Active: "No",
    Specification: "---",
    Certificate_Ref: "Qualitech/pg/08/17",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "49",
    Identifier: "44",
    Device_Name: "PIE GUAGE",
    Device_Model: "Hymech",
    Device_Type: "PIE GUAGE",
    Branch: "Pune",
    Device_Serial_Number: "HME 3351",
    Calibration_Due_Date: "3/9/2020",
    Active: "No",
    Specification: "----",
    Certificate_Ref: "HME 3351",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "48",
    Identifier: "43",
    Device_Name: "PIE GUAGE",
    Device_Model: "Hymech",
    Device_Type: "PIE GUAGE",
    Branch: "Pune",
    Device_Serial_Number: "HME 3350",
    Calibration_Due_Date: "3/9/2020",
    Active: "No",
    Specification: "----",
    Certificate_Ref: "HME 3350",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "47",
    Identifier: "42",
    Device_Name: "PIE GUAGE",
    Device_Model: "Hymech",
    Device_Type: "PIE GUAGE",
    Branch: "Pune",
    Device_Serial_Number: "HME 120",
    Calibration_Due_Date: "23/5/2021",
    Active: "No",
    Specification: "----",
    Certificate_Ref: "HME/4002",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "46",
    Identifier: "41",
    Device_Name: "PIE GUAGE",
    Device_Model: "Hymech",
    Device_Type: "PIE GUAGE",
    Branch: "Pune",
    Device_Serial_Number: "HME 125",
    Calibration_Due_Date: "14/4/2021",
    Active: "No",
    Specification: "----",
    Certificate_Ref: "HME 3002",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "45",
    Identifier: "KQSPL/VC/01",
    Device_Name: "VERNIER CALLIPER",
    Device_Model: "MITUTOYO",
    Device_Type: "VERNIER CALLIPER",
    Branch: "Pune",
    Device_Serial_Number: "KQSPL/VC/01",
    Calibration_Due_Date: "22/12/2025",
    Active: "Yes",
    Specification: "0 to 200 mm",
    Certificate_Ref: "PL/24-12/1437",
    Updated_At: "12/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "44",
    Identifier: "KQSPL/RFI/01",
    Device_Name: "Residual field Meter",
    Device_Model: "Hymech",
    Device_Type: "FIELD METER",
    Branch: "Pune",
    Device_Serial_Number: "325",
    Calibration_Due_Date: "30/5/2024",
    Active: "No",
    Specification: "----",
    Certificate_Ref: "SIMS/KQSPL/25/01",
    Updated_At: "12/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "43",
    Identifier: "KQSPL/LX-LT/05",
    Device_Name: "LUX METER",
    Device_Model: "Lutron",
    Device_Type: "LUX METER",
    Branch: "Pune",
    Device_Serial_Number: "S332615",
    Calibration_Due_Date: "2/9/2025",
    Active: "Yes",
    Specification: "365 nm",
    Certificate_Ref: "GTS/250303/04-002",
    Updated_At: "09/Mar/25 12:00 AM (ago)"
  },
  {
    ID: "42",
    Identifier: "KQSPL/UVM/01",
    Device_Name: "UV Intensity Meter",
    Device_Model: "LUTRON",
    Device_Type: "UV METER",
    Branch: "Pune",
    Device_Serial_Number: "S029663",
    Calibration_Due_Date: "25/6/2025",
    Active: "Yes",
    Specification: "365 nm",
    Certificate_Ref: "TCR/963/24",
    Updated_At: "28/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "41",
    Identifier: "36",
    Device_Name: "UV Light",
    Device_Model: "DNDT",
    Device_Type: "UV LIGHT",
    Branch: "Pune",
    Device_Serial_Number: "DUVT-5K-053",
    Calibration_Due_Date: "21/11/2020",
    Active: "No",
    Specification: "365nm",
    Certificate_Ref: "HME/1202",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "40",
    Identifier: "35",
    Device_Name: "UV Torch",
    Device_Model: "DNDT",
    Device_Type: "UV TORCH",
    Branch: "Pune",
    Device_Serial_Number: "DUVT-5K-038",
    Calibration_Due_Date: "6/4/2020",
    Active: "No",
    Specification: "365 nM",
    Certificate_Ref: "DNDT/CRT/ET01/26",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "39",
    Identifier: "34",
    Device_Name: "UV Torch",
    Device_Model: "DNDT",
    Device_Type: "UV TORCH",
    Branch: "Pune",
    Device_Serial_Number: "DUVT-6K-033",
    Calibration_Due_Date: "1/4/2020",
    Active: "No",
    Specification: "365 nM",
    Certificate_Ref: "DNDT/Cal/UVT/33",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "38",
    Identifier: "33",
    Device_Name: "UV Torch",
    Device_Model: "DNDT",
    Device_Type: "UV TORCH",
    Branch: "Pune",
    Device_Serial_Number: "DUVT-6K-012",
    Calibration_Due_Date: "23/5/2021",
    Active: "No",
    Specification: "365 nM",
    Certificate_Ref: "HME/4007",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "37",
    Identifier: "32",
    Device_Name: "UV Torch",
    Device_Model: "DNDT",
    Device_Type: "UV TORCH",
    Branch: "Pune",
    Device_Serial_Number: "DMY-AD-19-03-024",
    Calibration_Due_Date: "28/3/2020",
    Active: "No",
    Specification: "365 nM",
    Certificate_Ref: "DUVT/Cal/MY/039",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "36",
    Identifier: "31",
    Device_Name: "UV LED Torch",
    Device_Model: "Ferro Chem",
    Device_Type: "UV LED TORCH",
    Branch: "Pune",
    Device_Serial_Number: "FC-83060",
    Calibration_Due_Date: "9/9/2021",
    Active: "No",
    Specification: "365 nM",
    Certificate_Ref: "FC- 04",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "35",
    Identifier: "30",
    Device_Name: "UV LED Torch",
    Device_Model: "Ferro Chem",
    Device_Type: "UV LED TORCH",
    Branch: "Pune",
    Device_Serial_Number: "Sr. No. FC-83061",
    Calibration_Due_Date: "2/9/2021",
    Active: "No",
    Specification: "365 nM",
    Certificate_Ref: "FC- 05",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "34",
    Identifier: "KQSPL/MT-FM/01",
    Device_Name: "Measuring Tape",
    Device_Model: "FREEMANS",
    Device_Type: "MEASUREING TAPE",
    Branch: "Pune",
    Device_Serial_Number: "---",
    Calibration_Due_Date: "16/10/2024",
    Active: "Yes",
    Specification: "15 Meter",
    Certificate_Ref: "CC240522000002314F",
    Updated_At: "25/Nov/23 12:00 AM (ago)"
  },
  {
    ID: "33",
    Identifier: "KQSPL/MT-GL/03",
    Device_Name: "MEASURING TAPE",
    Device_Model: "GOLDEN",
    Device_Type: "MEASURING TAPE",
    Branch: "Pune",
    Device_Serial_Number: "3 Meter",
    Calibration_Due_Date: "17/11/2024",
    Active: "Yes",
    Specification: "3 Meter",
    Certificate_Ref: "PL/23/11/616",
    Updated_At: "20/Nov/23 12:00 AM (ago)"
  },
  {
    ID: "32",
    Identifier: "KQSPL/DEN/01",
    Device_Name: "Densitometer",
    Device_Model: "Trans- 4V",
    Device_Type: "Density Meter",
    Branch: "Pune",
    Device_Serial_Number: "JP3646",
    Calibration_Due_Date: "6/3/2025",
    Active: "Yes",
    Specification: "----",
    Certificate_Ref: "KQSPL/DEN/J P-35/20",
    Updated_At: "12/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "31",
    Identifier: "KQSPL/PG-BM/01",
    Device_Name: "Pressure Guage",
    Device_Model: "BAUMER",
    Device_Type: "Pressure Gauge",
    Branch: "Pune",
    Device_Serial_Number: "KQSPL/PG-BM/01",
    Calibration_Due_Date: "17/5/2024",
    Active: "Yes",
    Specification: "0-7 Kg/cm2",
    Certificate_Ref: "PL/23/11/614",
    Updated_At: "20/Nov/23 12:00 AM (ago)"
  },
  {
    ID: "30",
    Identifier: "KQSPL/PG-BM/02",
    Device_Name: "Pressure Gauge",
    Device_Model: "BAUMER",
    Device_Type: "Pressure Gauge",
    Branch: "Pune",
    Device_Serial_Number: "KL1.6",
    Calibration_Due_Date: "28/12/2022",
    Active: "No",
    Specification: "0-7kg/cm2",
    Certificate_Ref: "---",
    Updated_At: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: "29",
    Identifier: "KQSPL/WG/02",
    Device_Name: "WELD FILLET GUAGE",
    Device_Model: "---",
    Device_Type: "WELD GAUGE",
    Branch: "Pune",
    Device_Serial_Number: "----",
    Calibration_Due_Date: "6/6/2024",
    Active: "Yes",
    Specification: "1 mm",
    Certificate_Ref: "---",
    Updated_At: "25/Nov/23 12:00 AM (ago)"
  },
  {
    ID: "28",
    Identifier: "KQSPL/WG/01",
    Device_Name: "Weld Fillet Guage",
    Device_Model: "----",
    Device_Type: "WELD GAUGE",
    Branch: "Pune",
    Device_Serial_Number: "---",
    Calibration_Due_Date: "6/6/2024",
    Active: "Yes",
    Specification: "0-30 mm",
    Certificate_Ref: "BD05R-01/01",
    Updated_At: "25/Nov/23 12:00 AM (ago)"
  },
  {
    ID: "27",
    Identifier: "KQSPL/UVM/02",
    Device_Name: "UV Intensity Meter",
    Device_Model: "LUTRON",
    Device_Type: "UV METER",
    Branch: "Pune",
    Device_Serial_Number: "Q896117",
    Calibration_Due_Date: "17/8/2025",
    Active: "Yes",
    Specification: "0 \u00e2\u20ac\u201c 20000uW/cm",
    Certificate_Ref: "TCR/117/24",
    Updated_At: "23/Feb/25 12:00 AM (ago)"
  },
  {
    ID: 26,
    Identifier: "KQSPL/IR-TH/02",
    Device_Name: "Infrared Thermometer",
    Device_Model: "KQSPL/IR-TH/02",
    Device_Type: "THERMOMETER",
    Branch: "Pune",
    Device_Serial_Number: "2.01807E+11",
    Calibration_Due_Date: "20/07/2028",
    Active: "Yes",
    Specification: "-500C- 6500C",
    Certificate_Ref: "GTS/230830/03-002",
    Updated_At: "20/Jul/26 12:00 AM (ago)"
  },
  {
    ID: 25,
    Identifier: "KQSPL/IR-TH/01",
    Device_Name: "Digital IR Thermometer",
    Device_Model: "KUSAM- MECO",
    Device_Type: "THERMOMETER",
    Branch: "Pune",
    Device_Serial_Number: "125057",
    Calibration_Due_Date: "20/07/2028",
    Active: "Yes",
    Specification: "-300 to 5500C",
    Certificate_Ref: "GTS/240905/05-001",
    Updated_At: "20/Jul/26 12:00 AM (ago)"
  },
  {
    ID: "24",
    Identifier: "KQSPL/LX-MX/02",
    Device_Name: "LUX METER",
    Device_Model: "MEXTECH",
    Device_Type: "LUX METER",
    Branch: "Pune",
    Device_Serial_Number: "17519965",
    Calibration_Due_Date: "20/6/2025",
    Active: "Yes",
    Specification: "0-1999 & 2000 \u00e2\u20ac\u201c 19999 Lux",
    Certificate_Ref: "GTS/231120/01-001",
    Updated_At: "28/Dec/24 12:00 AM (ago)"
  },
  {
    ID: "23",
    Identifier: "KQSPL/LX-SGM/04",
    Device_Name: "LUX METER",
    Device_Model: "SIGMA",
    Device_Type: "LUX METER",
    Branch: "Pune",
    Device_Serial_Number: "20036177",
    Calibration_Due_Date: "27/8/2025",
    Active: "Yes",
    Specification: "0-20,000 Lux",
    Certificate_Ref: "GTS/250228/01-001",
    Updated_At: "09/Mar/25 12:00 AM (ago)"
  },
  {
    ID: "22",
    Identifier: "KQSPL/HB-QT/02",
    Device_Name: "DIGITAL HALLS PROBE",
    Device_Model: "QUALITECH",
    Device_Type: "GAUSS METER",
    Branch: "Pune",
    Device_Serial_Number: "126",
    Calibration_Due_Date: "17/7/2025",
    Active: "Yes",
    Specification: "\u00c2\u00b10 to \u00c2\u00b1 200 Gauss",
    Certificate_Ref: "SIMS/KUB/0126/25/09",
    Updated_At: "28/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "21",
    Identifier: "KQSPL/HB-DY/01",
    Device_Name: "DIGITAL HALLS PROBE",
    Device_Model: "DYEGLO",
    Device_Type: "GAUSS METER",
    Branch: "Pune",
    Device_Serial_Number: "DMG108",
    Calibration_Due_Date: "13/11/2025",
    Active: "Yes",
    Specification: "\u00c2\u00b10 to \u00c2\u00b1100 Gauss",
    Certificate_Ref: "SCL/KUB/264/05-001",
    Updated_At: "17/May/25 12:00 AM (ago)"
  },
  {
    ID: "20",
    Identifier: "KQSPL/SM-BT/06",
    Device_Name: "Stationary Machine -5000Amp",
    Device_Model: "Mayuresh 603",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "HME-29",
    Calibration_Due_Date: "28/4/2025",
    Active: "Yes",
    Specification: "0-5000 amps",
    Certificate_Ref: "HME-1501",
    Updated_At: "28/Dec/24 12:00 AM (ago)"
  },
  {
    ID: "19",
    Identifier: "KQSPL/SM-BT/05",
    Device_Name: "Stationary Machine \u00e2\u20ac\u201c1500 Amp",
    Device_Model: "DYEGLO",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "KQSPL-05 (98361)",
    Calibration_Due_Date: "3/5/2025",
    Active: "Yes",
    Specification: "0-1500 amps",
    Certificate_Ref: "HME-1502",
    Updated_At: "28/Dec/24 12:00 AM (ago)"
  },
  {
    ID: "18",
    Identifier: "KQSPL/SM-BT/03",
    Device_Name: "Stationary Machine -1500Amp",
    Device_Model: "Hymech 603",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "HME-21",
    Calibration_Due_Date: "23/6/2025",
    Active: "Yes",
    Specification: "0-1500 amps",
    Certificate_Ref: "HME/2272",
    Updated_At: "28/Dec/24 12:00 AM (ago)"
  },
  {
    ID: "17",
    Identifier: "KQSPL/SM-BT/02",
    Device_Name: "Stationary Machine -1500Amp",
    Device_Model: "Mayuresh 603",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "4515",
    Calibration_Due_Date: "28/4/2025",
    Active: "No",
    Specification: "0-1500 amps",
    Certificate_Ref: "HME-2200",
    Updated_At: "12/Jan/25 12:00 AM (ago)"
  },
  {
    ID: "16",
    Identifier: "KQSPL/SM-BT/01",
    Device_Name: "Stationary Machine -1500Amp",
    Device_Model: "Mayuresh 603",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "414",
    Calibration_Due_Date: "23/6/2025",
    Active: "Yes",
    Specification: "0-1500 amps",
    Certificate_Ref: "HME/2270",
    Updated_At: "28/Dec/24 12:00 AM (ago)"
  },
  {
    ID: "15",
    Identifier: "KQSPL/SM-BT/04",
    Device_Name: "STATIONARY MACHINE -3000 AMP",
    Device_Model: "HYMECH",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "HME-22",
    Calibration_Due_Date: "23/6/2025",
    Active: "Yes",
    Specification: "0-3000 amps",
    Certificate_Ref: "HME/2274",
    Updated_At: "28/Dec/24 12:00 AM (ago)"
  },
  {
    ID: "14",
    Identifier: "KQSPL/EL-YK/10",
    Device_Name: "ELECTROMAGNETIC YOKE",
    Device_Model: "Hymech",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "KQSPL/EL-YK/10 - HYMECH MAKE",
    Calibration_Due_Date: "18/11/2025",
    Active: "No",
    Specification: "Min. lifting Capacity 4.5 Kg.",
    Certificate_Ref: "KQSPL/CAL/YL/10",
    Updated_At: "19/May/25 12:00 AM (ago)"
  },
  {
    ID: "13",
    Identifier: "KQSPL/EL-YK/08",
    Device_Name: "ELECTROMAGNETIC YOKE",
    Device_Model: "HYMECH",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "HME-218",
    Calibration_Due_Date: "18/11/2025",
    Active: "Yes",
    Specification: "Min. lifting Capacity 4.5 Kg.",
    Certificate_Ref: "KQSPL/CAL/YK/2023/43",
    Updated_At: "19/May/25 12:00 AM (ago)"
  },
  {
    ID: "12",
    Identifier: "KQSPL/PR-YK/07",
    Device_Name: "PERMANENT MAGNETIC YOKE",
    Device_Model: "Hymech",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "Mayuresh Make",
    Calibration_Due_Date: "18/11/2025",
    Active: "Yes",
    Specification: "Min. lifting Capacity 4.5 Kg.",
    Certificate_Ref: "KQSPL/CAL/YK/2023/11",
    Updated_At: "19/May/25 12:00 AM (ago)"
  },
  {
    ID: "11",
    Identifier: "KQSPL/EL-YK/06",
    Device_Name: "ELECTROMAGNETIC YOKE",
    Device_Model: "FERROCHEM",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "FC-83059 - FERROCHEM MAKE",
    Calibration_Due_Date: "18/11/2025",
    Active: "Yes",
    Specification: "Min. lifting Capacity 4.5 Kg.",
    Certificate_Ref: "KQSPL/CAL/YK/2022/15",
    Updated_At: "19/May/25 12:00 AM (ago)"
  },
  {
    ID: "10",
    Identifier: "KQSPL/EL-YK/05",
    Device_Name: "ELECTROMAGNETIC YOKE",
    Device_Model: "DNDT",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "19-03-024 DNDT  MAKE",
    Calibration_Due_Date: "18/11/2025",
    Active: "Yes",
    Specification: "Min. lifting Capacity 4.5 Kg.",
    Certificate_Ref: "KQSPL/CAL/YK/2022/14",
    Updated_At: "19/May/25 12:00 AM (ago)"
  },
  {
    ID: "9",
    Identifier: "KQSPL/EL-YK/04",
    Device_Name: "ELECTROMAGNETIC YOKE",
    Device_Model: "HYMECH",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "HME 4 - HYMECH MAKE",
    Calibration_Due_Date: "18/5/2025",
    Active: "Yes",
    Specification: "Min. lifting Capacity 4.5 Kg.",
    Certificate_Ref: "KQSPL/CAL/YK/2022/13",
    Updated_At: "24/Nov/24 12:00 AM (ago)"
  },
  {
    ID: "8",
    Identifier: "KQSPL/EL-YK/03",
    Device_Name: "ELECTROMAGNETIC YOKE",
    Device_Model: "MAGNAFLUX",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "Y7 (2011092710) - MAXILUX MAKE",
    Calibration_Due_Date: "18/11/2025",
    Active: "Yes",
    Specification: "Min. lifting Capacity 4.5 Kg.",
    Certificate_Ref: "KQSPL/CAL/YK/2023/07",
    Updated_At: "19/May/25 12:00 AM (ago)"
  },
  {
    ID: "7",
    Identifier: "KQSPL/EL-YK/02",
    Device_Name: "Electromagnetic Yoke",
    Device_Model: "Hymec",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "HME 09",
    Calibration_Due_Date: "18/11/2025",
    Active: "Yes",
    Specification: "Min. lifting Capacity 4.5 Kg.",
    Certificate_Ref: "KQSPL/CAL/YK/2023/11",
    Updated_At: "19/May/25 12:00 AM (ago)"
  },
  {
    ID: "6",
    Identifier: "KQSPL/EL-YK/15",
    Device_Name: "Electromagnetic Yoke",
    Device_Model: "SIMS-Y A/D",
    Device_Type: "TEST EQUIPMENT",
    Branch: "Pune",
    Device_Serial_Number: "2.0241E+11",
    Calibration_Due_Date: "18/11/2025",
    Active: "Yes",
    Specification: "Min. lifting Capacity 4.5 Kg.",
    Certificate_Ref: "3765/24",
    Updated_At: "19/May/25 12:00 AM (ago)"
  },
  {
    ID: "555",
    Identifier: "Some device",
    Device_Name: "ABC DEvice",
    Device_Model: "ABC Model",
    Device_Type: "ABC Type",
    Branch: "AA",
    Device_Serial_Number: "123",
    Calibration_Due_Date: "12.1.2027",
    Active: "Active",
    Specification: "Some Spec",
    Certificate_Ref: "ASD",
    Updated_At: "12.12.2025"
  },
  {
    ID: 556,
    Identifier: "KQSPL/20",
    Device_Name: "TEST",
    Device_Model: "TEST",
    Device_Type: "TEST",
    Branch: "Mumbai",
    Device_Serial_Number: "ABD-02",
    Calibration_Due_Date: "",
    Active: "Active",
    Specification: "",
    Certificate_Ref: "",
    Updated_At: "16/May/26 12:00 AM (ago)"
  },
  {
    ID: 557,
    Identifier: "KQSPL",
    Device_Name: "YOKE",
    Device_Model: "TEST",
    Device_Type: "TEST",
    Branch: "Pune",
    Device_Serial_Number: "dadada",
    Calibration_Due_Date: "",
    Active: "Yes",
    Specification: "test",
    Certificate_Ref: "test",
    Updated_At: "10/Jun/26 12:00 AM (ago)"
  }
];

const CONSUMABLES = [
  {
    ID: 208,
    Identifier: "j",
    Product_Name: "NOT APPLICABLE",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "ABC123",
    Quantity: 1,
    Expiry_Date: "30/3/2030",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "03/Jun/25 12:00 AM (ago)"
  },
  {
    ID: 207,
    Identifier: "2503052",
    Product_Name: "MR CHEMIE MAKE MR 72",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "2503052",
    Quantity: 100,
    Expiry_Date: "30/3/2030",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "03/May/25 12:00 AM (ago)"
  },
  {
    ID: 206,
    Identifier: "2408103",
    Product_Name: "ZCHEK-CR",
    Product_Type: "CLEANER",
    Batch_No: "2408103",
    Quantity: 1,
    Expiry_Date: "30/7/2027",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "20/Dec/24 12:00 AM (ago)"
  },
  {
    ID: 205,
    Identifier: "240380",
    Product_Name: "ZCHEK-PT",
    Product_Type: "PENETRANT",
    Batch_No: "240380",
    Quantity: 1,
    Expiry_Date: "28/2/2027",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "20/Dec/24 12:00 AM (ago)"
  },
  {
    ID: 204,
    Identifier: "240650",
    Product_Name: "ZCHECK-DL",
    Product_Type: "DEVELOPER",
    Batch_No: "240650",
    Quantity: 400,
    Expiry_Date: "31/5/2027",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "20/Dec/24 12:00 AM (ago)"
  },
  {
    ID: 203,
    Identifier: "23H23",
    Product_Name: "MG 410",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "23H23",
    Quantity: 1,
    Expiry_Date: "30/8/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "22/Nov/24 12:00 AM (ago)"
  },
  {
    ID: 202,
    Identifier: "24C1017",
    Product_Name: "MAGNAFLUX MG 3410",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "24C1017",
    Quantity: 1,
    Expiry_Date: "30/3/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "26/Jul/24 12:00 AM (ago)"
  },
  {
    ID: 201,
    Identifier: "24G01",
    Product_Name: "MAGNAFLUX SKC-I",
    Product_Type: "CLEANER",
    Batch_No: "24G01",
    Quantity: 1,
    Expiry_Date: "30/7/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "18/Oct/24 12:00 AM (ago)"
  },
  {
    ID: 200,
    Identifier: "24G63",
    Product_Name: "MAGNAFLUX SKD-S2",
    Product_Type: "DEVELOPER",
    Batch_No: "24G63",
    Quantity: 400,
    Expiry_Date: "30/7/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "18/Oct/24 12:00 AM (ago)"
  },
  {
    ID: 199,
    Identifier: "24A21",
    Product_Name: "MG 410",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "24A21",
    Quantity: 1,
    Expiry_Date: "30/1/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "15/Dec/24 12:00 AM (ago)"
  },
  {
    ID: 198,
    Identifier: "24A92",
    Product_Name: "CARRIER OIL",
    Product_Type: "BATH MEDIUM",
    Batch_No: "24A922029-01-31",
    Quantity: 1,
    Expiry_Date: "31/1/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "08/May/24 12:00 AM (ago)"
  },
  {
    ID: 197,
    Identifier: "23L01",
    Product_Name: "MAGNAFLUX SKC-I",
    Product_Type: "CLEANER",
    Batch_No: "23L01",
    Quantity: 5,
    Expiry_Date: "30/11/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "25/Jun/24 12:00 AM (ago)"
  },
  {
    ID: 196,
    Identifier: "23A005",
    Product_Name: "MAGNAFLUX 14A",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "23A005",
    Quantity: 400,
    Expiry_Date: "1/4/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: 195,
    Identifier: "24G81",
    Product_Name: "CARRIER OIL",
    Product_Type: "BATH MEDIUM",
    Batch_No: "24G81",
    Quantity: 1,
    Expiry_Date: "31/7/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "19/Nov/24 12:00 AM (ago)"
  },
  {
    ID: 194,
    Identifier: "23F004",
    Product_Name: "14A",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "23F004",
    Quantity: 1,
    Expiry_Date: "30/6/2028",
    Branch: "Head Office",
    Active: "Yes",
    Updated_at: "10/Jan/25 12:00 AM (ago)"
  },
  {
    ID: 184,
    Identifier: "2403096",
    Product_Name: "MR CHEMIE MAKE MR76S",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "2403096",
    Quantity: 100,
    Expiry_Date: "28/3/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "31/May/24 12:00 AM (ago)"
  },
  {
    ID: 183,
    Identifier: "23F93",
    Product_Name: "CARRIER OIL",
    Product_Type: "BATH MEDIUM",
    Batch_No: "23F93",
    Quantity: 1,
    Expiry_Date: "31/1/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "25/Oct/23 12:00 AM (ago)"
  },
  {
    ID: 182,
    Identifier: "23A22",
    Product_Name: "MG 410",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "23A22",
    Quantity: 1,
    Expiry_Date: "31/1/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "21/Jul/23 12:00 AM (ago)"
  },
  {
    ID: 181,
    Identifier: "Techasavi 4657",
    Product_Name: "FC-711/2",
    Product_Type: "CLEANER",
    Batch_No: "4657",
    Quantity: 1,
    Expiry_Date: "30/11/2026",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "22/Feb/25 12:00 AM (ago)"
  },
  {
    ID: 180,
    Identifier: "Techasavi 3654",
    Product_Name: "FC-911/2",
    Product_Type: "PENETRANT",
    Batch_No: "3654",
    Quantity: 1,
    Expiry_Date: "31/12/2025",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "22/Feb/25 12:00 AM (ago)"
  },
  {
    ID: 179,
    Identifier: "24D30",
    Product_Name: "MAGNAFLUX SKD-S2",
    Product_Type: "DEVELOPER",
    Batch_No: "24D30",
    Quantity: 400,
    Expiry_Date: "30/4/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "22/Jun/24 12:00 AM (ago)"
  },
  {
    ID: 178,
    Identifier: "23D85",
    Product_Name: "CARRIER OIL",
    Product_Type: "BATH MEDIUM",
    Batch_No: "23D85",
    Quantity: 1,
    Expiry_Date: "30/4/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "20/May/23 12:00 AM (ago)"
  },
  {
    ID: 177,
    Identifier: "23A005",
    Product_Name: "MAGNAFLUX 14A",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "23A005",
    Quantity: 1,
    Expiry_Date: "30/1/2028",
    Branch: "Pune",
    Active: "No",
    Updated_at: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: 176,
    Identifier: "23B83",
    Product_Name: "CARRIER OIL",
    Product_Type: "BATH MEDIUM",
    Batch_No: "23B83",
    Quantity: 1,
    Expiry_Date: "30/6/2027",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "15/May/23 12:00 AM (ago)"
  },
  {
    ID: 175,
    Identifier: "22F22",
    Product_Name: "MG 410",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "22F22",
    Quantity: 1,
    Expiry_Date: "30/6/2027",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "15/May/23 12:00 AM (ago)"
  },
  {
    ID: 174,
    Identifier: "Techasavi 4660",
    Product_Name: "FC-811/2",
    Product_Type: "DEVELOPER",
    Batch_No: "4660",
    Quantity: 5,
    Expiry_Date: "31/12/2026",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "22/Feb/25 12:00 AM (ago)"
  },
  {
    ID: 173,
    Identifier: "2643",
    Product_Name: "FC-711/2",
    Product_Type: "CLEANER",
    Batch_No: "2643",
    Quantity: 7,
    Expiry_Date: "30/12/2024",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "15/May/23 12:00 AM (ago)"
  },
  {
    ID: 172,
    Identifier: "2608",
    Product_Name: "FC-911/2",
    Product_Type: "PENETRANT",
    Batch_No: "2608",
    Quantity: 5,
    Expiry_Date: "30/4/2024",
    Branch: "Pune",
    Active: "No",
    Updated_at: "08/May/24 12:00 AM (ago)"
  },
  {
    ID: 171,
    Identifier: "22B1018",
    Product_Name: "MAGNAFLUX 7HF",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "22B1018",
    Quantity: 800,
    Expiry_Date: "28/2/2027",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "25/Apr/23 12:00 AM (ago)"
  },
  {
    ID: 170,
    Identifier: "22A99",
    Product_Name: "MAGNAFLUX ZL-27A",
    Product_Type: "PENETRANT",
    Batch_No: "22A99",
    Quantity: 24,
    Expiry_Date: "31/1/2027",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "14/Apr/23 12:00 AM (ago)"
  },
  {
    ID: 169,
    Identifier: "22B24",
    Product_Name: "MG 410",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "22B24",
    Quantity: 1,
    Expiry_Date: "28/2/2027",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "25/Apr/23 12:00 AM (ago)"
  },
  {
    ID: 168,
    Identifier: "24K84",
    Product_Name: "CARRIER OIL",
    Product_Type: "BATH MEDIUM",
    Batch_No: "24K84",
    Quantity: 1,
    Expiry_Date: "30/10/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "10/Jan/25 12:00 AM (ago)"
  },
  {
    ID: 167,
    Identifier: "22M27",
    Product_Name: "MG 410",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "22M27",
    Quantity: 1,
    Expiry_Date: "31/12/2027",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "03/Nov/23 12:00 AM (ago)"
  },
  {
    ID: 166,
    Identifier: "2.40E+02",
    Product_Name: "MAGNAFLUX SKC-I",
    Product_Type: "CLEANER",
    Batch_No: "2.40E+02",
    Quantity: 5,
    Expiry_Date: "30/5/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "08/Jun/24 12:00 AM (ago)"
  },
  {
    ID: 165,
    Identifier: "24F05",
    Product_Name: "MAGNAFLUX SKD-S2",
    Product_Type: "DEVELOPER",
    Batch_No: "24F05",
    Quantity: 400,
    Expiry_Date: "30/6/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "16/Aug/24 12:00 AM (ago)"
  },
  {
    ID: 164,
    Identifier: "21C1018",
    Product_Name: "MAGNAFLUX ZL-27A",
    Product_Type: "PENETRANT",
    Batch_No: "21C1018",
    Quantity: 24,
    Expiry_Date: "31/3/2026",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "27/Apr/24 12:00 AM (ago)"
  },
  {
    ID: 163,
    Identifier: "2404002",
    Product_Name: "MR CHEMIE MAKE MR 72",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "2404002",
    Quantity: 100,
    Expiry_Date: "30/3/2030",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "03/May/25 12:00 AM (ago)"
  },
  {
    ID: 162,
    Identifier: "22K76",
    Product_Name: "CARRIER OIL",
    Product_Type: "BATH MEDIUM",
    Batch_No: "22K76",
    Quantity: 1,
    Expiry_Date: "30/10/2027",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "10/Mar/23 12:00 AM (ago)"
  },
  {
    ID: 161,
    Identifier: "23B81",
    Product_Name: "CARRIER OIL",
    Product_Type: "BATH MEDIUM",
    Batch_No: "23B81",
    Quantity: 1,
    Expiry_Date: "30/3/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "04/Aug/23 12:00 AM (ago)"
  },
  {
    ID: 160,
    Identifier: "22D049",
    Product_Name: "14A",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "22D049",
    Quantity: 1,
    Expiry_Date: "30/4/2027",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "04/Aug/23 12:00 AM (ago)"
  },
  {
    ID: 159,
    Identifier: "19L1015",
    Product_Name: "MAGNAFLUX SKL-SP2",
    Product_Type: "PENETRANT",
    Batch_No: "19L1015",
    Quantity: 400,
    Expiry_Date: "30/11/2024",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "20/Feb/23 12:00 AM (ago)"
  },
  {
    ID: 156,
    Identifier: "23A44",
    Product_Name: "MAGNAFLUX MG-2410",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "23A44",
    Quantity: 1000,
    Expiry_Date: "31/1/2027",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "07/Aug/23 12:00 AM (ago)"
  },
  {
    ID: 147,
    Identifier: "2502059",
    Product_Name: "MR CHEMIE MAKE MR76S",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "2502059",
    Quantity: 40000,
    Expiry_Date: "24/2/2030",
    Branch: "Pune",
    Active: true,
    Updated_at: "05/Mar/25 12:00 AM"
  },
  {
    ID: 146,
    Identifier: "2401016",
    Product_Name: "MR CHEMIE MAKE MR 72",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "2401016",
    Quantity: 28000,
    Expiry_Date: "4/1/2029",
    Branch: "Pune",
    Active: true,
    Updated_at: "25/Jun/24 12:00 AM"
  },
  {
    ID: 145,
    Identifier: "22B24",
    Product_Name: "MAGNAFLUX 410",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "22B24",
    Quantity: 1000,
    Expiry_Date: "21/2/2027",
    Branch: "Pune",
    Active: true,
    Updated_at: "23/Apr/22 12:00 AM"
  },
  {
    ID: 144,
    Identifier: "25A33",
    Product_Name: "MAGNAFLUX SKL-SP1",
    Product_Type: "PENETRANT",
    Batch_No: "25A33",
    Quantity: 1,
    Expiry_Date: "30/1/2030",
    Branch: "Pune",
    Active: true,
    Updated_at: "24/May/25 12:00 AM"
  },
  {
    ID: 143,
    Identifier: "24G08",
    Product_Name: "MAGNAFLUX SKD-S2",
    Product_Type: "DEVELOPER",
    Batch_No: "24G08",
    Quantity: 9600,
    Expiry_Date: "30/7/2029",
    Branch: "Pune",
    Active: true,
    Updated_at: "03/Sep/24 12:00 AM"
  },
  {
    ID: 142,
    Identifier: "23J01",
    Product_Name: "MAGNAFLUX SKC-I",
    Product_Type: "CLEANER",
    Batch_No: "23J01",
    Quantity: 5,
    Expiry_Date: "30/9/2028",
    Branch: "Pune",
    Active: true,
    Updated_at: "21/Oct/23 12:00 AM"
  },
  {
    ID: 141,
    Identifier: "5814",
    Product_Name: "FERROCHEM 1204/2",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "5814",
    Quantity: 800,
    Expiry_Date: "30/10/2025",
    Branch: "Pune",
    Active: true,
    Updated_at: "13/Apr/22 12:00 AM"
  },
  {
    ID: 140,
    Identifier: "1403",
    Product_Name: "FERROCHEM FC 147-A/2",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "1403",
    Quantity: 800,
    Expiry_Date: "30/9/2026",
    Branch: "Pune",
    Active: true,
    Updated_at: "13/Apr/22 12:00 AM"
  },
  {
    ID: 139,
    Identifier: "2312WP7",
    Product_Name: "DYEGLO WP01",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "2312WP7",
    Quantity: 2400,
    Expiry_Date: "30/12/2024",
    Branch: "Pune",
    Active: true,
    Updated_at: "07/Feb/24 12:00 AM"
  },
  {
    ID: 138,
    Identifier: "2312DBK10",
    Product_Name: "DYEGLO DBK06A",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "2312DBK10",
    Quantity: 2400,
    Expiry_Date: "30/12/2025",
    Branch: "Pune",
    Active: true,
    Updated_at: "07/Feb/24 12:00 AM"
  },
  {
    ID: 137,
    Identifier: "NA",
    Product_Name: "NOT",
    Product_Type: "BATH MEDIUM",
    Batch_No: "NA",
    Quantity: 0,
    Expiry_Date: "",
    Branch: "Head Office",
    Active: true,
    Updated_at: "03/Apr/22 12:00 AM"
  },
  {
    ID: 136,
    Identifier: "NA",
    Product_Name: "NOT APPLICABLE",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "NOT APPLICABLE",
    Quantity: 0,
    Expiry_Date: "",
    Branch: "Head Office",
    Active: true,
    Updated_at: "03/Apr/22 12:00 AM"
  },
  {
    ID: 135,
    Identifier: "NA",
    Product_Name: "NOT APPLICABLE",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "Not Applicable",
    Quantity: 0,
    Expiry_Date: "",
    Branch: "Head Office",
    Active: true,
    Updated_at: "03/Apr/22 12:00 AM"
  },
  {
    ID: 134,
    Identifier: "2411055",
    Product_Name: "MR CHEMIE MAKE MR76S - OIL BASED",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "2411055",
    Quantity: 40000,
    Expiry_Date: "22/11/2029",
    Branch: "Pune",
    Active: true,
    Updated_at: "11/Mar/25 12:00 AM"
  },
  {
    ID: 133,
    Identifier: "2311057",
    Product_Name: "MR CHEMIE MAKE MR 72",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "2311057",
    Quantity: 40000,
    Expiry_Date: "20/11/2028",
    Branch: "Pune",
    Active: true,
    Updated_at: "25/Jun/24 12:00 AM"
  },
  {
    ID: 132,
    Identifier: "22A65",
    Product_Name: "MAGNAFLUX MG-2410",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "22A65",
    Quantity: 2000,
    Expiry_Date: "31/1/2027",
    Branch: "Pune",
    Active: true,
    Updated_at: "07/Aug/23 12:00 AM"
  },
  {
    ID: 131,
    Identifier: "5637",
    Product_Name: "FC-911",
    Product_Type: "PENETRANT",
    Batch_No: "5637",
    Quantity: 1,
    Expiry_Date: "30/11/2022",
    Branch: "Pune",
    Active: false,
    Updated_at: "12/Dec/23 12:00 AM"
  },
  {
    ID: 130,
    Identifier: "5662",
    Product_Name: "FC-7111",
    Product_Type: "CLEANER",
    Batch_No: "56622023-02-28",
    Quantity: 6,
    Expiry_Date: "",
    Branch: "Pune",
    Active: false,
    Updated_at: "08/May/24 12:00 AM"
  },
  {
    ID: 129,
    Identifier: "2404049",
    Product_Name: "MR CHEMIE MAKE MR 72",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "2404049",
    Quantity: 20000,
    Expiry_Date: "19/4/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "25/Jun/24 12:00 AM (ago)"
  },
  {
    ID: 128,
    Identifier: "2406013",
    Product_Name: "MR CHEMIE MAKE MR 72",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "2406013",
    Quantity: 100,
    Expiry_Date: "10/6/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "30/Jul/24 12:00 AM (ago)"
  },
  {
    ID: 127,
    Identifier: "2406028",
    Product_Name: "MR CHEMIE MAKE MR 76S",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "2406028",
    Quantity: 50,
    Expiry_Date: "13/6/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "09/Aug/24 12:00 AM (ago)"
  },
  {
    ID: 126,
    Identifier: "2.40E+17",
    Product_Name: "MAGNAFLUX SKD-S2",
    Product_Type: "DEVELOPER",
    Batch_No: "2.40E+17",
    Quantity: 24,
    Expiry_Date: "30/4/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "25/Sep/24 12:00 AM (ago)"
  },
  {
    ID: 125,
    Identifier: "0",
    Product_Name: "NOT APPLICABLE",
    Product_Type: "DEVELOPER",
    Batch_No: "0",
    Quantity: 0,
    Expiry_Date: "31/1/2026",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "01/Mar/22 12:00 AM (ago)"
  },
  {
    ID: 124,
    Identifier: "W",
    Product_Name: "--",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "-",
    Quantity: 1,
    Expiry_Date: "",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: 123,
    Identifier: "W",
    Product_Name: "NOT APPLICABLE",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "-",
    Quantity: 1,
    Expiry_Date: "",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: 122,
    Identifier: "NA00",
    Product_Name: "NOT APPLICABLE",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "-",
    Quantity: 1,
    Expiry_Date: "",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "30/Mar/22 12:00 AM (ago)"
  },
  {
    ID: 121,
    Identifier: "L",
    Product_Name: "WATER BASE",
    Product_Type: "BATH MEDIUM",
    Batch_No: "-",
    Quantity: 1,
    Expiry_Date: "",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: 120,
    Identifier: "L",
    Product_Name: "WATER BASE",
    Product_Type: "BATH MEDIUM",
    Batch_No: "-",
    Quantity: 1,
    Expiry_Date: "",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "19/Feb/22 12:00 AM (ago)"
  },
  {
    ID: 119,
    Identifier: "1.30E+17",
    Product_Name: "MAGNAFLUX SKC-I",
    Product_Type: "CLEANER",
    Batch_No: "1.30E+17",
    Quantity: 1,
    Expiry_Date: "30/5/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "14/Jul/23 12:00 AM (ago)"
  },
  {
    ID: 118,
    Identifier: "24K01",
    Product_Name: "MAGNAFLUX SKC-I",
    Product_Type: "CLEANER",
    Batch_No: "24K01",
    Quantity: 15,
    Expiry_Date: "30/10/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "11/Feb/25 12:00 AM (ago)"
  },
  {
    ID: 117,
    Identifier: "24F15",
    Product_Name: "MAGNAFLUX SKD-S2",
    Product_Type: "DEVELOPER",
    Batch_No: "24F15",
    Quantity: 24,
    Expiry_Date: "30/6/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "19/Nov/24 12:00 AM (ago)"
  },
  {
    ID: 116,
    Identifier: "T",
    Product_Name: "NOT APPLICABLE",
    Product_Type: "BATH MEDIUM",
    Batch_No: "-",
    Quantity: 1,
    Expiry_Date: "",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "05/Feb/22 12:00 AM (ago)"
  },
  {
    ID: 115,
    Identifier: "7854",
    Product_Name: "FLAW GUIDE DEVELOPER GP",
    Product_Type: "DEVELOPER",
    Batch_No: "7854",
    Quantity: 12000,
    Expiry_Date: "30/11/2023",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: 114,
    Identifier: "7823",
    Product_Name: "FLAW GUIDE CLEANER GP",
    Product_Type: "CLEANER",
    Batch_No: "7823",
    Quantity: 5,
    Expiry_Date: "30/10/2023",
    Branch: "Pune",
    Active: "No",
    Updated_at: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: 113,
    Identifier: "2408028",
    Product_Name: "MR CHEMIE MAKE MR 76S",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "2408028",
    Quantity: 50,
    Expiry_Date: "12/8/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "24/Sep/24 12:00 AM (ago)"
  },
  {
    ID: 112,
    Identifier: "2409041",
    Product_Name: "MR CHEMIE MAKE MR 76S",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "2409041",
    Quantity: 4000,
    Expiry_Date: "17/9/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "18/Oct/24 12:00 AM (ago)"
  },
  {
    ID: 111,
    Identifier: "2407022",
    Product_Name: "MR CHEMIE MAKE MR 72",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "2407022",
    Quantity: 8000,
    Expiry_Date: "9/7/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "24/Sep/24 12:00 AM (ago)"
  },
  {
    ID: 110,
    Identifier: "2408046",
    Product_Name: "MR CHEMIE MAKE MR 72",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "2408046",
    Quantity: 8000,
    Expiry_Date: "21/8/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "24/Sep/24 12:00 AM (ago)"
  },
  {
    ID: 109,
    Identifier: "2410057",
    Product_Name: "MR CHEMIE MAKE MR 72",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "2410057",
    Quantity: 8000,
    Expiry_Date: "25/10/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "29/Nov/24 12:00 AM (ago)"
  },
  {
    ID: 108,
    Identifier: "2306015",
    Product_Name: "MR CHEMIE MAKE MR 72",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "2306015",
    Quantity: 8000,
    Expiry_Date: "6/6/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "25/Jun/24 12:00 AM (ago)"
  },
  {
    ID: 107,
    Identifier: "2303001",
    Product_Name: "MR CHEMIE MAKE MR 72",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "2303001",
    Quantity: 8000,
    Expiry_Date: "1/3/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "25/Jun/24 12:00 AM (ago)"
  },
  {
    ID: 106,
    Identifier: "24H1031",
    Product_Name: "MAGNAFLUX ZL-27A",
    Product_Type: "PENETRANT",
    Batch_No: "24H1031",
    Quantity: 400,
    Expiry_Date: "23/7/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "25/Sep/24 12:00 AM (ago)"
  },
  {
    ID: 105,
    Identifier: "24K15",
    Product_Name: "MAGNAFLUX SKD-S2",
    Product_Type: "DEVELOPER",
    Batch_No: "24K15",
    Quantity: 400,
    Expiry_Date: "30/10/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "20/Dec/24 12:00 AM (ago)"
  },
  {
    ID: 104,
    Identifier: "24L38",
    Product_Name: "MAGNAFLUX SKL-SP1",
    Product_Type: "PENETRANT",
    Batch_No: "24L38",
    Quantity: 1,
    Expiry_Date: "30/11/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "03/Jun/25 12:00 AM (ago)"
  },
  {
    ID: 103,
    Identifier: "23B27",
    Product_Name: "MAGNAFLUX SKL-SP1",
    Product_Type: "PENETRANT",
    Batch_No: "23B27",
    Quantity: 1,
    Expiry_Date: "27/2/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "18/Oct/24 12:00 AM (ago)"
  },
  {
    ID: 102,
    Identifier: "2644",
    Product_Name: "FC-811/2",
    Product_Type: "DEVELOPER",
    Batch_No: "2644",
    Quantity: 5200,
    Expiry_Date: "31/12/2024",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "15/May/23 12:00 AM (ago)"
  },
  {
    ID: 101,
    Identifier: "9646",
    Product_Name: "FC-811/2",
    Product_Type: "DEVELOPER",
    Batch_No: "9646",
    Quantity: 800,
    Expiry_Date: "11/1/2024",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "07/Jan/22 12:00 AM (ago)"
  },
  {
    ID: 100,
    Identifier: "9650",
    Product_Name: "FC-811/2",
    Product_Type: "DEVELOPER",
    Batch_No: "9650",
    Quantity: 800,
    Expiry_Date: "30/12/2024",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "07/Jan/22 12:00 AM (ago)"
  },
  {
    ID: 99,
    Identifier: "8610",
    Product_Name: "FC-921/2",
    Product_Type: "PENETRANT",
    Batch_No: "8610",
    Quantity: 1,
    Expiry_Date: "9/5/2023",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: 98,
    Identifier: "9634",
    Product_Name: "FC-911/2",
    Product_Type: "PENETRANT",
    Batch_No: "9634",
    Quantity: 1,
    Expiry_Date: "30/8/2024",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "07/Jan/22 12:00 AM (ago)"
  },
  {
    ID: 97,
    Identifier: "9632",
    Product_Name: "FC -911",
    Product_Type: "PENETRANT",
    Batch_No: "9632",
    Quantity: 1,
    Expiry_Date: "30/8/2024",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "07/Jan/22 12:00 AM (ago)"
  },
  {
    ID: 96,
    Identifier: "2.30E+36",
    Product_Name: "MAGNAFLUX WA-2B",
    Product_Type: "WATER CONDITIONER",
    Batch_No: "2.30E+36",
    Quantity: 1,
    Expiry_Date: "30/5/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "24/Jun/23 12:00 AM (ago)"
  },
  {
    ID: 95,
    Identifier: "23L96",
    Product_Name: "MAGNAFLUX MG-2410",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "23L96",
    Quantity: 2,
    Expiry_Date: "30/11/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "03/Mar/24 12:00 AM (ago)"
  },
  {
    ID: 94,
    Identifier: "24D20",
    Product_Name: "MAGNAFLUX SKD-S2",
    Product_Type: "DEVELOPER",
    Batch_No: "24D20",
    Quantity: 19200,
    Expiry_Date: "30/4/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "11/Feb/25 12:00 AM (ago)"
  },
  {
    ID: 93,
    Identifier: "23G02",
    Product_Name: "MAGNAFLUX SKC-I",
    Product_Type: "CLEANER",
    Batch_No: "23G02",
    Quantity: 5,
    Expiry_Date: "30/7/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "27/Apr/24 12:00 AM (ago)"
  },
  {
    ID: 92,
    Identifier: "24G39",
    Product_Name: "MAGNAFLUX SKL-SP1",
    Product_Type: "PENETRANT",
    Batch_No: "24G39",
    Quantity: 1,
    Expiry_Date: "30/7/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "09/Mar/25 12:00 AM (ago)"
  },
  {
    ID: 91,
    Identifier: "2.3E+30",
    Product_Name: "MAGNAFLUX SKL-SP1",
    Product_Type: "PENETRANT",
    Batch_No: "2.30E+30",
    Quantity: 1,
    Expiry_Date: "30/5/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "18/Oct/24 12:00 AM (ago)"
  },
  {
    ID: 90,
    Identifier: "19D97",
    Product_Name: "MAGNAFLUX 7HF",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "19D97",
    Quantity: 2400,
    Expiry_Date: "19/4/2024",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "08/May/24 12:00 AM (ago)"
  },
  {
    ID: 89,
    Identifier: "24M22",
    Product_Name: "MAGNAFLUX SKD-S2",
    Product_Type: "DEVELOPER",
    Batch_No: "24M22",
    Quantity: 24,
    Expiry_Date: "31/12/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "09/Mar/25 12:00 AM (ago)"
  },
  {
    ID: 88,
    Identifier: "23J62",
    Product_Name: "MAGNAFLUX MG-2410",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "23J62",
    Quantity: 2,
    Expiry_Date: "30/9/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "21/Oct/23 12:00 AM (ago)"
  },
  {
    ID: 87,
    Identifier: "23F1040",
    Product_Name: "WA-2B",
    Product_Type: "WATER CONDITIONER",
    Batch_No: "23F1040",
    Quantity: 4,
    Expiry_Date: "30/6/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "21/Oct/23 12:00 AM (ago)"
  },
  {
    ID: 86,
    Identifier: "23F65",
    Product_Name: "MAGNAFLUX MG-2410",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "23F65",
    Quantity: 4,
    Expiry_Date: "30/6/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "07/Aug/23 12:00 AM (ago)"
  },
  {
    ID: 85,
    Identifier: "18M93",
    Product_Name: "MAGNAFLUX 7HF",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "18M93",
    Quantity: 1600,
    Expiry_Date: "30/12/2023",
    Branch: "Pune",
    Active: "No",
    Updated_at: "08/May/24 12:00 AM (ago)"
  },
  {
    ID: 84,
    Identifier: "21D071",
    Product_Name: "14A",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "21D071",
    Quantity: 4,
    Expiry_Date: "30/4/2026",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "18/Feb/22 12:00 AM (ago)"
  },
  {
    ID: 83,
    Identifier: "2.30E+25",
    Product_Name: "MG 410",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "2.30E+25",
    Quantity: 4,
    Expiry_Date: "30/5/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "19/Nov/24 12:00 AM (ago)"
  },
  {
    ID: 82,
    Identifier: "2410004",
    Product_Name: "MR CHEMIE MAKE MR76S",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "2410004",
    Quantity: 10,
    Expiry_Date: "1/10/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "29/Nov/24 12:00 AM (ago)"
  },
  {
    ID: 81,
    Identifier: "2501100",
    Product_Name: "MR CHEMIE MAKE MR72",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "2501100",
    Quantity: 10,
    Expiry_Date: "31/1/2030",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "05/Mar/25 12:00 AM (ago)"
  },
  {
    ID: 80,
    Identifier: "2504004",
    Product_Name: "MR CHEMIE MAKE MR 76S",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "2504004",
    Quantity: 10,
    Expiry_Date: "30/4/2030",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "30/May/25 12:00 AM (ago)"
  },
  {
    ID: 79,
    Identifier: "24C27",
    Product_Name: "MAGNAFLUX SKL-SP1",
    Product_Type: "PENETRANT",
    Batch_No: "24C27",
    Quantity: 10,
    Expiry_Date: "30/3/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "15/Feb/25 12:00 AM (ago)"
  },
  {
    ID: 78,
    Identifier: "23D01",
    Product_Name: "MAGNAFLUX SKC-I",
    Product_Type: "CLEANER",
    Batch_No: "23D01",
    Quantity: 1,
    Expiry_Date: "30/4/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "03/Sep/24 12:00 AM (ago)"
  },
  {
    ID: 77,
    Identifier: "25D10",
    Product_Name: "MAGNAFLUX SKD-S2",
    Product_Type: "DEVELOPER",
    Batch_No: "25D10",
    Quantity: 24,
    Expiry_Date: "30/4/2030",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "03/Jun/25 12:00 AM (ago)"
  },
  {
    ID: 76,
    Identifier: "2406002",
    Product_Name: "MR CHEMIE MAKE MR76S",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "2406002",
    Quantity: 100,
    Expiry_Date: "4/6/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "30/Jul/24 12:00 AM (ago)"
  },
  {
    ID: 75,
    Identifier: "2404049",
    Product_Name: "MR CHEMIE MAKE MR 72",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "2404049",
    Quantity: 100,
    Expiry_Date: "19/4/2029",
    Branch: "Pune",
    Active: "No",
    Updated_at: "25/Jun/24 12:00 AM (ago)"
  },
  {
    ID: 74,
    Identifier: "2410057",
    Product_Name: "MR CHEMIE MAKE MR 72",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "2410057",
    Quantity: 100,
    Expiry_Date: "25/10/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "11/Mar/25 12:00 AM (ago)"
  },
  {
    ID: 73,
    Identifier: "2503041",
    Product_Name: "MR CHEMIE MAKE MR76S",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "2503041",
    Quantity: 100,
    Expiry_Date: "30/3/2030",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "30/Apr/25 12:00 AM (ago)"
  },
  {
    ID: 71,
    Identifier: "25D09",
    Product_Name: "MAGNAFLUX SKD-S2",
    Product_Type: "DEVELOPER",
    Batch_No: "25D09",
    Quantity: 7200,
    Expiry_Date: "30/4/2030",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "24/May/24 12:00 AM (ago)"
  },
  {
    ID: 70,
    Identifier: "23L36",
    Product_Name: "MAGNAFLUX SKL-SP1",
    Product_Type: "PENETRANT",
    Batch_No: "23L36",
    Quantity: 900,
    Expiry_Date: "30/11/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "03/Sep/24 12:00 AM (ago)"
  },
  {
    ID: 69,
    Identifier: "24A01",
    Product_Name: "MAGNAFLUX SKC-I",
    Product_Type: "CLEANER",
    Batch_No: "24A01",
    Quantity: 7920,
    Expiry_Date: "31/1/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "21/Feb/24 12:00 AM (ago)"
  },
  {
    ID: 68,
    Identifier: "23L05",
    Product_Name: "MAGNAFLUX SKD-S2",
    Product_Type: "DEVELOPER",
    Batch_No: "23L05",
    Quantity: 7920,
    Expiry_Date: "30/11/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "22/Jun/24 12:00 AM (ago)"
  },
  {
    ID: 67,
    Identifier: "2410068",
    Product_Name: "MR CHEMIE MAKE MR 76S",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "2410068",
    Quantity: 16000,
    Expiry_Date: "28/10/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "30/Nov/24 12:00 AM (ago)"
  },
  {
    ID: 66,
    Identifier: "2301001",
    Product_Name: "MR CHEMIE MAKE MR 76S",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "2301001",
    Quantity: 16000,
    Expiry_Date: "2/1/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "25/Apr/23 12:00 AM (ago)"
  },
  {
    ID: 65,
    Identifier: "2105/F1",
    Product_Name: "MR CHEMIE MAKE MR72",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "2105/F1",
    Quantity: 16000,
    Expiry_Date: "30/6/2025",
    Branch: "Pune",
    Active: "No",
    Updated_at: "25/Jun/24 12:00 AM (ago)"
  },
  {
    ID: 64,
    Identifier: "2503059",
    Product_Name: "MR CHEMIE MAKE MR 76S",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "2503059",
    Quantity: 8000,
    Expiry_Date: "30/3/2030",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "30/Apr/25 12:00 AM (ago)"
  },
  {
    ID: 63,
    Identifier: "2107",
    Product_Name: "MR CHEMIE MAKE MR72",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "2107",
    Quantity: 8000,
    Expiry_Date: "31/1/2026",
    Branch: "Pune",
    Active: "No",
    Updated_at: "25/Jun/24 12:00 AM (ago)"
  },
  {
    ID: 62,
    Identifier: "2504053",
    Product_Name: "MR CHEMIE MAKE MR72",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "2504053",
    Quantity: 200000,
    Expiry_Date: "30/4/2030",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "30/Apr/25 12:00 AM (ago)"
  },
  {
    ID: 61,
    Identifier: "3105",
    Product_Name: "MR 76S",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "3105",
    Quantity: 20000,
    Expiry_Date: "30/7/2025",
    Branch: "Pune",
    Active: "No",
    Updated_at: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: 60,
    Identifier: "22G26",
    Product_Name: "Magnaflux SKL-SP1",
    Product_Type: "PENETRANT",
    Batch_No: "22G26",
    Quantity: 2,
    Expiry_Date: "30/7/2027",
    Branch: "Pune",
    Active: "No",
    Updated_at: "22/Jun/24 12:00 AM (ago)"
  },
  {
    ID: 59,
    Identifier: "23K12",
    Product_Name: "MAGNAFLUX SKD-S2",
    Product_Type: "DEVELOPER",
    Batch_No: "23K12",
    Quantity: 24,
    Expiry_Date: "30/10/2028",
    Branch: "Pune",
    Active: "No",
    Updated_at: "22/Jun/24 12:00 AM (ago)"
  },
  {
    ID: 58,
    Identifier: "24A04",
    Product_Name: "MAGNAFLUX SKD-S2",
    Product_Type: "DEVELOPER",
    Batch_No: "24A04",
    Quantity: 24,
    Expiry_Date: "31/1/2029",
    Branch: "Pune",
    Active: "No",
    Updated_at: "22/Jun/24 12:00 AM (ago)"
  },
  {
    ID: 57,
    Identifier: "24B01",
    Product_Name: "MAGNAFLUX SKC-I",
    Product_Type: "CLEANER",
    Batch_No: "24B01",
    Quantity: 1,
    Expiry_Date: "28/2/2029",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "25/Jun/24 12:00 AM (ago)"
  },
  {
    ID: 56,
    Identifier: "9406",
    Product_Name: "Ferrochem 147A/2",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "9406",
    Quantity: 24,
    Expiry_Date: "31/3/2022",
    Branch: "Pune",
    Active: "No",
    Updated_at: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: 55,
    Identifier: "18M92",
    Product_Name: "MAGNAFLUX WCP2",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "18M92",
    Quantity: 400,
    Expiry_Date: "19/12/2023",
    Branch: "Pune",
    Active: "No",
    Updated_at: "25/Apr/23 12:00 AM (ago)"
  },
  {
    ID: 54,
    Identifier: "17M1003",
    Product_Name: "MAGNAFLUX WCP2",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "17M1003",
    Quantity: 400,
    Expiry_Date: "30/1/2028",
    Branch: "Pune",
    Active: "No",
    Updated_at: "25/Apr/23 12:00 AM (ago)"
  },
  {
    ID: 53,
    Identifier: "18D1008",
    Product_Name: "MAGNAFLUX WCP2",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "18D1008",
    Quantity: 400,
    Expiry_Date: "19/4/2023",
    Branch: "Pune",
    Active: "No",
    Updated_at: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: 52,
    Identifier: "22D94",
    Product_Name: "MAGNAFLUX WCP2",
    Product_Type: "CONTRAST",
    Batch_No: "22D94",
    Quantity: 800,
    Expiry_Date: "30/4/2027",
    Branch: "Pune",
    Active: "No",
    Updated_at: "25/Apr/23 12:00 AM (ago)"
  },
  {
    ID: 51,
    Identifier: "23A1012",
    Product_Name: "MAGNAFLUX 7HF",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "23A1012",
    Quantity: 1200,
    Expiry_Date: "30/1/2028",
    Branch: "Pune",
    Active: "No",
    Updated_at: "12/Mar/23 12:00 AM (ago)"
  },
  {
    ID: 50,
    Identifier: "3405",
    Product_Name: "Ferrochem FC 147/A2",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "3405",
    Quantity: 24,
    Expiry_Date: "30/10/2021",
    Branch: "Pune",
    Active: "No",
    Updated_at: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: 49,
    Identifier: "0",
    Product_Name: "EXAMINATION MEDIUM",
    Product_Type: "--",
    Batch_No: "0",
    Quantity: 0,
    Expiry_Date: "31/1/2023",
    Branch: "Pune",
    Active: "No",
    Updated_at: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: 48,
    Identifier: "21F16",
    Product_Name: "SKL-SP1",
    Product_Type: "PENETRANT",
    Batch_No: "21F16",
    Quantity: 1,
    Expiry_Date: "30/6/2026",
    Branch: "Pune",
    Active: "No",
    Updated_at: "25/Apr/23 12:00 AM (ago)"
  },
  {
    ID: 47,
    Identifier: "23C10",
    Product_Name: "MAGNAFLUX SKD-S2",
    Product_Type: "DEVELOPER",
    Batch_No: "23C10",
    Quantity: 9600,
    Expiry_Date: "30/3/2028",
    Branch: "Pune",
    Active: "No",
    Updated_at: "22/Jun/24 12:00 AM (ago)"
  },
  {
    ID: 46,
    Identifier: "23M14",
    Product_Name: "MAGNAFLUX SKD-S2",
    Product_Type: "DEVELOPER",
    Batch_No: "23M14",
    Quantity: 9600,
    Expiry_Date: "30/12/2028",
    Branch: "Pune",
    Active: "No",
    Updated_at: "22/Jun/24 12:00 AM (ago)"
  },
  {
    ID: 45,
    Identifier: "23J1004",
    Product_Name: "CARRIER OIL",
    Product_Type: "BATH MEDIUM",
    Batch_No: "23J1004",
    Quantity: 1,
    Expiry_Date: "30/9/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: 44,
    Identifier: "9604",
    Product_Name: "FC -911",
    Product_Type: "PENETRANT",
    Batch_No: "9604",
    Quantity: 1,
    Expiry_Date: "30/4/2024",
    Branch: "Pune",
    Active: "No",
    Updated_at: "08/May/24 12:00 AM (ago)"
  },
  {
    ID: 43,
    Identifier: "17D27",
    Product_Name: "WA-2B",
    Product_Type: "WATER CONDITIONER",
    Batch_No: "17D27",
    Quantity: 4,
    Expiry_Date: "30/12/2025",
    Branch: "Pune",
    Active: "No",
    Updated_at: "25/Apr/23 12:00 AM (ago)"
  },
  {
    ID: 42,
    Identifier: "24A19",
    Product_Name: "MAGNAFLUX SKD-S2",
    Product_Type: "DEVELOPER",
    Batch_No: "24A19",
    Quantity: 10080,
    Expiry_Date: "30/1/2029",
    Branch: "Pune",
    Active: "No",
    Updated_at: "22/Jun/24 12:00 AM (ago)"
  },
  {
    ID: 41,
    Identifier: "25A01",
    Product_Name: "MAGNAFLUX SKC-I",
    Product_Type: "CLEANER",
    Batch_No: "25A01",
    Quantity: 5,
    Expiry_Date: "31/1/2029",
    Branch: "Pune",
    Active: "No",
    Updated_at: "24/May/25 12:00 AM (ago)"
  },
  {
    ID: 40,
    Identifier: "9813",
    Product_Name: "Ferrochem 1204/2",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "9813",
    Quantity: 12000,
    Expiry_Date: "21/7/2021",
    Branch: "Pune",
    Active: "No",
    Updated_at: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: 39,
    Identifier: "29420",
    Product_Name: "FERROCHEM FC 147-A/2",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "29420",
    Quantity: 8400,
    Expiry_Date: "31/10/2020",
    Branch: "Pune",
    Active: "No",
    Updated_at: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: 32,
    Identifier: "9403",
    Product_Name: "Ferrochem 131-A/2",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "9403",
    Quantity: 9660,
    Expiry_Date: "31/8/2021",
    Branch: "Pune",
    Active: "No",
    Updated_at: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: 31,
    Identifier: "9823",
    Product_Name: "Ferrochem 1204/2",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "9823",
    Quantity: 23940,
    Expiry_Date: "31/12/2021",
    Branch: "Pune",
    Active: "No",
    Updated_at: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: 30,
    Identifier: "2110",
    Product_Name: "MR CHEMIE MAKE MR72",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "2110",
    Quantity: 24000,
    Expiry_Date: "30/9/2026",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "25/Jun/24 12:00 AM (ago)"
  },
  {
    ID: 29,
    Identifier: "2302034",
    Product_Name: "MR CHEMIE MAKE MR 76S",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "2302034",
    Quantity: 12000,
    Expiry_Date: "13/2/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "25/Apr/23 12:00 AM (ago)"
  },
  {
    ID: 28,
    Identifier: "20M1002",
    Product_Name: "MAGNAFLUX 14AM",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "20M1002",
    Quantity: 800,
    Expiry_Date: "31/12/2025",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "25/Apr/23 12:00 AM (ago)"
  },
  {
    ID: 27,
    Identifier: "22J98",
    Product_Name: "MAGNAFLUX 14AM",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "22J98",
    Quantity: 400,
    Expiry_Date: "30/9/2027",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "25/Apr/23 12:00 AM (ago)"
  },
  {
    ID: 26,
    Identifier: "22G94",
    Product_Name: "MAGNAFLUX 14AM",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "22G94",
    Quantity: 1200,
    Expiry_Date: "30/7/2027",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "25/Apr/23 12:00 AM (ago)"
  },
  {
    ID: 25,
    Identifier: "23J1035",
    Product_Name: "Magnaflux SKL-SP2",
    Product_Type: "PENETRANT",
    Batch_No: "23J1035",
    Quantity: 4500,
    Expiry_Date: "30/9/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "11/Feb/25 12:00 AM (ago)"
  },
  {
    ID: 24,
    Identifier: "17L99",
    Product_Name: "Magnaflux SKC-S",
    Product_Type: "CLEANER",
    Batch_No: "17L99",
    Quantity: 2100,
    Expiry_Date: "30/11/2022",
    Branch: "Pune",
    Active: "No",
    Updated_at: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: 23,
    Identifier: "19H20",
    Product_Name: "Magnaflux 410",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "19H20",
    Quantity: 1814,
    Expiry_Date: "31/8/2023",
    Branch: "Pune",
    Active: "No",
    Updated_at: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: 22,
    Identifier: "23A1004",
    Product_Name: "Magnaflux WCP2",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "23A1004",
    Quantity: 7590,
    Expiry_Date: "30/1/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "25/Apr/23 12:00 AM (ago)"
  },
  {
    ID: 21,
    Identifier: "23H1026",
    Product_Name: "MAGNAFLUX 14AM",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "23H1026",
    Quantity: 2700,
    Expiry_Date: "30/8/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "13/Feb/24 12:00 AM (ago)"
  },
  {
    ID: 20,
    Identifier: "23K61",
    Product_Name: "MAGNAFLUX MG-2410",
    Product_Type: "EXAMINATION MEDIUM",
    Batch_No: "23K61",
    Quantity: 4,
    Expiry_Date: "30/10/2028",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "10/Jan/24 12:00 AM (ago)"
  },
  {
    ID: 19,
    Identifier: "2.20E+39",
    Product_Name: "Magnaflux WA-2B",
    Product_Type: "WATER CONDITIONER",
    Batch_No: "2.20E+39",
    Quantity: 3,
    Expiry_Date: "30/5/2027",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "03/Apr/23 12:00 AM (ago)"
  },
  {
    ID: 18,
    Identifier: "21H56",
    Product_Name: "MAGNAFLUX WCP2",
    Product_Type: "CONTRAST PAINT",
    Batch_No: "21H56",
    Quantity: 400,
    Expiry_Date: "31/8/2026",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "25/Apr/23 12:00 AM (ago)"
  },
  {
    ID: 17,
    Identifier: "25A01",
    Product_Name: "MAGNAFLUX SKC-I",
    Product_Type: "CLEANER",
    Batch_No: "25A01",
    Quantity: 2520,
    Expiry_Date: "30/1/2030",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "24/May/25 12:00 AM (ago)"
  },
  {
    ID: 16,
    Identifier: "22M1010",
    Product_Name: "Magnaflux ZL-27A",
    Product_Type: "PENETRANT",
    Batch_No: "22M1010",
    Quantity: 600,
    Expiry_Date: "31/12/2027",
    Branch: "Pune",
    Active: "Yes",
    Updated_at: "25/Apr/23 12:00 AM (ago)"
  },
  {
    ID: 15,
    Identifier: "18B20",
    Product_Name: "Magnaflux SKL-WP",
    Product_Type: "PENETRANT",
    Batch_No: "18B20",
    Quantity: 600,
    Expiry_Date: "28/2/2023",
    Branch: "Pune",
    Active: "No",
    Updated_at: "12/Dec/23 12:00 AM (ago)"
  },
  {
    ID: 14,
    Identifier: "22K25",
    Product_Name: "Magnaflux SKL-SP1",
    Product_Type: "PENETRANT",
    Batch_No: "22K25",
    Quantity: 900,
    Expiry_Date: "30/10/2027",
    Branch: "Pune",
    Active: "No",
    Updated_at: "25/Apr/23 12:00 AM (ago)"
  },
  {
    ID: 13,
    Identifier: "23D16",
    Product_Name: "MAGNAFLUX SKD-S2",
    Product_Type: "DEVELOPER",
    Batch_No: "23D16",
    Quantity: 15840,
    Expiry_Date: "26/4/2028",
    Branch: "Pune",
    Active: "No",
    Updated_at: "22/Jun/24 12:00 AM (ago)"
  }
];

const BATH_MEDIUM = [
  {
    id: 118,
    value: "By Spraying",
    status: "Active",
    description: "Used in MT Bench Type"
  }
];

const CURRENT_TYPE = [
  {
    id: 136,
    value: "AC",
    status: "Active",
    description: "Used in MT Bench Type"
  },
  {
    id: 135,
    value: "DC",
    status: "Active",
    description: "Used in MT Bench Type"
  },
  {
    id: 134,
    value: "HWDC",
    status: "Active",
    description: "Used in MT Bench Type"
  }
];

const DEVELOPER_APPLICATION = [
  {
    id: 117,
    value: "By Spraying",
    status: "Active",
    description: "Used in PT-V and PT-F templates"
  },
  {
    id: 116,
    value: "By Brushing",
    status: "Active",
    description: "Used in PT-V and PT-F templates"
  }
];

const FIELD_ADEQUACY = [
  {
    id: 133,
    value: "Not Applicable for Yoke",
    status: "Active",
    description: "Used in MT-B and MT-Y templates"
  },
  {
    id: 132,
    value: "Shim and known Discontinuity Sample",
    status: "Active",
    description: "Used in MT-B and MT-Y templates"
  },
  {
    id: 131,
    value: "Pie Gauge",
    status: "Active",
    description: "Used in MT-B and MT-Y templates"
  },
  {
    id: 130,
    value: "Shim",
    status: "Active",
    description: "Used in MT-B and MT-Y templates"
  },
  {
    id: 129,
    value: "Pie Gauge and shim (230)",
    status: "Active",
    description: "Used in MT-B and MT-Y templates"
  }
];

const MAGNETISATION_METHOD = [
  {
    id: 128,
    value: "Circular Magnetisation 2 Directions",
    status: "Active",
    description: "Used in MT-B and MT-Y templates"
  },
  {
    id: 127,
    value: "Circular Magnetisation",
    status: "Active",
    description: "Used in MT-B and MT-Y templates"
  },
  {
    id: 126,
    value: "Longitudinal Magnetisation + Circular",
    status: "Active",
    description: "Used in MT-B and MT-Y templates"
  },
  {
    id: 125,
    value: "Longitudinal Magnetisation",
    status: "Active",
    description: "Used in MT-B and MT-Y templates"
  },
  {
    id: 124,
    value: "Longitudinal Magnetisation in 2 directions",
    status: "Active",
    description: "Used in MT-B and MT-Y templates"
  }
];

const OUTCOME = [
  {
    id: 141,
    value: "Reject",
    status: "Active",
    description: "Used in Observation Report"
  },
  {
    id: 140,
    value: "Accept",
    status: "Active",
    description: "Used in Observation Report"
  }
];

const PENETRANT_APPLICATION = [
  {
    id: 115,
    value: "By Dipping",
    status: "Active",
    description: "Used in PT-V and PT-F templates"
  },
  {
    id: 114,
    value: "By Spraying",
    status: "Active",
    description: "Used in PT-V and PT-F templates"
  },
  {
    id: 113,
    value: "By Brushing",
    status: "Active",
    description: "Used in PT-V and PT-F templates"
  }
];

const SAMPLE = [
  {
    id: 142,
    value: "Item/Part/Component",
    status: "Active",
    description: "Used in Observation Report"
  }
];

const CURRENT_TYPE_POLE_SPACING = [
  {
    id: 123,
    value: "DC Type (At maximum Pole Spacing)",
    status: "Active",
    description: "Used in MT Yoke"
  },
  {
    id: 122,
    value: "AC Type (At maximum Pole Spacing)",
    status: "Active",
    description: "Used in MT Yoke"
  },
  {
    id: 121,
    value: "DC Type 4 to 6 inches",
    status: "Active",
    description: "Used in MT Yoke"
  },
  {
    id: 120,
    value: "DC Type 2 to 4 inches",
    status: "Active",
    description: "Used in MT Yoke"
  },
  {
    id: 119,
    value: "AC Type 4 to 6 inches",
    status: "Active",
    description: "Used in MT Yoke"
  }
];

const DRYING_TIME_AFTER_PRECLEANING = [
  {
    id: 330,
    value: "2min",
    status: "Active",
    description: "Used in PT-V and PT-F templates"
  },
  {
    id: 329,
    value: "5min",
    status: "Active",
    description: "Used in PT-V and PT-F templates"
  },
  {
    id: 328,
    value: "10min",
    status: "Active",
    description: "Used in PT-V and PT-F templates"
  },
  {
    id: 336,
    value: "20mins",
    status: "Active",
    description: "Used in PT-V and PT-F templates"
  },
  {
    id: "337",
    value: "100 mins",
    status: "Active",
    description: "Used in PT-V"
  }
];

const DWELL_TIME = [
  {
    id: 334,
    value: "10min",
    status: "Active",
    description: "Used in PT-V and PT-F templates"
  },
  {
    id: 333,
    value: "15min",
    status: "Active",
    description: "Used in PT-V and PT-F templates"
  },
  {
    id: 332,
    value: "20min",
    status: "Active",
    description: "Used in PT-V and PT-F templates"
  },
  {
    id: 331,
    value: "30min",
    status: "Active",
    description: "Used in PT-V and PT-F templates"
  }
];

const DRYING_TIME_BEFORE_DEVELOPER = [
  {
    id: 337,
    value: "2min",
    status: "Active",
    description: "Used in PT-V and PT-F templates"
  },
  {
    id: 336,
    value: "5min",
    status: "Active",
    description: "Used in PT-V and PT-F templates"
  },
  {
    id: 335,
    value: "10min",
    status: "Active",
    description: "Used in PT-V and PT-F templates"
  },
  {
    id: 350,
    value: "1hour",
    status: "Active",
    description: "Used in PT-V and PT-F templates"
  }
];

const DEVELOPMENT_AND_INTERPRETATION_TIME = [
  {
    id: 341,
    value: "10min",
    status: "Active",
    description: "Used in PT-V and PT-F templates"
  },
  {
    id: 340,
    value: "15min",
    status: "Active",
    description: "Used in PT-V and PT-F templates"
  },
  {
    id: 339,
    value: "20min",
    status: "Active",
    description: "Used in PT-V and PT-F templates"
  },
  {
    id: 338,
    value: "30min",
    status: "Active",
    description: "Used in PT-V and PT-F templates"
  }
];

const RT_RADIATION_SOURCES = [
  {
    id: 1,
    source_type: "X-Ray",
    source_code: "XRAY",
    serial_no: "2001",
    equipment_name: "X-Ray Machine",
    display_label: "X-Ray 1 2001 X-Ray Machine",
    half_life_value: null,
    half_life_unit: null,
    initial_strength_curies: null,
    source_diameter_mm: null,
    source_height_mm: null,
    purchased_refilled_date: null,
    status: "Active",
    description: "X-Ray radiation source - no isotope decay"
  },
  {
    id: 2,
    source_type: "Gamma-Ray Ir-192",
    source_code: "IR192",
    serial_no: "1001",
    equipment_name: "Camera",
    display_label: "Gamma-Ray Ir-192 2 1001 Camera",
    half_life_value: 74,
    half_life_unit: "Days",
    initial_strength_curies: 60,
    source_diameter_mm: 2.7,
    source_height_mm: 3.2,
    purchased_refilled_date: "08/04/2026",
    status: "Active",
    description: "Iridium-192 gamma ray source"
  },
  {
    id: 3,
    source_type: "Gamma-Ray Co-60",
    source_code: "CO60",
    serial_no: "1002",
    equipment_name: "Camera",
    display_label: "Gamma-Ray Co-60 3 1002 Camera",
    half_life_value: 5.3,
    half_life_unit: "Years",
    initial_strength_curies: 60,
    source_diameter_mm: 2.7,
    source_height_mm: 3.2,
    purchased_refilled_date: "09/04/2026",
    status: "Active",
    description: "Cobalt-60 gamma ray source"
  },
  {
    id: 4,
    source_type: "Gamma-Ray Se-75",
    source_code: "SE75",
    serial_no: "1003",
    equipment_name: "Camera",
    display_label: "Gamma-Ray Se-75 4 1003 Camera",
    half_life_value: 120,
    half_life_unit: "Days",
    initial_strength_curies: 60,
    source_diameter_mm: 2.7,
    source_height_mm: 3.2,
    purchased_refilled_date: "09/04/2026",
    status: "Active",
    description: "Selenium-75 gamma ray source"
  }
];

export {
    SERVICES,
    STAGE_SURFACE_CONDITIONS,
    DEVICES_LIST,
    CONSUMABLES,
    BATH_MEDIUM,
    CURRENT_TYPE,
    DEVELOPER_APPLICATION,
    FIELD_ADEQUACY,
    MAGNETISATION_METHOD,
    OUTCOME,
    PENETRANT_APPLICATION,
    SAMPLE,
    CURRENT_TYPE_POLE_SPACING,
    DRYING_TIME_AFTER_PRECLEANING,
    DWELL_TIME,
    DRYING_TIME_BEFORE_DEVELOPER,
    DEVELOPMENT_AND_INTERPRETATION_TIME,
    RT_RADIATION_SOURCES
}